/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AddAdditionItemReqDTO */
export interface AddAdditionItemReqDTO {
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  ingredientStatus?: number;
  /** @format int32 */
  ingredientsCount?: number;
  ingredientsSku?: string;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
}

/** AddAdditionReqDTO */
export interface AddAdditionReqDTO {
  /** 配置项集合 */
  additionList?: AddAdditionItemReqDTO[];
  /** 国际发货配置 */
  addressAddition?: ShopAddressAdditionReqDTO;
  /** 品类id集合 */
  categoryCodeList?: number[];
  /**
   * 无附加项标志 0 需要附加项 1 不需要附加项
   * @format int32
   */
  noAdditionalFlag?: number;
  /** 附加项适用仓库的仓库编码 */
  warehouseCode?: string;
}

/** AddBannerReqDTO */
export interface AddBannerReqDTO {
  /**
   * 适用用户会员模板id
   * @format int64
   */
  bannerApplicableTemplateId?: number;
  /** 指定用户的id，以英文逗号分隔 */
  bannerDesignatedUserId?: string;
  /** banner图片url-H5页面 */
  bannerImgMobileUrl?: string;
  /** banner图片url */
  bannerImgUrl?: string;
  /** banner图片点击跳转链接 */
  bannerJumpLink?: string;
  /** 名称 */
  bannerName?: string;
  /**
   * 开启/关闭状态，0：开启，1：关闭
   * @format int32
   */
  bannerStatus?: number;
  /**
   * banner类型，0：我的频道；1：透明购，2：市场购,3:青蛙文章
   * @format int32
   */
  bannerType?: number;
  /**
   * banner有效期结束时间
   * @format date-time
   */
  endTime?: string;
  /** @format int64 */
  mallCategoryId?: number;
  /**
   * banner有效期开始时间
   * @format date-time
   */
  startTime?: string;
  /** 站点code */
  stationCode?: string;
  /**
   * 系统来源，1:d2c,2:b2b
   * @format int32
   */
  systemSource?: number;
}

/** AddClearanceAddressReqDTO */
export interface AddClearanceAddressReqDTO {
  address?: string;
  addressEn?: string;
  area?: string;
  areaEn?: string;
  city?: string;
  cityEn?: string;
  /** 市名称 */
  cityName?: string;
  /** 通关码 */
  clearanceCode?: string;
  /** @format int32 */
  clearanceType?: number;
  companyCode?: string;
  companyName?: string;
  companyNameEn?: string;
  countryCode?: string;
  /** 国家名称 */
  countryName?: string;
  /** @format int32 */
  defaultAddress?: number;
  email?: string;
  /** 清关地址出口国家，默认中国 CN 韩国 KR */
  exportCountry?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家id */
  nationId?: string;
  phone?: string;
  postalCode?: string;
  /** 省名称 */
  provinceName?: string;
  receiveName?: string;
  receiveNameEn?: string;
}

/** AddCustomerShopReqDTO */
export interface AddCustomerShopReqDTO {
  clientId?: string;
  clientSecret?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  customerShopLogo?: string;
  customerShopName?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  customerShopUrl?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** 站点code */
  stationCode?: string;
  /** @format int32 */
  supportChoice?: number;
  /** @format int32 */
  systemSource?: number;
  wareCode?: string;
}

/** AddDepartmentReqDTO */
export interface AddDepartmentReqDTO {
  directorId?: string;
  id?: string;
  name?: string;
  parentId?: string;
  /** @format int32 */
  sort?: number;
  status?: string;
  treePath?: string;
}

/** AddFrogArticleReqDTO */
export interface AddFrogArticleReqDTO {
  frogArticleAuthor?: string;
  frogArticleContent?: string;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  frogArticleImgUrl?: string;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型Id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** @format int64 */
  frogArticleViewCount?: number;
  /**
   * 未登录限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noLoginRestriction?: number;
  /**
   * 未入会限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noMembershipRestriction?: number;
  /** SEO 描述 */
  seoDescription?: string;
  /** @format int32 */
  showMall?: number;
  stationCode?: string;
}

/** AddIntendedCustomerInfoReqDTO */
export interface AddIntendedCustomerInfoReqDTO {
  /** 邮箱 */
  email: string;
  /** 姓名 */
  name: string;
  /** 手机号 */
  phone?: string;
  /** 站点 */
  stationCode: string;
}

/** AddManageUserReqDTO */
export interface AddManageUserReqDTO {
  avatar?: string;
  deptId?: string;
  /** @format int32 */
  directoried?: number;
  email?: string;
  /** @format int32 */
  gender?: number;
  mobile?: string;
  nickname?: string;
  password?: string;
  relationDd?: string;
  relationDdDeptId?: string;
  relationDdDeptName?: string;
  relationDdUserId?: string;
  relationDdUserName?: string;
  roleIds?: string[];
  /** @format int32 */
  status?: number;
  username?: string;
  wareCode?: string[];
}

/** AddMenuReqDTO */
export interface AddMenuReqDTO {
  backEndPath?: string;
  btnPerm?: string;
  code?: string;
  icon?: string;
  name?: string;
  parentId?: string;
  redirect?: string;
  routeName?: string;
  routePath?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  type?: number;
  /** @format int32 */
  visible?: number;
}

/** AddRoleReqDTO */
export interface AddRoleReqDTO {
  deptId?: string;
  name?: string;
  remark?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
}

/** AddShippingAddressReqDTO */
export interface AddShippingAddressReqDTO {
  address?: string;
  addressEn?: string;
  area?: string;
  areaEn?: string;
  city?: string;
  cityEn?: string;
  /** 市名称 */
  cityName?: string;
  countryCode?: string;
  /** 国家名称 */
  countryName?: string;
  /** @format int32 */
  defaultAddress?: number;
  email?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家id */
  nationId?: string;
  phone?: string;
  postalCode?: string;
  /** 省名称 */
  provinceName?: string;
  receiveName?: string;
  receiveNameEn?: string;
}

/** AddShopTaxDeductionAccountDTO */
export interface AddShopTaxDeductionAccountDTO {
  /** 分行代码 */
  branchCode?: string;
  /**
   * 客户店铺ID
   * @format int64
   */
  customerShopId?: number;
  /** 金融机构代码 */
  financialInstitutionCode?: string;
  /** 进口商标准代码 */
  importerCode?: string;
  /**
   * 是否是默认设置 0 否 1 是
   * @format int32
   */
  isDefault?: number;
  /** 扣税账号 */
  taxDeductionAccount?: string;
}

/** AddSubCustomerReqDTO */
export interface AddSubCustomerReqDTO {
  chatWorkId?: string;
  countryCode?: string;
  customerEmail?: string;
  customerMobile?: string;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  gender?: number;
  loginName?: string;
  password?: string;
  skype?: string;
  verificationCode?: string;
}

/** AddUserReqDTO */
export interface AddUserReqDTO {
  customerIds?: number[];
  userId?: string;
  userName?: string;
}

/** AddUserRoleReqDTO */
export interface AddUserRoleReqDTO {
  roleId?: string;
  userId?: string;
}

/** AdditionItemRespDTO */
export interface AdditionItemRespDTO {
  /** @format int32 */
  additionCode?: number;
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  additionId?: number;
  additionName?: string;
  additionNameJp?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  imageUrl?: string;
  /** @format int32 */
  ingredientStatus?: number;
  /** @format int32 */
  ingredientsCount?: number;
  ingredientsSku?: string;
  /** @format int64 */
  shopAdditionId?: number;
  /** @format int64 */
  shopAdditionItemId?: number;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** AdditionMappingDTO */
export interface AdditionMappingDTO {
  /** 更换仓库后的附加项列表 */
  newAdditionList?: AdditionPojo[];
  /** 旧的附加项列表 */
  oldAdditionList?: AdditionPojo[];
}

/** AdditionPojo */
export interface AdditionPojo {
  /** @format int32 */
  additionCode?: number;
  /** @format int64 */
  additionConfigId?: number;
  /** @format int64 */
  additionId?: number;
  additionName?: string;
  /** @format int32 */
  productType?: number;
}

/** AdditionTemplateItemRespDTO */
export interface AdditionTemplateItemRespDTO {
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  additionId?: number;
  additionName?: string;
  additionNameJp?: string;
  /** @format int32 */
  additionTemplateId?: number;
  /** @format int64 */
  additionTemplateItemId?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  imageUrl?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** AdditionTemplateRespDTO */
export interface AdditionTemplateRespDTO {
  /** @format int32 */
  additionTemplateId?: number;
  additionTemplateImg?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  items?: AdditionTemplateItemRespDTO[];
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** AppShopRespDTO */
export interface AppShopRespDTO {
  /** @format int64 */
  abnormalOrderCount?: number;
  /** @format int64 */
  apiOrderCount?: number;
  availableAmount?: number;
  /** @format int64 */
  canDeliveryOrderCount?: number;
  /** @format int32 */
  canceledCount?: number;
  /** @format int64 */
  completeOrderCount?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  /** @format int64 */
  dealOrderCount?: number;
  /** @format int32 */
  deletedFlag?: number;
  /** @format int32 */
  noBindAmazonSkuCount?: number;
  /** @format int32 */
  noConfirmReplenishPlanCount?: number;
  orderAmount?: number;
  /** @format int32 */
  orderCount?: number;
  /** @format int64 */
  partDeliveryOrderCount?: number;
  /** @format int32 */
  pendingInventoryCount?: number;
  /** @format int32 */
  supportChoice?: number;
  /** @format int32 */
  systemSource?: number;
  /** @format int32 */
  yesterdayOrderQuantity?: number;
  /** @format int32 */
  yesterdayShipmentsQuantity?: number;
}

/** AttachmentInfo */
export interface AttachmentInfo {
  attachmentName?: string;
  attachmentUrl?: string;
}

/** BaseQueryPage */
export interface BaseQueryPage {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
}

/** BaseResponse */
export interface BaseResponse {
  code?: string;
  msg?: string;
  success?: boolean;
}

/** BatchModifyPurchaseReqDTO */
export interface BatchModifyPurchaseReqDTO {
  /** @format int32 */
  modifyType?: number;
  records?: ModifyPurchaseRecordDTO[];
  userId?: string;
  userName?: string;
}

/** BatchRemoveUserReqDTO */
export interface BatchRemoveUserReqDTO {
  customerIds?: number[];
}

/** BindThirdReqDTO */
export interface BindThirdReqDTO {
  /**
   * 0-直采 1-代采
   * @format int32
   */
  buType?: number;
  /** 渠道 */
  channel?: string;
  /** chartWorkId */
  chatWorkId?: string;
  /** 公司名称 */
  corpName?: string;
  /** 区号 */
  countryCode?: string;
  /** 国家code */
  countryPlaceCode?: string;
  /** 邮箱地址 */
  customerEmail?: string;
  /**
   * 用户id
   * @format int64
   */
  customerId?: number;
  /** 客户手机号 */
  customerMobile?: string;
  /** 联系人姓名 */
  customerName?: string;
  /**
   * 客户状态：1-正常；2-停用
   * @format int32
   * @example 1
   */
  customerStatus?: number;
  /** 拓展参数，埋点信息等 */
  ext?: Record<string, object>;
  /**
   * 性别：1-男；2-女；3-未知
   * @format int32
   * @example 1
   */
  gender?: number;
  /**
   * 是否初始化店铺 0：否，1：是
   * @format int32
   */
  initShopFlag?: number;
  /** 三方邀请码 */
  invitationCode?: string;
  /**
   * 邀请平台:0-内部,1-aucfan
   * @format int32
   */
  invitationPlatform?: number;
  /** 语言代码 */
  langcode?: string;
  /** 登录名 */
  loginName?: string;
  /** 登录密码 */
  password?: string;
  /**
   * 平台类型:1网页端,2APP
   * @format int32
   */
  platformType?: number;
  /** 三方推荐邮箱 */
  recommendationEmail?: string;
  /** skype */
  skype?: string;
  /** spm */
  spm?: string;
  /** 站点code */
  stationCode?: string;
  /**
   * 隐私协议id
   * @format int64
   */
  termId?: number;
  /** 三方平台用户账号,可以理解为唯一标识 */
  thirdCustomerId?: string;
  /** 三方平台用户名称 */
  thirdCustomerName?: string;
  /** 三方平台用户邮箱 */
  thirdEmail?: string;
  /** 三方平台标识 */
  thirdPlatform?: string;
  /** 时区 */
  utcTimeZone?: string;
  /** 验证码 */
  verificationCode?: string;
}

/** BizResponse */
export interface BizResponse {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/** CategoryAdditionRespDTO */
export interface CategoryAdditionRespDTO {
  /** @format int64 */
  categoryCateId?: number;
  categoryCateName?: string;
  categoryCateNameEn?: string;
  categoryCateNameJp?: string;
  categoryCateNameKr?: string;
  /** @format int32 */
  categoryLevel?: number;
  /** @format int64 */
  categoryParentId?: number;
  /** @format int32 */
  categoryStaus?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  shopAdditionConfigCategoryId?: number;
  /** @format int64 */
  shopAdditionId?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** CategoryCodeRespDTO */
export interface CategoryCodeRespDTO {
  levelOneCategoryCode?: string;
  levelTwoCategoryCodes?: string[];
}

/** ChangeEmailReqDTO */
export interface ChangeEmailReqDTO {
  /** @format int64 */
  customerId?: number;
  newCustomerEmail?: string;
  password?: string;
  stationCode?: string;
  verificationCode?: string;
}

/** ChangeMobileReqDTO */
export interface ChangeMobileReqDTO {
  /** 区号 */
  countryCode?: string;
  /** 新手机号 */
  newMobile?: string;
  /** 密码 */
  password?: string;
  /** 验证码 */
  verificationCode?: string;
}

/**
 * ChangeUrlWhiteUserReqDTO
 * 换源白名单列表
 */
export interface ChangeUrlWhiteUserReqDTO {
  /**
   * 复购单经理id
   * @format int64
   */
  managerId?: number;
  /**
   * 营销经理id
   * @format int64
   */
  marketingManagerId?: number;
  /**
   * 会员等级id
   * @format int64
   */
  membershipId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /**
   * 客户总监id
   * @format int64
   */
  supervisionManagerId?: number;
  /**
   * 系统来源: 1-D2C; 2-B2B
   * @format int32
   */
  systemSource?: number;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
  /** 仓库编码 */
  wareCode?: string;
}

/**
 * ChangeUrlWhiteUserRespDTO
 * 换源白名单列表
 */
export interface ChangeUrlWhiteUserRespDTO {
  /**
   * 添加时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 用户id
   * @format int64
   */
  customerId?: number;
  /**
   * 客户经理id
   * @format int64
   */
  managerId?: number;
  /** 客户经理名称 */
  managerName?: string;
  /**
   * 营销经理id
   * @format int64
   */
  marketingManagerId?: number;
  /** 营销经理名称 */
  marketingManagerName?: string;
  /** 会员信息 */
  membership?: CustomerMembership;
  /** 国家代码 */
  nationCode?: string;
  /** 站点代码 */
  stationCode?: string;
  /**
   * 客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 客户总监id
   * @format int64
   */
  supervisionManagerId?: number;
  /** 客户总监名称 */
  supervisionManagerName?: string;
  /**
   * 系统来源: 1-D2C; 2-B2B
   * @format int32
   */
  systemSource?: number;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
  /** 添加人 */
  userName?: string;
  /** 仓库编码 */
  wareCode?: string;
  /** 仓库名称 */
  wareName?: string;
}

/** ChangeWarehouseTaskReqDTO */
export interface ChangeWarehouseTaskReqDTO {
  additionSnapshot?: AdditionMappingDTO;
  /** @format int64 */
  customerShopId?: number;
  oldWarehouseCode?: string;
  /** 物流配置列表 */
  shopShipList?: ShopShipMappingDTO[];
  warehouseCode?: string;
}

/** CheckEmailReqDTO */
export interface CheckEmailReqDTO {
  /**
   * 业务类型 0直采 1代采
   * @format int32
   */
  buType?: number;
  countryPlaceCode?: string;
  customerEmail?: string;
  langcode?: string;
  stationCode?: string;
}

/** ConcatReqDTO */
export interface ConcatReqDTO {
  body?: string;
}

/** CustomShopDetailRespDTO */
export interface CustomShopDetailRespDTO {
  /** @format int32 */
  activeSubAccountFlag?: number;
  /** @format date-time */
  changeShopTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  mainCustomerName?: string;
  stationCode?: string;
  /** @format int32 */
  supportChoice?: number;
  /** @format int32 */
  virtualFlag?: number;
  wareCode?: string;
  wareName?: string;
}

/** Customer */
export interface Customer {
  /** @format int32 */
  accountType?: number;
  /**
   * 业务类型 0 直采 1 代采
   * @format int32
   */
  buType?: number;
  chatWorkId?: string;
  corpName?: string;
  countryCode?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  defaultLogin?: number;
  /** @format int32 */
  defectiveProductRiskFlagMain?: number;
  defectiveProductRiskFlagMainRemark?: string;
  /** @format int32 */
  defectiveProductRiskFlagSub?: number;
  defectiveProductRiskFlagSubRemark?: string;
  /** @format int32 */
  gender?: number;
  googleUrl?: string;
  headerUrl?: string;
  /** @format int32 */
  internalFlag?: number;
  langcode?: string;
  /** @format date-time */
  lastLoginTime?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int64 */
  managerId?: number;
  /** @format int64 */
  marketingManagerId?: number;
  /** @format int32 */
  memberChangeFlag?: number;
  nationCode?: string;
  /** @format int64 */
  oldCustomerStatus?: number;
  outsideLink?: string;
  password?: string;
  /** @format int32 */
  passwordChangeFlag?: number;
  /**
   * 建议补全手机号是否已读:0-没有,1-已读
   * @format int32
   */
  phoneCompletedFlag?: number;
  /** @format int32 */
  platformType?: number;
  salt?: string;
  skype?: string;
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int64 */
  supervisionManagerId?: number;
  /** @format int32 */
  systemSource?: number;
  timeZone?: string;
  unificationCustomerFullName?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
  /** @format int32 */
  zeroChangeFlag?: number;
}

/** CustomerCanTransformRespDTO */
export interface CustomerCanTransformRespDTO {
  /**
   * 账号类型：1-主账号；2-子账号；
   * @format int32
   */
  accountType?: number;
  /**
   * 用户id
   * @format int64
   */
  customerId?: number;
  /** 用户名 */
  customerName?: string;
  /**
   * 店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 店铺名称 */
  customerShopName?: string;
  /**
   * 客户店铺平台: 0-其他; 1-Base; 2-Shopify; 3-Stores; 4-Amazon
   * @format int32
   */
  customerShopPlatform?: number;
  /** 登录名 */
  loginName?: string;
  /**
   * 来源，1- d2c ,2- b2b
   * @format int32
   */
  systemSource?: number;
}

/** CustomerConfigRespDTO */
export interface CustomerConfigRespDTO {
  configCode?: string;
  configName?: string;
  configValue?: string;
}

/** CustomerCount */
export interface CustomerCount {
  platformType?: string;
}

/** CustomerDetailManagerRespDTO */
export interface CustomerDetailManagerRespDTO {
  /** @format int64 */
  account?: number;
  /** @format int32 */
  accountType?: number;
  automaticRenewalStatusInfo?: string;
  automaticToggleStaus?: boolean;
  availableAmount?: number;
  /**
   * 业务类型 0直采 1代采
   * @format int32
   */
  buType?: number;
  chatWorkId?: string;
  corpName?: string;
  /** 国家 */
  country?: string;
  countryCode?: string;
  /** @format date-time */
  createTime?: string;
  customerDetailRespDTOS?: CustomerDetailRespDTO[];
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopList?: CustomerShopRespDTO[];
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  defaultLogin?: number;
  /** @format int32 */
  deleteStatus?: number;
  /** @format int32 */
  gender?: number;
  headerUrl?: string;
  /** @format int32 */
  internalFlag?: number;
  /** 语言代码:ja-日语,en-英语,th-泰语,ko-韩语 */
  langcode?: string;
  /** @format date-time */
  lastLoginTime?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int32 */
  manageStatus?: number;
  /** @format int64 */
  managerId?: number;
  managerName?: string;
  /** @format int64 */
  marketingManagerId?: number;
  marketingManagerName?: string;
  /** 客户与会员身份关联数据 */
  membership?: CustomerMembership;
  membershipPreChargeOrder?: string;
  nationCode?: string;
  outsideLink?: string;
  /**
   * 业务类型 0直采 1代采
   * @format int32
   */
  platformType?: number;
  shopAddressAdditionList?: ShopAddressAdditionRespDTO[];
  shopPurchaseRespDTO?: ShopPurchaseRespDTO;
  skype?: string;
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int64 */
  supervisionManagerId?: number;
  supervisionManagerName?: string;
  /** @format int32 */
  systemSource?: number;
  /** @format int32 */
  tagType?: number;
  tags?: number[];
  thirdBind?: string[];
  timeZone?: string;
  unificationCustomerFullName?: string;
  /** @format date-time */
  updateTime?: string;
  wareCode?: string;
  wareName?: string;
  warehouseList?: WarehousePojo[];
}

/** CustomerDetailRespDTO */
export interface CustomerDetailRespDTO {
  /**
   * 账号类型：1-主账号；2-子账号；
   * @format int32
   */
  accountType?: number;
  /** 默认店铺余额 */
  availableAmount?: number;
  /** chartWorkId */
  chatWorkId?: string;
  corpName?: string;
  /** 国家代码 */
  countryCode?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** 邮箱地址 */
  customerEmail?: string;
  customerEmailChecked?: boolean;
  /**
   * 用户id
   * @format int64
   */
  customerId?: number;
  /** 客户手机号 */
  customerMobile?: string;
  /** 用户名 */
  customerName?: string;
  /**
   * 用户店铺表id
   * @format int64
   */
  customerShopId?: number;
  /** 客户店铺列表 */
  customerShopList?: CustomerShopRespDTO[];
  /**
   * 客户状态：1-正常；2-停用
   * @format int32
   */
  customerStatus?: number;
  /**
   * 是否默认登录：0-否；1-是
   * @format int32
   */
  defaultLogin?: number;
  ext?: string;
  /**
   * 性别：1-男；2-女；3-未知
   * @format int32
   */
  gender?: number;
  /** 谷歌表 */
  googleUrl?: string;
  hasKoreaWallet?: boolean;
  /** 头像 */
  headerUrl?: string;
  initialPassword?: boolean;
  /**
   * 内部用户标志：0-否；1-是
   * @format int32
   */
  internalFlag?: number;
  langcode?: string;
  /**
   * 上次登录时间
   * @format date-time
   */
  lastLoginTime?: string;
  /** 登录名 */
  loginName?: string;
  /**
   * 主账号id
   * @format int64
   */
  mainCustomerId?: number;
  /**
   * 是否有分配业务员权限:1-有,0-没有
   * @format int32
   */
  manageStatus?: number;
  /**
   * 复购单经理id
   * @format int64
   */
  managerId?: number;
  /** 复购单经理名称 */
  managerName?: string;
  /**
   * 营销经理id
   * @format int64
   */
  marketingManagerId?: number;
  /** 营销经理名称 */
  marketingManagerName?: string;
  /** 会员信息 */
  membership?: CustomerMembership;
  /** 国家代码 */
  nationCode?: string;
  /** 外链分享 */
  outsideLink?: string;
  /** 对应店铺名称 */
  shopName?: string;
  /** 是否展示会员信息 */
  showMembershipInfo?: boolean;
  /** skype */
  skype?: string;
  /**
   * 下单拆包提醒的标志：默认0-需要提醒；1-不再提醒
   * @format int32
   */
  splitRemindFlag?: number;
  /** 站点代码 */
  stationCode?: string;
  /**
   * b2b与d2c的统一id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 客户总监id
   * @format int64
   */
  supervisionManagerId?: number;
  /** 客户总监名称 */
  supervisionManagerName?: string;
  /**
   * 系统来源: 1-D2C; 2-B2B
   * @format int32
   */
  systemSource?: number;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
  /** @format int32 */
  updateShopPopup?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
  utcTimeZone?: string;
}

/** CustomerDistributeQueryRespDTO */
export interface CustomerDistributeQueryRespDTO {
  /** @format int64 */
  customerId?: number;
  merchandiserUserId?: string;
  merchandiserUserName?: string;
  oemPurchaseUserId?: string;
  oemPurchaseUserName?: string;
  purchaseUserId?: string;
  purchaseUserName?: string;
}

/** CustomerGuide */
export interface CustomerGuide {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerGuideId?: number;
  /** @format int64 */
  customerId?: number;
  guideProperties?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerItemRespDTO */
export interface CustomerItemRespDTO {
  /** @format int32 */
  accountType?: number;
  chatWorkId?: string;
  countryCode?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  customerShop?: CustomShopDetailRespDTO;
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  gender?: number;
  headerUrl?: string;
  /** @format int32 */
  internalFlag?: number;
  langcode?: string;
  /** @format date-time */
  lastLoginTime?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** 客户与会员身份关联数据 */
  membership?: CustomerMembership;
  outsideLink?: string;
  password?: string;
  salt?: string;
  skype?: string;
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** CustomerJpushReqDTO */
export interface CustomerJpushReqDTO {
  customerId?: string;
  extrasParam?: string;
  msgContent?: string;
  msgTitle?: string;
  notificationTitle?: string;
}

/** CustomerLoginRespDTO */
export interface CustomerLoginRespDTO {
  customerRespDTO?: CustomerRespDTO;
  customerShopList?: CustomerShopRespDTO[];
  memberShipResp?: CustomerMemberShipRespDTO;
  token?: string;
  uuid?: string;
}

/** CustomerMemberShipRespDTO */
export interface CustomerMemberShipRespDTO {
  /** @format int32 */
  basicFlag?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerMembershipId?: number;
  /** @format int32 */
  customerMembershipStatus?: number;
  customerName?: string;
  discountActualPrice?: number;
  /** @format date-time */
  expiresDate?: string;
  /** @format int32 */
  historyMemberLevel?: number;
  /**
   * 推广规模id
   * @format int32
   */
  membershipConfigId?: number;
  /**
   * 0-默认仅展示普通会员,1-仅展示特殊会员,2-展示全部会员
   * @format int32
   */
  membershipShowStatus?: number;
  /** @format int64 */
  membershipTemplateId?: number;
  membershipTemplateName?: string;
  /** @format int64 */
  membershipTemplatePriceId?: number;
  membershipTemplatePriceName?: string;
  sellingPrice?: number;
  /**
   * 会员类型:0-普通,1-特殊
   * @format int32
   */
  specialType?: number;
  /** @format int64 */
  superCustomerId?: number;
  /**
   * 会员等级，从低到高，0最低
   * @format int32
   */
  templateLevel?: number;
  /**
   * 试用标志:0-不是,1是
   * @format int32
   */
  trialFlag?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** CustomerMembershipReqDTO */
export interface CustomerMembershipReqDTO {
  automaticRenewalSuperCustomerIdList?: number[];
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerMembershipId?: number;
  /** @format int32 */
  customerMembershipStatus?: number;
  customerName?: string;
  expired?: boolean;
  /** @format date-time */
  expiresDate?: string;
  /** @format int64 */
  membershipTemplateId?: number;
  membershipTemplateName?: string;
  /** @format int64 */
  membershipTemplatePriceId?: number;
  membershipTemplatePriceName?: string;
  /**
   * 会员类型:0-普通,1-特殊
   * @format int32
   */
  specialType?: number;
  /** @format int64 */
  superCustomerId?: number;
  /**
   * 试用标志:0-不是,1是
   * @format int32
   */
  trialFlag?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerMembershipResDTO */
export interface CustomerMembershipResDTO {
  /** @format int32 */
  basicFlag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerMembershipId?: number;
  /** @format int32 */
  customerMembershipStatus?: number;
  customerName?: string;
  discountActualPrice?: number;
  /** @format date-time */
  expiresDate?: string;
  /** @format int32 */
  historyMemberLevel?: number;
  /** @format int64 */
  membershipTemplateId?: number;
  membershipTemplateName?: string;
  /** @format int64 */
  membershipTemplatePriceId?: number;
  membershipTemplatePriceName?: string;
  sellingPrice?: number;
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerOverviewRespDTO */
export interface CustomerOverviewRespDTO {
  /** @format int32 */
  accountType?: number;
  availableAmount?: number;
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  customerShop?: CustomerShopRespDTO;
  customerShopList?: CustomerShopRespDTO[];
  /**
   * 店铺数量
   * @format int32
   */
  customerShopQuantity?: number;
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  daysTogether?: number;
  frozenAmount?: number;
  /** @format int32 */
  gender?: number;
  headerUrl?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** 客户与会员身份关联数据 */
  membership?: CustomerMembership;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int32 */
  systemSource?: number;
}

/** CustomerPageDTO */
export interface CustomerPageDTO {
  /** @format int32 */
  accountType?: number;
  chatWorkId?: string;
  countryCode?: string;
  /** @format date-time */
  createTime?: string;
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  defaultLogin?: number;
  /** @format int32 */
  gender?: number;
  headerUrl?: string;
  /** @format int32 */
  internalFlag?: number;
  /** @format date-time */
  lastLoginTime?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int64 */
  managerId?: number;
  /** @format int64 */
  marketingManagerId?: number;
  /** @format int64 */
  oldCustomerStatus?: number;
  outsideLink?: string;
  password?: string;
  salt?: string;
  skype?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int64 */
  supervisionManagerId?: number;
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerRespDTO */
export interface CustomerRespDTO {
  /** @format int32 */
  accountType?: number;
  /** @format date-time */
  createTime?: string;
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  /** @format int32 */
  gender?: number;
  hasKoreaWallet?: boolean;
  /** @format date-time */
  lastLoginTime?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /**
   * 推广规模id
   * @format int32
   */
  membershipConfigId?: number;
  /**
   * 0-默认仅展示普通会员,1-仅展示特殊会员,2-展示全部会员
   * @format int32
   */
  membershipShowStatus?: number;
  nationCode?: string;
  /** @format int32 */
  platformType?: number;
  /** @format int64 */
  shopId?: number;
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerShopAddressRespDTO */
export interface CustomerShopAddressRespDTO {
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  logisticsId?: number;
  logisticsName?: string;
}

/** CustomerShopBySuperRespDTO */
export interface CustomerShopBySuperRespDTO {
  customerShopList?: CustomerShopRespDTO[];
  /** @format int64 */
  superCustomerId?: number;
}

/** CustomerShopLimitRespDTO */
export interface CustomerShopLimitRespDTO {
  /**
   * 当前店铺数量
   * @format int32
   */
  currentShopNum?: number;
  /**
   * 会员等级
   * @format int32
   */
  level?: number;
  /**
   * 限制店铺数量
   * @format int32
   */
  limitShopNum?: number;
}

/** CustomerShopOptDTO */
export interface CustomerShopOptDTO {
  /**
   * 是否自动下单
   * @format int32
   */
  customerShopAutoOrderFlag?: number;
  /** @format int64 */
  customerShopId?: number;
  /**
   * 是否使用在途库存
   * @format int32
   */
  customerShopUseOnTheWayStockFlag?: number;
}

/** CustomerShopPageDTO */
export interface CustomerShopPageDTO {
  /** @format int32 */
  activeSubAccountFlag?: number;
  clientId?: string;
  clientSecret?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int32 */
  customerShopAuthStatus?: number;
  /** @format int32 */
  customerShopAutoOrderFlag?: number;
  /** @format int64 */
  customerShopId?: number;
  customerShopLogo?: string;
  customerShopName?: string;
  customerShopPermission?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  customerShopUrl?: string;
  /** @format int64 */
  mainCustomerId?: number;
  mainCustomerName?: string;
  /** @format int32 */
  supportChoice?: number;
  /** @format date-time */
  updateTime?: string;
  /** @format int32 */
  virtualFlag?: number;
  wareCode?: string;
  wareName?: string;
}

/** CustomerShopQueryDTO */
export interface CustomerShopQueryDTO {
  customerIds?: number[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
}

/** CustomerShopRespDTO */
export interface CustomerShopRespDTO {
  /** @format int64 */
  abnormalOrderCount?: number;
  /** @format int64 */
  abnormalOrderNum?: number;
  /** @format int32 */
  activeSubAccountFlag?: number;
  /** @format int64 */
  apiOrderCount?: number;
  /** @format int32 */
  apiOrderStatusFailCount?: number;
  /** @format int32 */
  authExpireStatus?: number;
  /** @format int64 */
  authStatus?: number;
  availableAmount?: number;
  /** @format int32 */
  badAmount?: number;
  /** @format int64 */
  canDeliveryOrderCount?: number;
  /** @format int32 */
  canceledCount?: number;
  clientId?: string;
  clientSecret?: string;
  /** @format int32 */
  combinationFallAmount?: number;
  /** @format int32 */
  combinationFallFreezedAmount?: number;
  /** @format int32 */
  combinationFallTotalAmount?: number;
  /** @format int64 */
  completeOrderCount?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int32 */
  customerShopAuthStatus?: number;
  /** @format int32 */
  customerShopAutoOrderFlag?: number;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  customerShopPermission?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  customerShopUrl?: string;
  /** @format int32 */
  customerShopUseOnTheWayStockFlag?: number;
  /** @format int64 */
  dealOrderCount?: number;
  /** @format int32 */
  deletedFlag?: number;
  /** @format int32 */
  flAmount?: number;
  frozenAmount?: number;
  /** @format int32 */
  isExistOem?: number;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  managerIds?: string[];
  /** @format int32 */
  noBindAmazonSkuCount?: number;
  /** @format int32 */
  noBindApiSkuCount?: number;
  /** @format int64 */
  noCompleteOrderCount?: number;
  /** @format int32 */
  noConfirmReplenishPlanCount?: number;
  /** @format int64 */
  nonDoneRechargeCount?: number;
  orderAmount?: number;
  orderAmountKrw?: number;
  /** @format int32 */
  orderCount?: number;
  /** @format int64 */
  overdueCanotDeliverNum?: number;
  /** @format int64 */
  partDeliveryOrderCount?: number;
  /** @format int32 */
  pendingInventoryCount?: number;
  /** @format int32 */
  productAmount?: number;
  /** @format int32 */
  quotedOem?: number;
  /** @format int32 */
  rePurchaseOem?: number;
  /** @format int32 */
  searchSuccessOem?: number;
  /** @format int64 */
  shopPlatform?: number;
  stationCode?: string;
  /** @format int32 */
  supportChoice?: number;
  /** @format int32 */
  systemSource?: number;
  /** @format int32 */
  toBeQuotedOem?: number;
  unificationCustomerFullName?: string;
  /** @format int32 */
  unpaidBillNum?: number;
  /** @format int32 */
  virtualFlag?: number;
  /** @format int32 */
  waitConfirm?: number;
  /** @format int64 */
  waitPayOrderCount?: number;
  /** @format int32 */
  waitedOem?: number;
  wareCode?: string;
  wareName?: string;
  warehouseList?: WarehousePojo[];
  /** @format int32 */
  yesterdayOrderQuantity?: number;
  /** @format int32 */
  yesterdayShipmentsQuantity?: number;
}

/** CustomerShopShipDelReqDTO */
export interface CustomerShopShipDelReqDTO {
  /**
   * 配置id
   * @format int64
   */
  shopShipId?: number;
}

/** CustomerShopShipReqDTO */
export interface CustomerShopShipReqDTO {
  /** 目的地国家 */
  countryCode?: string;
  /**
   * 配置id，编辑时必传
   * @format int64
   */
  customerShopShipId?: number;
  /**
   * 物流 id
   * @format int64
   */
  logisticsId?: number;
  /** 仓库编码 */
  warehouseCode?: string;
}

/** CustomerShopShipRespDTO */
export interface CustomerShopShipRespDTO {
  countryCode?: string;
  countryName?: string;
  /** @format int64 */
  customerShopShipId?: number;
  /** @format int64 */
  logisticsId?: number;
  logisticsLogo?: string;
  logisticsName?: string;
}

/** CustomerShopWmsRespDTO */
export interface CustomerShopWmsRespDTO {
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
}

/** CustomerSplitRemindFlagDTO */
export interface CustomerSplitRemindFlagDTO {
  /** @format int64 */
  customerId?: number;
}

/** CustomerStationDTO */
export interface CustomerStationDTO {
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * 是否删除 0:未删除 1:已删除
   * @format int32
   */
  isDelete?: number;
  /** 语言代码 */
  languageCode?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家名称 */
  nationName?: string;
  /** 站点代码 */
  stationCode?: string;
  /** 站点名称 */
  stationName?: string;
}

/** CustomerTagDTO */
export interface CustomerTagDTO {
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int32 */
  tag?: number;
  tagName?: string;
  /** @format int32 */
  tagType?: number;
}

/** CustomerTagSearchReq */
export interface CustomerTagSearchReq {
  customerIds?: number[];
  /** @format int32 */
  customerTag?: number;
  customerTags?: number[];
  /** @format int64 */
  mainCustomerId?: number;
  mainCustomerIds?: number[];
}

/** CustomerTagUpdateReq */
export interface CustomerTagUpdateReq {
  customerTags?: number[];
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int32 */
  operateType?: number;
}

/** CustomerThirdBindRespDTO */
export interface CustomerThirdBindRespDTO {
  /**
   * 系统用户id
   * @format int64
   */
  customerId?: number;
  /** 三方用户id唯一 */
  thirdCustomerId?: string;
  /** 三方用户名 */
  thirdCustomerName?: string;
  /** 三方邮箱 */
  thirdEmail?: string;
  /** 三方手机号 */
  thirdPhoneNumber?: string;
  /** 三方平台 */
  thirdPlatform?: string;
}

/** DataDictRespDTO */
export interface DataDictRespDTO {
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  dataDictId?: number;
  dictKey?: string;
  dictName?: string;
  dictValue?: string;
  /** @format int32 */
  parentId?: number;
  remark?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  type?: number;
  /** @format date-time */
  updateTime?: string;
}

/** DeclarationWhitelistPageDTO */
export interface DeclarationWhitelistPageDTO {
  /** 主客户ID */
  mainCustomerIds?: number[];
  /** 用户名 */
  mainCustomerName?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
}

/** DeclarationWhitelistRespDTO */
export interface DeclarationWhitelistRespDTO {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  mainCustomerId?: number;
  mainCustomerName?: string;
  unificationCustomerFullName?: string;
}

/** DefaultLoginReqDTO */
export interface DefaultLoginReqDTO {
  /** @format int32 */
  systemSource?: number;
  uuid?: string;
}

/** DelUserRoleReqDTO */
export interface DelUserRoleReqDTO {
  roleId?: string[];
  userId?: string[];
}

/** DeleteClearanceAddressReqDTO */
export interface DeleteClearanceAddressReqDTO {
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  shopClearanceAddressId?: number;
}

/** DeleteShippingAddressReqDTO */
export interface DeleteShippingAddressReqDTO {
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  shopShippingAddressId?: number;
}

/** DepartmentDetailRespDTO */
export interface DepartmentDetailRespDTO {
  code?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  director?: string;
  directorId?: string;
  id?: string;
  mobile?: string;
  name?: string;
  parentId?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  treePath?: string;
  /** @format int32 */
  type?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** DepartmentTreeRespDTO */
export interface DepartmentTreeRespDTO {
  children?: DepartmentTreeRespDTO[];
  icon?: string;
  id?: string;
  label?: string;
  path?: string;
  roles?: ManageRoleRespDTO[];
  /** @format int32 */
  size?: number;
  /** @format int32 */
  type?: number;
  users?: ManageUserRespDTO[];
  /** @format int32 */
  visible?: number;
}

/** DirectorSetReqDTO */
export interface DirectorSetReqDTO {
  /** @format int32 */
  status?: number;
  userId?: string;
}

/** EchatBizReqDTO */
export interface EchatBizReqDTO {
  /**
   * 客户id
   * @format int64
   */
  customerId?: number;
  /**
   * echat业务类型
   * @format int32
   */
  echatBizType?: number;
  /** 业务参数 */
  myData?: Record<string, object>;
  /** 随机数 */
  nonce?: string;
  /** echat签名 */
  signature?: string;
  /** 时间戳 */
  timestamp?: string;
}

/** EmailLoginReqDTO */
export interface EmailLoginReqDTO {
  /** @format int32 */
  buType?: number;
  customerEmail?: string;
  /** @format int32 */
  platformType?: number;
  stationCode?: string;
  /** 三方平台用户账号,可以理解为唯一标识 */
  thirdCustomerId?: string;
  /** 三方平台用户名称 */
  thirdCustomerName?: string;
  /** 三方平台用户邮箱 */
  thirdEmail?: string;
  /** 三方平台标识 */
  thirdPlatform?: string;
  verificationCode?: string;
}

/** EmailSendReqDTO */
export interface EmailSendReqDTO {
  attachmentInfoList?: AttachmentInfo[];
  businessKey?: string;
  content?: string;
  contentMap?: object;
  lang?: string;
  templateType?: string;
  title?: string;
  toEmail?: string;
}

/** EmailSendRespDTO */
export interface EmailSendRespDTO {
  businessKey?: string;
  sendSuccess?: boolean;
}

/** FeedbackInfoReqDTO */
export interface FeedbackInfoReqDTO {
  companyName?: string;
  /** 邮箱 */
  email: string;
  /** 附件、图片 */
  files?: string[];
  message?: string;
  phone?: string;
  /** 站点信息 */
  stationCode: string;
  /** 姓名 */
  userName: string;
}

/** FeedbackInfoRspDTO */
export interface FeedbackInfoRspDTO {
  companyName?: string;
  /** @format date-time */
  createTime?: string;
  email?: string;
  files?: string[];
  /** @format int64 */
  id?: number;
  message?: string;
  phone?: string;
  stationCode?: string;
  /** @format date-time */
  updateTime?: string;
  userName?: string;
}

/** FreeCountOperationReqDTO */
export interface FreeCountOperationReqDTO {
  addReturnQuantity?: boolean;
  bizId?: string;
  /** @format int32 */
  freeCountType?: number;
  remarks?: string;
  /** @format int64 */
  superCustomerId?: number;
}

/** FreeCountRespDTO */
export interface FreeCountRespDTO {
  /**
   * 当前可用数量
   * @format int32
   */
  currentAvailableQuantity?: number;
  /**
   * 上月剩余可用数量
   * @format int32
   */
  lastMonthQuantity?: number;
  /** 月份(例:2024-12) */
  month?: string;
  /** oem寻源费用 */
  oemCharge?: number;
  /**
   * 超级客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 本月新增可用数量
   * @format int32
   */
  thisMonthAddQuantity?: number;
  /**
   * 本月可用数量
   * @format int32
   */
  thisMonthQuantity?: number;
  /**
   * 本月返还次数
   * @format int32
   */
  thisMonthReturnQuantity?: number;
  /**
   * 本月已用数量
   * @format int32
   */
  thisMonthUsedQuantity?: number;
  /**
   * 类型 1 免费下单次数 2 oem寻源次数
   * @format int32
   */
  type?: number;
}

/** FrogArticleArchiveSortRespDTO */
export interface FrogArticleArchiveSortRespDTO {
  /** @format int32 */
  articleNum?: number;
  /** @format int32 */
  frogArticleMonth?: number;
  /** @format int32 */
  frogArticleYear?: number;
}

/** FrogArticleDetailRespDTO */
export interface FrogArticleDetailRespDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** @format date-time */
  createTime?: string;
  frogArticleContent?: string;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  /** @format int64 */
  frogArticleId?: number;
  frogArticleImgUrl?: string;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** @format int64 */
  frogArticleViewCount?: number;
  /**
   * 未登录限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noLoginRestriction?: number;
  /**
   * 未入会限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noMembershipRestriction?: number;
  /** SEO 描述 */
  seoDescription?: string;
  /** @format int32 */
  showMall?: number;
  stationCode?: string;
  /** @format int64 */
  viewNum?: number;
}

/** FrogArticlePrepAndNextRespDTO */
export interface FrogArticlePrepAndNextRespDTO {
  /** @format int64 */
  nextArticleId?: number;
  nextArticleTitle?: string;
  /** @format int64 */
  prepArticleId?: number;
  prepArticleTitle?: string;
}

/** FrogArticleRespDTO */
export interface FrogArticleRespDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  /** @format int64 */
  frogArticleId?: number;
  frogArticleImgUrl?: string;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** @format int64 */
  frogArticleViewCount?: number;
  /**
   * 是否置顶
   * @format int32
   */
  isPinTop?: number;
  /**
   * 未登录限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noLoginRestriction?: number;
  /**
   * 未入会限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noMembershipRestriction?: number;
  /** SEO 描述 */
  seoDescription?: string;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  stationCode?: string;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
  /** @format int64 */
  viewNum?: number;
}

/**
 * GetActivitiesRespDTO
 * 获取直播间列表
 */
export interface GetActivitiesRespDTO {
  /** 回放列表 */
  backActivities?: VideoActivityDTO[];
  /** 直播中列表 */
  livingActivities?: VideoActivityDTO[];
  /** 预约列表 */
  reserveActivities?: VideoActivityDTO[];
}

/** GetAllFrogArticlePageDTO */
export interface GetAllFrogArticlePageDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  typeList?: string[];
}

/** GetCustomerByMainCustomerReqDTO */
export interface GetCustomerByMainCustomerReqDTO {
  customerName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int32 */
  systemSource?: number;
}

/**
 * GetCustomerGoogleListReqDTO
 * 查询用户谷歌表列表请求DTO
 */
export interface GetCustomerGoogleListReqDTO {
  /**
   * 客户id
   * @format int32
   */
  customerId?: number;
  /** 谷歌表id */
  googleId?: string;
  /** 负责人名称 */
  managerName?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
  /**
   * 用户id
   * @format int64
   */
  userId?: number;
}

/** GetCustomerListReqDTO */
export interface GetCustomerListReqDTO {
  /** @format int32 */
  accountType?: number;
  /** @format int32 */
  assign?: number;
  /** @format int64 */
  customerId?: number;
  customerIds?: number[];
  customerName?: string;
  email?: string;
  loginName?: string;
  multiMatch?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  phone?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  superCustomerIds?: number[];
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
  wareCode?: string;
}

/** GetCustomerShopDTO */
export interface GetCustomerShopDTO {
  /** @format int64 */
  accountType?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  mainCustomerId?: number;
  shopName?: string;
  stationCode?: string;
  /** @format int32 */
  systemSource?: number;
  /**
   * 是否查看前10个店铺: 1是,0否-查看剩余店铺
   * @format int32
   */
  viewFirstTenStores?: number;
}

/** GetCustomerShopListByShopIdListDTO */
export interface GetCustomerShopListByShopIdListDTO {
  customerShopIdList?: number[];
}

/** GetCustomerShopListReqDTO */
export interface GetCustomerShopListReqDTO {
  /** @format int64 */
  customerId?: number;
  customerShopIdList?: number[];
  /** @format int32 */
  customerShopPlatform?: number;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int32 */
  need2cShopList?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  shopAuthStatus?: number;
  /** @format int32 */
  startIndex?: number;
  /** @format int32 */
  supportChoice?: number;
}

/** GetDepartmentTreeByIdReqDTO */
export interface GetDepartmentTreeByIdReqDTO {
  deptId?: string;
  types?: number[];
}

/** GetDepartmentTreeByNameReqDTO */
export interface GetDepartmentTreeByNameReqDTO {
  nickname?: string;
  types?: number[];
}

/** GetDepartmentTreeReqDTO */
export interface GetDepartmentTreeReqDTO {
  types?: number[];
}

/** GetDepartmentUserReqDTO */
export interface GetDepartmentUserReqDTO {
  createTimeOrder?: boolean;
  depId?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  endTime?: string;
  info?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  startTime?: string;
}

/** GetFrogArticleArchivePageDTO */
export interface GetFrogArticleArchivePageDTO {
  frogArticleMonth?: string;
  frogArticleYear?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** GetFrogArticlePageDTO */
export interface GetFrogArticlePageDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** 文章归档月份 */
  frogArticleMonth?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型Id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** 文章归档年份 */
  frogArticleYear?: string;
  /** 关键字 */
  keyword?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /**
   * 在市场购展示  0:否  1：是
   * @format int32
   */
  showMall?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  /**
   * 客户Id
   * @format int64
   */
  superCustomerId?: number;
}

/** GetFrogArticlePrepAndNextReqDTO */
export interface GetFrogArticlePrepAndNextReqDTO {
  /** @format int64 */
  frogArticleId?: number;
  stationCode?: string;
  /** @format int32 */
  type?: number;
}

/** GetManageBannerPageReqDTO */
export interface GetManageBannerPageReqDTO {
  /** @format int64 */
  bannerApplicableTemplateId?: number;
  bannerDesignatedUser?: boolean;
  /** @format int32 */
  bannerStatus?: number;
  /** @format date-time */
  endTime?: string;
  name?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** @format date-time */
  startTime?: string;
  stationCode?: string;
  /**
   * banner类型，0：我的频道；1：透明购，2：市场购, 3:青蛙文章
   * @format int32
   */
  type?: number;
}

/** GetManageFrogArticlePageDTO */
export interface GetManageFrogArticlePageDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  frogArticleTitle?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** GetRolesUserListReqDTO */
export interface GetRolesUserListReqDTO {
  name?: string;
  roleId?: string[];
}

/** GetShopListByCustomerReqDTO */
export interface GetShopListByCustomerReqDTO {
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int32 */
  systemSource?: number;
}

/** GetThirdAuthLinkReqDTO */
export interface GetThirdAuthLinkReqDTO {
  /**
   * 类型 0-直采 1-代采
   * @format int32
   */
  buType: number;
  /**
   * 回调地址
   * @example "http://2peuvm.natappfree.cc/oauth/callback/google"
   */
  redirectUrl: string;
  /** 站点信息 美国站 US */
  stationCode?: string;
  /**
   * 三方平台标识
   * @example "google"
   */
  thirdPlatform: string;
}

/** GetThirdDataReqDTO */
export interface GetThirdDataReqDTO {
  /**
   * 回调地址上带的授权Code
   * @example "4%2F0Adeu5BXKXVMj0i3b3L7IBojphwa_mrwL46nHLmvJMgK_y_Npt3mBBltKKhuyRRtggDh54Q"
   */
  authCode: string;
  /**
   * 0-直采 1-代采
   * @format int32
   */
  buType: number;
  /**
   * 三方邮箱,苹果会在回调时返回,特殊逻辑
   * @example "111@163.com"
   */
  email?: string;
  /**
   * idToken,苹果特殊逻辑
   * @example "4%2F0Adeu5BXKXVMj0i3b3L7IBojphwa_mrwL46nHLmvJMgK_y_Npt3mBBltKKhuyRRtggDh54Q"
   */
  idToken?: string;
  /**
   * 回调地址
   * @example "http://2peuvm.natappfree.cc/oauth/callback/google"
   */
  redirectUrl: string;
  /**
   * 回调链接上带的state参数
   * @example "b1b0971bfa724c8c512847b33eb78353"
   */
  state: string;
  /**
   * 三方平台标识
   * @example "google"
   */
  thirdPlatform: string;
  /**
   * 三方名称,苹果会在回调时返回,特殊逻辑
   * @example 111
   */
  username?: string;
}

/** GetThirdDataRespDTO */
export interface GetThirdDataRespDTO {
  /** 三方平台用户邮箱 */
  thirdCustomerEmail?: string;
  /** 三方平台用户账号,可以理解为唯一标识 */
  thirdCustomerId?: string;
  /** 三方平台用户昵称 */
  thirdCustomerName?: string;
  /** 三方平台用户手机号 */
  thirdCustomerPhone?: string;
  /** 三方平台标识 */
  thirdPlatform?: string;
}

/** GetUserListReqDTO */
export interface GetUserListReqDTO {
  createTimeOrder?: boolean;
  deptId?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  endTime?: string;
  endTimeOrder?: boolean;
  mobile?: string;
  nickname?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  startTime?: string;
  /** @format int32 */
  status?: number;
}

/** HolidayDateDTO */
export interface HolidayDateDTO {
  /**
   * 日期（格式:20230101）
   * @format int64
   */
  date?: number;
  /**
   * 天
   * @format int32
   */
  day?: number;
  /**
   * 月
   * @format int32
   */
  month?: number;
  /**
   * 1为工作日，2为周末，3为节假日
   * @format int32
   */
  type?: number;
  workDay?: boolean;
  /**
   * 年
   * @format int32
   */
  year?: number;
}

/** HotFrogArticleRespDTO */
export interface HotFrogArticleRespDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  /** @format int64 */
  frogArticleId?: number;
  frogArticleImgUrl?: string;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** @format int64 */
  frogArticleViewCount?: number;
  /**
   * 未登录限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noLoginRestriction?: number;
  /**
   * 未入会限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noMembershipRestriction?: number;
  /** @format int64 */
  viewNum?: number;
}

/** HotFrogArticleSortDTO */
export interface HotFrogArticleSortDTO {
  /** @format int64 */
  frogArticleId?: number;
  /** @format int64 */
  realViewCount?: number;
}

/** ImportantNoticeDTO */
export interface ImportantNoticeDTO {
  content?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  newFlag?: number;
  /**
   * 是否已读 0 否 1 是
   * @format int32
   */
  readStatus?: number;
  stationCode?: string;
  /** @format int32 */
  status?: number;
  title?: string;
  /** @format int32 */
  topStatus?: number;
  /** @format int32 */
  type?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ImportantNoticeDetailDTO */
export interface ImportantNoticeDetailDTO {
  content?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  newFlag?: number;
  /**
   * 下一页id
   * @format int64
   */
  nextId?: number;
  /** 下一页标题 */
  nextTitle?: string;
  /**
   * 上一页id
   * @format int64
   */
  preId?: number;
  /** 上一页标题 */
  preTitle?: string;
  /**
   * 是否已读 0 否 1 是
   * @format int32
   */
  readStatus?: number;
  stationCode?: string;
  /** @format int32 */
  status?: number;
  title?: string;
  /** @format int32 */
  topStatus?: number;
  /** @format int32 */
  type?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ImportantNoticePageReqDTO */
export interface ImportantNoticePageReqDTO {
  /**
   * id
   * @format int64
   */
  id?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** 站点编码 */
  stationCode?: string;
  /** @format int32 */
  status?: number;
  /**
   * 类型 1放假通知、2价格变更、3系统更新、4其他
   * @format int32
   */
  type?: number;
}

/** IntAreaDTO */
export interface IntAreaDTO {
  /** 区号 */
  areaNum?: string;
  /** 子级地区 */
  children?: IntAreaDTO[];
  /** 区域代码 */
  code?: string;
  /**
   * id
   * @format int64
   */
  intAreaId?: number;
  /**
   * 层级:1洲 2国家 3省 4市
   * @format int64
   */
  level?: number;
  /** 中文名称 */
  name?: string;
  /** 英文名称 */
  nameEn?: string;
  /** 日文名称 */
  nameJa?: string;
  /** 韩文名称 */
  nameKr?: string;
  /** 中文拼音 */
  namePinyin?: string;
  /**
   * 父id
   * @format int64
   */
  pid?: number;
  /** 邮编 */
  postalCode?: string;
}

/** IntAreaQueryDTO */
export interface IntAreaQueryDTO {
  /** 区号 */
  areaNum?: string;
  /** 区域代码 */
  code?: string;
  /**
   * 地区id
   * @format int64
   */
  intAreaId?: number;
  /** 地区id */
  intAreaIdList?: number[];
  /**
   * 层级:1洲 2国家 3省....
   * @format int64
   */
  level?: number;
  /** 中文名称 */
  name?: string;
  /** 英文名称 */
  nameEn?: string;
  /** 日文名称 */
  nameJa?: string;
  /** 中文拼音 */
  namePinyin?: string;
  /**
   * 父id
   * @format int64
   */
  pid?: number;
}

/** InvitationInfoRespDTO */
export interface InvitationInfoRespDTO {
  /** 国家：日本：JP 韩国：KR */
  country?: string;
  /** 国家中文描述 */
  countryDesc?: string;
  /** 语言编码 */
  langCode?: string;
  /** 站点代码 */
  stationCode?: string;
}

/** JSONObject */
export type JSONObject = Record<string, object>;

/** ManageBannerReqDTO */
export interface ManageBannerReqDTO {
  categoryList?: number[];
}

/** ManageBannerRespDTO */
export interface ManageBannerRespDTO {
  /** @format int64 */
  bannerApplicableTemplateId?: number;
  bannerApplicableTemplateName?: string;
  /** @format int32 */
  bannerClickNum?: number;
  bannerDesignatedUserId?: string;
  bannerDesignatedUserList?: CustomerDetailRespDTO[];
  /** @format int64 */
  bannerId?: number;
  /** banner图片url-H5页面 */
  bannerImgMobileUrl?: string;
  bannerImgUrl?: string;
  bannerJumpLink?: string;
  bannerName?: string;
  /** @format int32 */
  bannerStatus?: number;
  /** @format int32 */
  bannerUserClickNum?: number;
  /** @format date-time */
  endTime?: string;
  /** @format int64 */
  mallCategoryId?: number;
  /** @format date-time */
  startTime?: string;
  stationCode?: string;
  /** @format int32 */
  systemSource?: number;
}

/** ManageFrogArticleRespDTO */
export interface ManageFrogArticleRespDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  /** @format int64 */
  frogArticleId?: number;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  frogArticleType?: string;
  /**
   * 文章类型id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** 文章类型名称 */
  frogArticleTypeName?: string;
  /** @format int64 */
  frogArticleViewCount?: number;
  /**
   * 是否置顶
   * @format int32
   */
  isPinTop?: number;
  /**
   * 未登录限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noLoginRestriction?: number;
  /**
   * 未入会限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noMembershipRestriction?: number;
  /** SEO 描述 */
  seoDescription?: string;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  stationCode?: string;
}

/** ManageLoginRespDTO */
export interface ManageLoginRespDTO {
  containCustomerIds?: number[];
  containUserIds?: string[];
  /** @format int32 */
  directoried?: number;
  /** @format int64 */
  expiresIn?: number;
  loginWareHouse?: string;
  nick?: string;
  roles?: string[];
  token?: string;
  userId?: string;
  username?: string;
  warehouses?: UserWarehouseRespDTO[];
}

/** ManageMenuRespDTO */
export interface ManageMenuRespDTO {
  backEndPath?: string;
  btnPerm?: string;
  code?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  icon?: string;
  id?: string;
  name?: string;
  parentId?: string;
  redirect?: string;
  routeName?: string;
  routePath?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  type?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
  /** @format int32 */
  visible?: number;
}

/** ManageRoleRespDTO */
export interface ManageRoleRespDTO {
  code?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  deptId?: string;
  manageRoleId?: string;
  name?: string;
  remark?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  type?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ManageUserDetailRespDTO */
export interface ManageUserDetailRespDTO {
  avatar?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  deptId?: string;
  /** @format int32 */
  directoried?: number;
  email?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  endTime?: string;
  /** @format int32 */
  gender?: number;
  id?: string;
  menus?: string[];
  mobile?: string;
  nickname?: string;
  relationDd?: string;
  relationDdDeptId?: string;
  relationDdDeptName?: string;
  relationDdUserId?: string;
  relationDdUserName?: string;
  roleIds?: string[];
  /** @format int32 */
  status?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
  username?: string;
}

/** ManageUserInfoRespDTO */
export interface ManageUserInfoRespDTO {
  id?: string;
  menus?: string[];
  roles?: string[];
}

/** ManageUserLoginRespDTO */
export interface ManageUserLoginRespDTO {
  avatar?: string;
  change?: boolean;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  deptId?: string;
  /** @format int32 */
  directoried?: number;
  email?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  endTime?: string;
  /** @format int32 */
  gender?: number;
  id?: string;
  mobile?: string;
  nickname?: string;
  perms?: string[];
  relationDd?: string;
  relationDdDeptId?: string;
  relationDdDeptName?: string;
  relationDdUserId?: string;
  relationDdUserName?: string;
  roles?: string[];
  /** @format int32 */
  status?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
  username?: string;
  warehouses?: UserWarehouseRespDTO[];
}

/** ManageUserRespDTO */
export interface ManageUserRespDTO {
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  deptId?: string;
  /** @format int32 */
  directoried?: number;
  email?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  endTime?: string;
  /** @format int32 */
  gender?: number;
  manageUserId?: string;
  mobile?: string;
  nickname?: string;
  relationDd?: string;
  relationDdDeptId?: string;
  relationDdDeptName?: string;
  relationDdUserId?: string;
  relationDdUserName?: string;
  roleIdStrs?: string;
  roleNames?: string;
  /** @format int32 */
  status?: number;
  type?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
  username?: string;
  wareCodeList?: UserWarehouseRespDTO[];
}

/** MembershipOrderDTO */
export interface MembershipOrderDTO {
  /** @format int32 */
  approveStatus?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  creationChannel?: number;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  exchangeCurrencyFrom?: string;
  exchangeCurrencyTo?: string;
  exchangeRate?: number;
  exchangeRateFloat?: number;
  /** @format date-time */
  expiresDate?: string;
  /** @format int32 */
  getChannel?: number;
  /** @format int64 */
  membershipOrderId?: number;
  /** @format int64 */
  membershipTemplateId?: number;
  membershipTemplateName?: string;
  /** @format int64 */
  membershipTemplatePriceId?: number;
  membershipTemplatePriceName?: string;
  /** @format int64 */
  oldMembershipTemplateId?: number;
  oldMembershipTemplateName?: string;
  orderNo?: string;
  /** @format int32 */
  orderType?: number;
  originCurrencyCode?: string;
  originDiscountPrice?: number;
  originPaymentAmount?: number;
  originReceiptAmount?: number;
  originSellAmount?: number;
  /** @format int32 */
  payChannel?: number;
  /** @format int32 */
  payStatus?: number;
  /** @format date-time */
  payTime?: string;
  payeeBankName?: string;
  payerBankName?: string;
  payerName?: string;
  /** @format date-time */
  paymentDate?: string;
  paypalCycleDate?: string;
  paypalOrderId?: string;
  paypalSubscriptionId?: string;
  /** @format date-time */
  receiptDate?: string;
  /**
   * 会员类型:0-普通,1-特殊
   * @format int32
   */
  specialType?: number;
  /** @format int64 */
  superCustomerId?: number;
  systemSource?: string;
  targetCurrencyCode?: string;
  targetDiscountPrice?: number;
  targetPaymentAmount?: number;
  targetReceiptAmount?: number;
  targetSellAmount?: number;
  txnId?: string;
  unificationCustomerFullName?: string;
  /** @format date-time */
  updateTime?: string;
  /** @format int32 */
  validPeriod?: number;
  /** @format int32 */
  validPeriodUnit?: number;
  zhongyinExchangeRate?: number;
}

/** MenuTreeListRespDTO */
export interface MenuTreeListRespDTO {
  children?: MenuTreeListRespDTO[];
  component?: string;
  icon?: string;
  id?: string;
  name?: string;
  parentId?: string;
  path?: string;
  redirect?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  visible?: number;
}

/** MenuTreeRespDTO */
export interface MenuTreeRespDTO {
  children?: MenuTreeRespDTO[];
  icon?: string;
  id?: string;
  label?: string;
  path?: string;
  /** @format int32 */
  size?: number;
  /** @format int32 */
  type?: number;
  users?: ManageUserRespDTO[];
  /** @format int32 */
  visible?: number;
}

/** Meta */
export interface Meta {
  icon?: string;
  roles?: string[];
  title?: string;
}

/** ModifyPurchaseRecordDTO */
export interface ModifyPurchaseRecordDTO {
  /** @format int64 */
  customerId?: number;
  originUserName?: string;
  userId?: string;
  userName?: string;
}

/** MoveUserDepartmentReqDTO */
export interface MoveUserDepartmentReqDTO {
  deptId?: string;
  userList?: string[];
}

/** NotifyPrivatePublishVO */
export interface NotifyPrivatePublishVO {
  content?: string;
  /** @format int64 */
  targetCustomerShopId?: number;
  title?: string;
}

/** NotifyPrivateReadVO */
export interface NotifyPrivateReadVO {
  /** @format int64 */
  notifyTemplatePrivateId?: number;
  /** @format int32 */
  operateType?: number;
}

/** NotifyPrivateVO */
export interface NotifyPrivateVO {
  content?: string;
  /** @format date-time */
  createTime?: string;
  extraContent?: string;
  hyperlink?: string;
  hyperlinkParams?: string;
  notifyStatus?: boolean;
  /** @format int64 */
  notifyTemplateId?: number;
  /** @format int64 */
  notifyTemplatePrivateId?: number;
  notifyType?: string;
  /** @format int32 */
  operateType?: number;
  sourceBizId?: string;
  sourceBizType?: string;
  sourceId?: string;
  /** @format int64 */
  targetCustomerId?: number;
  /** @format int64 */
  targetCustomerShopId?: number;
  targetCustomerShopName?: string;
  targetLoginName?: string;
  /** @format int64 */
  targetMainCustomerId?: number;
  targetMainReadStatus?: boolean;
  /** @format date-time */
  targetMainReadTime?: string;
  targetSubReadStatus?: boolean;
  /** @format date-time */
  targetSubReadTime?: string;
  targetSystemSource?: string;
  title?: string;
  /** @format date-time */
  updateTime?: string;
}

/** NotifyPublicReadVO */
export interface NotifyPublicReadVO {
  /** @format int64 */
  notifyTemplatePublicId?: number;
}

/** NotifyPublicVO */
export interface NotifyPublicVO {
  content?: string;
  /** @format date-time */
  createTime?: string;
  hyperlink?: string;
  hyperlinkParams?: string;
  notifyStatus?: boolean;
  /** @format int64 */
  notifyTemplateId?: number;
  /** @format int64 */
  notifyTemplatePublicId?: number;
  notifyType?: string;
  readStatus?: boolean;
  /** @format date-time */
  readTime?: string;
  sourceBizId?: string;
  sourceBizType?: string;
  sourceId?: string;
  title?: string;
  /** @format date-time */
  updateTime?: string;
}

/** NotifyTemplateUpsertVO */
export interface NotifyTemplateUpsertVO {
  content?: string;
  contentListEnd?: string;
  contentListStart?: string;
  /** @format date-time */
  createTime?: string;
  description?: string;
  hyperlink?: string;
  /** @format int32 */
  isContentList?: number;
  /** @format int64 */
  isMarketingNotification?: number;
  isNeedShopName?: boolean;
  langcode?: string;
  /** @format int64 */
  notifyTemplateId?: number;
  notifyTemplateType?: string;
  notifyType?: string;
  title?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OpenBaseReqDto */
export interface OpenBaseReqDto {
  /** app key */
  appKey?: string;
  /** sign */
  sign?: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp?: number;
}

/** OpenShopListRespDTO */
export interface OpenShopListRespDTO {
  /**
   * customer shop id
   * @format int64
   */
  customerShopId?: number;
  /** customer shop name */
  customerShopName?: string;
  /** customer shop url */
  customerShopUrl?: string;
}

/** OrderItem */
export interface OrderItem {
  asc?: boolean;
  column?: string;
}

/** PageMenuReqDTO */
export interface PageMenuReqDTO {
  menuId?: string;
  name?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** @format int32 */
  visible?: number;
}

/** PasswordLoginReqDTO */
export interface PasswordLoginReqDTO {
  /** @format int32 */
  buType?: number;
  nameOrEmail?: string;
  password?: string;
  /** @format int32 */
  platformType?: number;
  recaptchaCode?: string;
  stationCode?: string;
  /** 三方平台用户账号,可以理解为唯一标识 */
  thirdCustomerId?: string;
  /** 三方平台用户名称 */
  thirdCustomerName?: string;
  /** 三方平台用户邮箱 */
  thirdEmail?: string;
  /** 三方平台标识 */
  thirdPlatform?: string;
}

/** QueryCustomerByManagerDTO */
export interface QueryCustomerByManagerDTO {
  /** @format int32 */
  accountType?: number;
  /** @format int64 */
  autoRenawal?: number;
  /** @format int64 */
  beforeWareCode?: number;
  /**
   * 业务类型 0 直采 1 代采
   * @format int32
   */
  buType?: number;
  chatWorkId?: string;
  corpName?: string;
  countryCode?: string;
  countryPlaceCode?: string;
  /** @format date-time */
  createTimeEnd?: string;
  /** @format date-time */
  createTimeStart?: string;
  /** @format int64 */
  currentCode?: number;
  customerEmail?: string;
  /** @format int64 */
  customerId?: number;
  customerIdList?: number[];
  customerIds?: number[];
  customerMobile?: string;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopIds?: number[];
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  defaultLogin?: number;
  /** @format int32 */
  gender?: number;
  /** @format int64 */
  hasAssignSuccess?: number;
  /** @format int64 */
  hasSub?: number;
  /** @format int32 */
  internalFlag?: number;
  /** 语言代码:ja-日语,en-英语,th-泰语,ko-韩语 */
  langcode?: string;
  /** @format date-time */
  lastLoginTime?: string;
  loginName?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int64 */
  managerId?: number;
  /** @format int64 */
  marketingManagerId?: number;
  /** @format int64 */
  membershipId?: number;
  /** @format int64 */
  onlyBelongMe?: number;
  outsideLink?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  password?: string;
  /**
   * 平台类型:1网页端,2APP 3PLUGIN,4H5
   * @format int32
   */
  platformType?: number;
  salt?: string;
  skype?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
  /** @format int64 */
  supervisionManagerId?: number;
  /** @format int32 */
  systemSource?: number;
  tags?: number[];
  unificationCustomerFullName?: string;
  userId?: string;
  userName?: string;
  /** @format int64 */
  wareCode?: number;
}

/** QueryCustomerDetailManagerReqDTO */
export interface QueryCustomerDetailManagerReqDTO {
  customerStatusList?: number[];
  /** @format int64 */
  managerId?: number;
  marketingAndCustomerManagerFlag?: boolean;
  /** @format int64 */
  marketingManagerId?: number;
  /** @format int64 */
  supervisionManagerId?: number;
}

/** QueryCustomerDetailReqDTO */
export interface QueryCustomerDetailReqDTO {
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
}

/** QueryCustomerDistributeReqDTO */
export interface QueryCustomerDistributeReqDTO {
  /** @format int32 */
  merchandiserUserEmptyFlag?: number;
  merchandiserUserId?: string;
  /** @format int32 */
  oemPurchaseUserEmptyFlag?: number;
  oemPurchaseUserId?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  purchaseUserEmptyFlag?: number;
  purchaseUserId?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
  wareCode?: string;
}

/** QueryCustomerDistributeRespDTO */
export interface QueryCustomerDistributeRespDTO {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  merchandiserUserId?: string;
  merchandiserUserName?: string;
  nationCode?: string;
  oemPurchaseUserId?: string;
  oemPurchaseUserName?: string;
  purchaseUserId?: string;
  purchaseUserName?: string;
  stationCode?: string;
  /** @format int32 */
  systemSource?: number;
  unificationCustomerFullName?: string;
  wareCode?: string;
  wareName?: string;
}

/** QueryOperateLogRespDTO */
export interface QueryOperateLogRespDTO {
  content?: string;
  /** @format date-time */
  createTime?: string;
  userName?: string;
}

/** QueryWorkbenchBannerReqDTO */
export interface QueryWorkbenchBannerReqDTO {
  /**
   * 结束时间
   * @format date-time
   */
  endTime?: string;
  /**
   * 类型,1重要公告，2热门活动，3功能更新
   * @format int32
   */
  functionType?: number;
  /**
   * 开始时间
   * @format date-time
   */
  startTime?: string;
  /** 站点 */
  stationCode?: string;
  /**
   * 业务类型：1-D2C,2-B2B
   * @format int32
   */
  systemSource?: number;
}

/** RegisterPageImageBackendDTO */
export interface RegisterPageImageBackendDTO {
  /** 图片地址 */
  imageUrl?: string;
  /** 跳转链接 */
  jumpUrl?: string;
  /**
   * id
   * @format int64
   */
  registerPageImageId?: number;
  /** 站点code */
  stationCode?: string;
}

/** RegisterPageImageBackendUpdateDTO */
export interface RegisterPageImageBackendUpdateDTO {
  /** 图片地址 */
  imageUrl?: string;
  /** 跳转链接 */
  jumpUrl?: string;
  /**
   * id
   * @format int64
   */
  registerPageImageId?: number;
  /** 站点code */
  stationCode?: string;
}

/** RegisterPageImageDTO */
export interface RegisterPageImageDTO {
  /** 图片地址 */
  imageUrl?: string;
  /** 跳转链接 */
  jumpUrl?: string;
  /** 站点code */
  stationCode?: string;
}

/** ReserveCallBackReqDTO */
export interface ReserveCallBackReqDTO {
  AccountID?: string;
  ActivityID?: string;
  ActivityName?: string;
  EventType?: string;
  LiveTime?: string;
  RequestUuid?: string;
  Sign?: string;
  Timestamp?: string;
  UserInfos?: UserReservationInfo[];
  ViewUrl?: string;
}

/** ResetPasswordReqDTO */
export interface ResetPasswordReqDTO {
  customerEmail?: string;
  /** 手机号 */
  customerMobile?: string;
  /** 国际区号 */
  globalRoaming?: string;
  newPassword?: string;
  stationCode?: string;
  verificationCode?: string;
}

/** RoleUserRespDTO */
export interface RoleUserRespDTO {
  /** @format int32 */
  count?: number;
  departmentName?: string;
  mobile?: string;
  nickname?: string;
  userId?: string;
  userName?: string;
}

/** RouteRespDTO */
export interface RouteRespDTO {
  alwaysShow?: boolean;
  children?: RouteRespDTO[];
  hidden?: boolean;
  id?: string;
  meta?: Meta;
  name?: string;
  path?: string;
  redirect?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  type?: number;
}

/** SaveCustomerConfigReqDTO */
export interface SaveCustomerConfigReqDTO {
  /** 配置 code */
  configCode?: string;
  /** 配置名称 */
  configName?: string;
  /** 配置值 */
  configValue?: string;
}

/** SaveOrUpdateCustomerConfigReqDTO */
export interface SaveOrUpdateCustomerConfigReqDTO {
  /** 配置 code */
  configCode?: string;
  /** 配置名称 */
  configName?: string;
  /** 配置值 */
  configValue?: string;
  /**
   * 子账号id
   * @format int64
   */
  customerId?: number;
  /**
   * 级别 1-superCustomerId 2-mainCustomerId 3-customerId
   * @format int32
   */
  level?: number;
  /**
   * 主账号id
   * @format int64
   */
  mainCustomerId?: number;
  /**
   * 超级用户id
   * @format int64
   */
  superCustomerId?: number;
}

/** SaveWorkbenchBannerReqDTO */
export interface SaveWorkbenchBannerReqDTO {
  /** 跳转链接 */
  dumpUrl?: string;
  /**
   * 结束时间
   * @format date-time
   */
  endTime?: string;
  /** 外国名称 */
  foreignName?: string;
  /**
   * 类型,1重要公告，2热门活动，3功能更新
   * @format int32
   */
  functionType?: number;
  /**
   * 主键
   * @format int64
   */
  id?: number;
  /** 图片 */
  img?: string;
  /** 名称 */
  name?: string;
  /**
   * 开始时间
   * @format date-time
   */
  startTime?: string;
  /** 站点 */
  stationCode?: string;
  /**
   * 是否生效，1失效，0生效
   * @format int32
   */
  status?: number;
  /**
   * 业务类型：1-D2C,2-B2B
   * @format int32
   */
  systemSource?: number;
}

/** SearchResultDTO */
export interface SearchResultDTO {
  /**
   * 图搜剩余次数
   * @format int32
   */
  imageSearchKey?: number;
  /**
   * 图搜最大次数
   * @format int32
   */
  imageSearchKeyMax?: number;
  /**
   * 价格跟踪剩余次数
   * @format int32
   */
  priceTrackingTimes?: number;
  /**
   * 价格跟踪最大次数
   * @format int32
   */
  priceTrackingTimesMax?: number;
  /**
   * 关键字搜索剩余次数
   * @format int32
   */
  searchKeywordKey?: number;
  /**
   * 关键字搜索最大次数
   * @format int32
   */
  searchKeywordKeyMax?: number;
}

/** SelectTypeDicDTO */
export interface SelectTypeDicDTO {
  /** 业务类型 */
  businessType?: string;
  /** 站点code */
  stationCode?: string;
  /** key */
  typeKey?: string;
  /** value */
  typeValue?: string;
}

/** ShopAdditionAddressRespDTO */
export interface ShopAdditionAddressRespDTO {
  additionItemList?: AdditionItemRespDTO[];
  /** @format int32 */
  additionScene?: number;
  addressAdditionRespDTO?: ShopAddressAdditionRespDTO;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  customerShopShipRespDTOList?: CustomerShopShipRespDTO[];
  /** @format int64 */
  shopAdditionId?: number;
  /** @format int32 */
  systemSource?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ShopAdditionDetailRespDTO */
export interface ShopAdditionDetailRespDTO {
  additionItemList?: AdditionItemRespDTO[];
  /** @format int32 */
  additionScene?: number;
  categoryAdditionList?: CategoryAdditionRespDTO[];
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  shopAdditionId?: number;
  shopAddressAdditionRespDTO?: ShopAddressAdditionRespDTO;
  /** @format int32 */
  systemSource?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ShopAdditionRespDTO */
export interface ShopAdditionRespDTO {
  additionItemList?: AdditionItemRespDTO[];
  /** @format int32 */
  additionScene?: number;
  categoryAdditionList?: CategoryAdditionRespDTO[];
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  noAdditionalFlag?: number;
  /** @format int64 */
  shopAdditionId?: number;
  /** 水洗标配置 */
  shopAdditionWashedLabelRespDTO?: WashedLabelRespDTOV2[];
  /** @format int32 */
  systemSource?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ShopAdditionWashedLabelRespDTO */
export interface ShopAdditionWashedLabelRespDTO {
  /** @format int32 */
  additionScene?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  shopAdditionId?: number;
  /** @format int32 */
  systemSource?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
  washedLabelRespDTOList?: WashedLabelRespDTO[];
}

/** ShopAddressAdditionReqDTO */
export interface ShopAddressAdditionReqDTO {
  address?: string;
  area?: string;
  city?: string;
  countryCode?: string;
  email?: string;
  /** @format int64 */
  logisticsId?: number;
  logisticsName?: string;
  postalCode?: string;
  sendName?: string;
  sendTel?: string;
}

/** ShopAddressAdditionRespDTO */
export interface ShopAddressAdditionRespDTO {
  address?: string;
  area?: string;
  city?: string;
  countryCode?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  email?: string;
  postalCode?: string;
  sendName?: string;
  sendTel?: string;
  /** @format int64 */
  shopAdditionId?: number;
  /** @format int64 */
  shopAddressAdditionId?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ShopClearanceAddressRespDTO */
export interface ShopClearanceAddressRespDTO {
  address?: string;
  addressEn?: string;
  area?: string;
  areaEn?: string;
  city?: string;
  cityEn?: string;
  /** 市名称 */
  cityName?: string;
  clearanceCode?: string;
  /** @format int32 */
  clearanceType?: number;
  companyCode?: string;
  companyName?: string;
  companyNameEn?: string;
  countryCode?: string;
  /** 国家名称 */
  countryName?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  defaultAddress?: number;
  email?: string;
  exportCountry?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家id */
  nationId?: string;
  phone?: string;
  postalCode?: string;
  /** 省名称 */
  provinceName?: string;
  receiveName?: string;
  receiveNameEn?: string;
  /** @format int64 */
  shopClearanceAddressId?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ShopOverviewRespDTO */
export interface ShopOverviewRespDTO {
  availableAmount?: number;
  /** @format int64 */
  customerId?: number;
  customerShop?: AppShopRespDTO;
  /** @format int32 */
  customerStatus?: number;
  /** @format int32 */
  gender?: number;
  /** @format int64 */
  mainCustomerId?: number;
  /** @format int32 */
  systemSource?: number;
}

/** ShopPurchaseRespDTO */
export interface ShopPurchaseRespDTO {
  /**
   * api自动下单配置 1-每次询问 2-不询问，以一件代发价下单
   * @format int32
   */
  apiAutoCreateOrderType?: number;
  /** 创建时间 */
  createTime?: string;
  /**
   * 用户店铺id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 发货配置项,0:每次联系 1:无需联络 2:普通无需,组合需要
   * @format int32
   */
  deliveryConfigurationType?: number;
  /**
   * 次品付费重购,0:其他 1:接受次品重拍 2:次品退货退款
   * @format int32
   */
  payRepurchaseType?: number;
  /**
   * 能接受的采购价格上涨幅度
   * @format int32
   */
  purchasePriceAdd?: number;
  /** @format int32 */
  repurchaseFree?: number;
  /** @format int32 */
  repurchasePrice?: number;
  /** @format int32 */
  repurchaseTryMax?: number;
  /**
   * 主键
   * @format int64
   */
  shopPurchaseId?: number;
  /** 更新时间 */
  updateTime?: string;
}

/** ShopShipMappingDTO */
export interface ShopShipMappingDTO {
  countryCode?: string;
  /** @format int64 */
  newLogisticsId?: number;
  newLogisticsLogo?: string;
  newLogisticsName?: string;
  /** @format int64 */
  oldLogisticsId?: number;
}

/** ShopShippingAddressRespDTO */
export interface ShopShippingAddressRespDTO {
  address?: string;
  addressEn?: string;
  area?: string;
  areaEn?: string;
  city?: string;
  cityEn?: string;
  /** 市名称 */
  cityName?: string;
  countryCode?: string;
  /** 国家名称 */
  countryName?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  defaultAddress?: number;
  email?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家id */
  nationId?: string;
  phone?: string;
  postalCode?: string;
  /** 省名称 */
  provinceName?: string;
  receiveName?: string;
  receiveNameEn?: string;
  /** @format int64 */
  shopShippingAddressId?: number;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/** ShopTaxDeductionAccountPageDTO */
export interface ShopTaxDeductionAccountPageDTO {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
}

/** ShopTaxDeductionAccountRespDTO */
export interface ShopTaxDeductionAccountRespDTO {
  branchCode?: string;
  /** @format int64 */
  customerShopId?: number;
  financialInstitutionCode?: string;
  /** @format int64 */
  id?: number;
  importerCode?: string;
  /** @format int32 */
  isDefault?: number;
  taxDeductionAccount?: string;
}

/** ShopWashedLabelAdditionReqDTO */
export interface ShopWashedLabelAdditionReqDTO {
  /** 会社地址 */
  companyAddress?: string;
  /** 会社logo */
  companyLogo?: string;
  /** 会社名 */
  companyName?: string;
  /**
   * 图片比例: 1比1-1,16比9-2
   * @format int32
   */
  imageRatio?: number;
  /**
   * 是否默认: 0-否,1-是
   * @format int32
   */
  isDefault?: number;
  /**
   * 模板: 竖向-1,横向-2
   * @format int32
   */
  model?: number;
  /**
   * 商品番号: 不使用商品番号-1,商品番号-2,客户商品sku-3
   * @format int32
   */
  productDesignation?: number;
  /**
   * 附加项配置表id
   * @format int64
   */
  shopAdditionId?: number;
  /** 水洗标名称 */
  washedlabelName?: string;
}

/** SignUpReqDTO */
export interface SignUpReqDTO {
  /**
   * 业务类型 0直采 1代采
   * @format int32
   */
  buType?: number;
  /** 渠道 */
  channel?: string;
  /** chartWorkId */
  chatWorkId?: string;
  /** 公司名称 */
  corpName?: string;
  /** 区号 */
  countryCode?: string;
  /** 国家code */
  countryPlaceCode?: string;
  /** 邮箱地址 */
  customerEmail?: string;
  /** 客户手机号 */
  customerMobile?: string;
  /** 联系人姓名 */
  customerName?: string;
  /**
   * 客户状态：1-正常；2-停用
   * @format int32
   * @example 1
   */
  customerStatus?: number;
  /** 拓展参数，埋点信息等 */
  ext?: Record<string, object>;
  /**
   * 性别：1-男；2-女；3-未知
   * @format int32
   * @example 1
   */
  gender?: number;
  /**
   * 是否初始化店铺 0：否，1：是
   * @format int32
   */
  initShopFlag?: number;
  /** 三方邀请码 */
  invitationCode?: string;
  /**
   * 邀请平台:0-内部,1-aucfan
   * @format int32
   */
  invitationPlatform?: number;
  /** 语言代码 */
  langcode?: string;
  /** 登录名 */
  loginName?: string;
  /** 登录密码 */
  password?: string;
  /**
   * 平台类型:1网页端,2APP,3插件,4H5
   * @format int32
   */
  platformType?: number;
  /** 三方推荐邮箱 */
  recommendationEmail?: string;
  /** skype */
  skype?: string;
  /** spm */
  spm?: string;
  /** 站点code */
  stationCode?: string;
  /**
   * 隐私协议id
   * @format int64
   */
  termId?: number;
  /** 三方平台用户账号,可以理解为唯一标识 */
  thirdCustomerId?: string;
  /** 三方平台用户名称 */
  thirdCustomerName?: string;
  /** 三方平台用户邮箱 */
  thirdEmail?: string;
  /** 三方平台标识 */
  thirdPlatform?: string;
  /** 时区 */
  utcTimeZone?: string;
  /** 验证码 */
  verificationCode?: string;
}

/** SignUpRespDTO */
export interface SignUpRespDTO {
  uuid?: string;
}

/** SupportCenterContentDTO */
export interface SupportCenterContentDTO {
  /** 业务类型: 2B, 2C */
  bizType?: string;
  /** content */
  content?: string;
  /** 内容类型: text, video */
  contentType?: string;
  /** 内容url */
  contentUrl?: string;
  /**
   * 发生时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 创建者id
   * @format int64
   */
  creator?: number;
  /** 描述 */
  description?: string;
  /**
   * 修改者id
   * @format int64
   */
  modifier?: number;
  /** @format int64 */
  parentSupportCenterSubjectId?: number;
  /** SEO 描述 */
  seoDescription?: string;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  /** 站点code */
  stationCode?: string;
  /**
   * id
   * @format int64
   */
  supportCenterContentId?: number;
  /**
   * 所属分类id
   * @format int64
   */
  supportCenterSubjectId?: number;
  /** 标题 */
  title?: string;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
  /** 封面图片 */
  videoImageUrl?: string;
}

/** SupportCenterContentUpdateBackendDTO */
export interface SupportCenterContentUpdateBackendDTO {
  /** 业务类型: 2B, 2C */
  bizType?: string;
  /** 内容 */
  content?: string;
  /** 内容类型: text, video */
  contentType?: string;
  /** 描述 */
  description?: string;
  /** SEO 描述 */
  seoDescription?: string;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  /** 站点code */
  stationCode?: string;
  /**
   * id
   * @format int64
   */
  supportCenterContentId?: number;
  /**
   * 所属分类id
   * @format int64
   */
  supportCenterSubjectId?: number;
  /** 标题 */
  title?: string;
  /** 封面图片 */
  videoImageUrl?: string;
}

/** SupportCenterSubjectDTO */
export interface SupportCenterSubjectDTO {
  /** 业务类型: 2B, 2C */
  bizType?: string;
  /** 子目录集合 */
  childrenList?: SupportCenterSubjectDTO[];
  /** 下属的文档 */
  contentList?: SupportCenterContentDTO[];
  /** 菜单类型： video；text */
  contentType?: string;
  /**
   * 发生时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 创建者id
   * @format int64
   */
  creator?: number;
  /** 描述 */
  description?: string;
  /**
   * 修改者id
   * @format int64
   */
  modifier?: number;
  /**
   * 父级分类id
   * @format int64
   */
  parentSupportCenterSubjectId?: number;
  /** 路径 */
  path?: string;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  /** 站点code */
  stationCode?: string;
  /** 分类名称 */
  subject?: string;
  /**
   * id
   * @format int64
   */
  supportCenterSubjectId?: number;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** SupportCenterSubjectUpdateBackendDTO */
export interface SupportCenterSubjectUpdateBackendDTO {
  /** 业务类型: 2B, 2C */
  bizType?: string;
  /** 描述 */
  description?: string;
  /**
   * 父级分类id
   * @format int64
   */
  parentSupportCenterSubjectId?: number;
  /** 路径 */
  path?: string;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  /** 站点code */
  stationCode?: string;
  /** 分类名称 */
  subject?: string;
  /**
   * id
   * @format int64
   */
  supportCenterSubjectId?: number;
}

/** TakeUserAddReqDTO */
export interface TakeUserAddReqDTO {
  /** @format int32 */
  cityId?: number;
  email?: string;
  password?: string;
  takeUserMallReqDTOList?: TakeUserMallReqDTO[];
  username?: string;
}

/** TakeUserEditReqDTO */
export interface TakeUserEditReqDTO {
  /** @format int32 */
  cityId?: number;
  email?: string;
  password?: string;
  /** @format int64 */
  takeUserId?: number;
  takeUserMallReqDTOList?: TakeUserMallReqDTO[];
  username?: string;
}

/** TakeUserLoginReqDTO */
export interface TakeUserLoginReqDTO {
  email?: string;
  password?: string;
}

/** TakeUserMallReqDTO */
export interface TakeUserMallReqDTO {
  mallId?: string;
  mallName?: string;
}

/** TakeUserReqDTO */
export interface TakeUserReqDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  username?: string;
}

/** TakeUserRespDTO */
export interface TakeUserRespDTO {
  /** @format int32 */
  cityId?: number;
  /** @format date-time */
  createTime?: string;
  email?: string;
  mallId?: string;
  mallName?: string;
  password?: string;
  /** @format int64 */
  takeUserId?: number;
  /** @format date-time */
  updateTime?: string;
  username?: string;
}

/** TermConfigDTO */
export interface TermConfigDTO {
  /**
   * 客户同意时间
   * @format date-time
   */
  agreeTime?: string;
  /**
   * 发生时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 创建者id
   * @format int64
   */
  creator?: number;
  /** 创建者名称 */
  creatorName?: string;
  /** 配置地址 */
  fileUrl?: string;
  /**
   * 是否生效: 0 未生效, 1 生效中
   * @format int32
   */
  isEffect?: number;
  /**
   * 修改者id
   * @format int64
   */
  modifier?: number;
  /** 修改者名称 */
  modifierName?: string;
  /** 站点code */
  stationCode?: string;
  /**
   * 条款id
   * @format int64
   */
  termId?: number;
  /** 条款类型: utilize:利用规约, privacy:隐私权限, regular:次转正提醒, oem:oem条款 */
  termType?: string;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** TermUpdateDTO */
export interface TermUpdateDTO {
  content?: string;
  /** @format int64 */
  termId?: number;
}

/** ThirdIsBindRespDTO */
export interface ThirdIsBindRespDTO {
  /** 是否已绑定 */
  isBind?: boolean;
  /** 是否为新注册用户 */
  isNew?: boolean;
}

/** Type */
export interface Type {
  typeName?: string;
}

/** UpdateAdditionAddressReqDTO */
export interface UpdateAdditionAddressReqDTO {
  additionList?: AddAdditionItemReqDTO[];
  /** @format int32 */
  additionScene?: number;
  addressAddition?: ShopAddressAdditionReqDTO;
  /** 仓库编码 */
  warehouseCode?: string;
}

/** UpdateAdditionReqDTO */
export interface UpdateAdditionReqDTO {
  /** 配置项id集合 */
  additionList?: AddAdditionItemReqDTO[];
  /** 国际发货配置 */
  addressAddition?: ShopAddressAdditionReqDTO;
  /** 品类id集合 */
  categoryCodeList?: number[];
  /**
   * 无附加项标志 0 需要附加项 1 不需要附加项
   * @format int32
   */
  noAdditionalFlag?: number;
  /**
   * 主键
   * @format int64
   */
  shopAdditionId?: number;
}

/** UpdateAdditionWashedLabelReqDTO */
export interface UpdateAdditionWashedLabelReqDTO {
  /** @format int32 */
  additionScene?: number;
  /** @format int64 */
  customerShopId?: number;
  shopAdditionId?: string;
  washedLabelAdditionReqDTOs?: ShopWashedLabelAdditionReqDTO[];
}

/** UpdateBannerReqDTO */
export interface UpdateBannerReqDTO {
  /** @format int64 */
  bannerApplicableTemplateId?: number;
  bannerDesignatedUserId?: string;
  /** @format int64 */
  bannerId?: number;
  /** banner图片url-H5页面 */
  bannerImgMobileUrl?: string;
  bannerImgUrl?: string;
  bannerJumpLink?: string;
  bannerName?: string;
  /** @format int32 */
  bannerStatus?: number;
  /** @format int32 */
  bannerType?: number;
  /** @format date-time */
  endTime?: string;
  /** @format int64 */
  mallCategoryId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format int32 */
  systemSource?: number;
}

/** UpdateClearanceAddressReqDTO */
export interface UpdateClearanceAddressReqDTO {
  address?: string;
  addressEn?: string;
  area?: string;
  areaEn?: string;
  city?: string;
  cityEn?: string;
  /** 市名称 */
  cityName?: string;
  /** 通关码 */
  clearanceCode?: string;
  /** @format int32 */
  clearanceType?: number;
  companyCode?: string;
  companyName?: string;
  companyNameEn?: string;
  /** 国家名称 */
  countryName?: string;
  /** @format int32 */
  defaultAddress?: number;
  email?: string;
  /** 出口国家 KR CN */
  exportCountry?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家id */
  nationId?: string;
  phone?: string;
  postalCode?: string;
  /** 省名称 */
  provinceName?: string;
  receiveName?: string;
  receiveNameEn?: string;
  shopClearanceAddressId?: string;
}

/** UpdateClearanceDefaultAddressReqDTO */
export interface UpdateClearanceDefaultAddressReqDTO {
  /** @format int64 */
  shopClearanceAddressId?: number;
}

/** UpdateCustomerReqDTO */
export interface UpdateCustomerReqDTO {
  chatWorkId?: string;
  corpName?: string;
  countryCode?: string;
  /** @format int64 */
  customerId?: number;
  customerMobile?: string;
  customerName?: string;
  /** @format int32 */
  gender?: number;
  googleUrl?: string;
  loginName?: string;
  skype?: string;
  /** @format int32 */
  systemSource?: number;
}

/** UpdateCustomerShopDTO */
export interface UpdateCustomerShopDTO {
  clientId?: string;
  clientSecret?: string;
  /** @format int32 */
  customerShopAuthStatus?: number;
  /** @format int64 */
  customerShopId?: number;
  customerShopLogo?: string;
  customerShopName?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  customerShopUrl?: string;
  wareCode?: string;
}

/** UpdateDepartmentReqDTO */
export interface UpdateDepartmentReqDTO {
  directorId?: string;
  id?: string;
  name?: string;
  /** @format int32 */
  sort?: number;
}

/** UpdateFrogArticleReqDTO */
export interface UpdateFrogArticleReqDTO {
  frogArticleContent?: string;
  /** @format int32 */
  frogArticleEnableStatus?: number;
  /** @format int64 */
  frogArticleId?: number;
  frogArticleImgUrl?: string;
  frogArticleSubTitle?: string;
  frogArticleTitle?: string;
  /** @format int32 */
  frogArticleType?: number;
  /**
   * 文章类型Id
   * @format int64
   */
  frogArticleTypeId?: number;
  /** @format int64 */
  frogArticleViewCount?: number;
  /**
   * 未登录限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noLoginRestriction?: number;
  /**
   * 未入会限制；1.可查看全文；2.部分可查看；3.不可查看
   * @format int32
   */
  noMembershipRestriction?: number;
  /** SEO 描述 */
  seoDescription?: string;
  /** @format int32 */
  showMall?: number;
  stationCode?: string;
}

/** UpdateFrogArticleStatusReqDTO */
export interface UpdateFrogArticleStatusReqDTO {
  /** @format int32 */
  articalVersionFlag?: number;
  /** @format int64 */
  frogArticleId?: number;
}

/** UpdateManageBannerReqDTO */
export interface UpdateManageBannerReqDTO {
  /** @format int64 */
  bannerId?: number;
}

/** UpdateManageUserReqDTO */
export interface UpdateManageUserReqDTO {
  avatar?: string;
  deptId?: string;
  /** @format int32 */
  directoried?: number;
  email?: string;
  /** @format int32 */
  gender?: number;
  id?: string;
  mobile?: string;
  nickname?: string;
  password?: string;
  relationDd?: string;
  relationDdDeptId?: string;
  relationDdDeptName?: string;
  relationDdUserId?: string;
  relationDdUserName?: string;
  roleIds?: string[];
  /** @format int32 */
  status?: number;
  username?: string;
  wareCode?: string[];
}

/** UpdateManagerPasswordReqDTO */
export interface UpdateManagerPasswordReqDTO {
  id?: string;
  newPassword?: string;
  oldPassword?: string;
}

/** UpdateMenuReqDTO */
export interface UpdateMenuReqDTO {
  backEndPath?: string;
  btnPerm?: string;
  code?: string;
  icon?: string;
  id?: string;
  name?: string;
  redirect?: string;
  routeName?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  type?: number;
  /** @format int32 */
  visible?: number;
}

/** UpdateMenuVisibleReqDTO */
export interface UpdateMenuVisibleReqDTO {
  id?: string;
  /** @format int32 */
  visible?: number;
}

/** UpdatePasswordReqDTO */
export interface UpdatePasswordReqDTO {
  /** @format int64 */
  customerId?: number;
  newPassword?: string;
  oldPassword?: string;
}

/**
 * UpdatePasswordReqManagerDTO
 * 更新管理员密码DTO
 */
export interface UpdatePasswordReqManagerDTO {
  id?: string;
  password?: string;
  /** @format int32 */
  status?: number;
}

/** UpdateRoleMenusReqDTO */
export interface UpdateRoleMenusReqDTO {
  id?: string;
  menuIds?: string[];
}

/** UpdateRoleReqDTO */
export interface UpdateRoleReqDTO {
  id?: string;
  name?: string;
  remark?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
}

/** UpdateShippingAddressReqDTO */
export interface UpdateShippingAddressReqDTO {
  address?: string;
  addressEn?: string;
  area?: string;
  areaEn?: string;
  city?: string;
  cityEn?: string;
  /** 市名称 */
  cityName?: string;
  countryCode?: string;
  /** 国家名称 */
  countryName?: string;
  /** @format int32 */
  defaultAddress?: number;
  email?: string;
  /** 国家代码 */
  nationCode?: string;
  /** 国家id */
  nationId?: string;
  phone?: string;
  postalCode?: string;
  /** 省名称 */
  provinceName?: string;
  receiveName?: string;
  receiveNameEn?: string;
  shopShippingAddressId?: string;
}

/** UpdateShippingDefaultAddressReqDTO */
export interface UpdateShippingDefaultAddressReqDTO {
  shopShippingAddressId?: string;
}

/** UpdateShopDeliveryReqDTO */
export interface UpdateShopDeliveryReqDTO {
  /** @format int64 */
  customerShopId?: number;
  /**
   * 发货配置项,0:每次联系 1:无需联络 2:普通无需,组合需要
   * @format int32
   */
  deliveryConfigurationType?: number;
  /** @format date-time */
  updateTime?: string;
}

/** UpdateShopPurchaseReqDTO */
export interface UpdateShopPurchaseReqDTO {
  /**
   * api自动下单配置 1-每次询问 2-不询问，以一件代发价下单
   * @format int32
   */
  apiAutoCreateOrderType?: number;
  /**
   * 店铺id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 发货配置项,0:每次联系 1:无需联络 2:普通无需,组合需要
   * @format int32
   */
  deliveryConfigurationType?: number;
  /**
   * 次品付费重购,0:其他 1:接受次品重拍 2:次品退货退款
   * @format int32
   */
  payRepurchaseType?: number;
  /**
   * 能接受的采购价格上涨幅度
   * @format int32
   */
  purchasePriceAdd?: number;
  /**
   * 更新渠道:1-接口2-feign
   * @format int32
   */
  updateChannel?: number;
}

/** UpdateShopTaxDeductionAccountDTO */
export interface UpdateShopTaxDeductionAccountDTO {
  /** 分行代码 */
  branchCode?: string;
  /** 金融机构代码 */
  financialInstitutionCode?: string;
  /**
   * 唯一ID
   * @format int64
   */
  id?: number;
  /** 进口商标准代码 */
  importerCode?: string;
  /**
   * 是否是默认设置 0 否 1 是
   * @format int32
   */
  isDefault?: number;
  /** 扣税账号 */
  taxDeductionAccount?: string;
}

/** UpdateWareOemReqDTO */
export interface UpdateWareOemReqDTO {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  isExistOem?: number;
}

/** UserManagerDetailRespDTO */
export interface UserManagerDetailRespDTO {
  businessRepresentativeId?: string;
  businessRepresentativeName?: string;
  customerDirectorId?: string;
  customerDirectorName?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
}

/** UserReservationInfo */
export interface UserReservationInfo {
  ExternalID?: string;
  Extra?: string;
  NickName?: string;
  ReservationTel?: string;
  UserAccessIP?: string;
  UserAgent?: string;
  UserID?: string;
}

/** UserWarehouseRespDTO */
export interface UserWarehouseRespDTO {
  /** @format date-time */
  createTime?: string;
  manageUserId?: string;
  /** @format int64 */
  manageUserWarehouseId?: number;
  wareCode?: string;
  wareName?: string;
}

/**
 * VideoActivityDTO
 * 直播间对象
 */
export interface VideoActivityDTO {
  /**
   * 活动id
   * @format int64
   */
  activityId?: number;
  /**
   * 关播时间
   * @format int64
   */
  closeTime?: number;
  /** 直播间封面 */
  coverImage?: string;
  /**
   * 是否开启显示观看人数 0：关闭 1：开启
   * @format int32
   */
  enablePeopleCount?: number;
  /**
   * 是否开启直播预约功能 0-关闭 1-开启
   * @format int32
   */
  enableReserve?: number;
  /**
   * 开播时间
   * @format int64
   */
  liveTime?: number;
  /** 直播间名称 */
  name?: string;
  /** PC 端页头图的URL */
  pcBackImageUrl?: string;
  /** 默认PC端背景图的URL */
  pcBackImageUrlDefault?: string;
  /** PC端页头图的URL */
  pcHeaderImageUrl?: string;
  /**
   * 直播间预约状态 0-未预约 1-已预约
   * @format int32
   */
  reserveFlag?: number;
  /**
   * 直播状态 1：直播中 2：预告 3：回放 4：停止
   * @format int32
   */
  status?: number;
  /** token 游客模式-1 */
  token?: string;
  /**
   * 播放量
   * @format int64
   */
  uv?: number;
  /** 直播间地址 */
  viewUrl?: string;
}

/** WarehousePojo */
export interface WarehousePojo {
  warehouseCode?: string;
  warehouseCountry?: string;
  warehouseName?: string;
  warehouseNameTranslate?: string;
}

/** WashedLabelRespDTO */
export interface WashedLabelRespDTO {
  /** 会社地址 */
  companyAddress?: string;
  /** 会社logo */
  companyLogo?: string;
  /** 会社名 */
  companyName?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /**
   * 用户店铺id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 图片比例: 1比1-1,16比9-2
   * @format int32
   */
  imageRatio?: number;
  /**
   * 是否默认: 0-否,1-是
   * @format int32
   */
  isDefault?: number;
  /**
   * 模板: 竖向-1,横向-2
   * @format int32
   */
  model?: number;
  /**
   * 商品番号: 不使用商品番号-1,商品番号-2,客户商品sku-3
   * @format int32
   */
  productDesignation?: number;
  /**
   * 附加项配置表id
   * @format int64
   */
  shopAdditionId?: number;
  /**
   * 主键
   * @format int64
   */
  shopAddressWashedlabelId?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
  /** 水洗标名称 */
  washedlabelName?: string;
}

/** WashedLabelRespDTOV2 */
export interface WashedLabelRespDTOV2 {
  /** 会社地址 */
  companyAddress?: string;
  /** 会社logo */
  companyLogo?: string;
  /** 会社名 */
  companyName?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /**
   * 用户店铺id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 图片比例: 1比1-1,16比9-2
   * @format int32
   */
  imageRatio?: number;
  /**
   * 是否默认: 0-否,1-是
   * @format int32
   */
  isDefault?: number;
  /**
   * 模板: 竖向-1,横向-2
   * @format int32
   */
  model?: number;
  /**
   * 商品番号: 不使用商品番号-1,商品番号-2,客户商品sku-3
   * @format int32
   */
  productDesignation?: number;
  /**
   * 附加项配置表id
   * @format int64
   */
  shopAdditionId?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
  /**
   * 主键
   * @format int64
   */
  washedlabelAdditionId?: number;
  /** 水洗标名称 */
  washedlabelName?: string;
}

/** WorkbenchBannerRespDTO */
export interface WorkbenchBannerRespDTO {
  dumpUrl?: string;
  /** @format date-time */
  endTime?: string;
  foreignName?: string;
  /** @format int32 */
  functionType?: number;
  /** @format int64 */
  id?: number;
  img?: string;
  name?: string;
  operator?: string;
  /** @format date-time */
  startTime?: string;
  stationCode?: string;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  systemSource?: number;
}

/** BizResponse«CustomerConfigRespDTO» */
export interface BizResponseCustomerConfigRespDTO {
  code?: string;
  data?: CustomerConfigRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerDetailManagerRespDTO» */
export interface BizResponseCustomerDetailManagerRespDTO {
  code?: string;
  data?: CustomerDetailManagerRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerDetailRespDTO» */
export interface BizResponseCustomerDetailRespDTO {
  code?: string;
  data?: CustomerDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerDistributeQueryRespDTO» */
export interface BizResponseCustomerDistributeQueryRespDTO {
  code?: string;
  data?: CustomerDistributeQueryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerGuide» */
export interface BizResponseCustomerGuide {
  code?: string;
  data?: CustomerGuide;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerLoginRespDTO» */
export interface BizResponseCustomerLoginRespDTO {
  code?: string;
  data?: CustomerLoginRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerMembershipResDTO» */
export interface BizResponseCustomerMembershipResDTO {
  code?: string;
  data?: CustomerMembershipResDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerMembership对象» */
export interface BizResponseCustomerMembership {
  code?: string;
  /** 客户与会员身份关联数据 */
  data?: CustomerMembership;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerOverviewRespDTO» */
export interface BizResponseCustomerOverviewRespDTO {
  code?: string;
  data?: CustomerOverviewRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerRespDTO» */
export interface BizResponseCustomerRespDTO {
  code?: string;
  data?: CustomerRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerShopAddressRespDTO» */
export interface BizResponseCustomerShopAddressRespDTO {
  code?: string;
  data?: CustomerShopAddressRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerShopLimitRespDTO» */
export interface BizResponseCustomerShopLimitRespDTO {
  code?: string;
  data?: CustomerShopLimitRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerShopRespDTO» */
export interface BizResponseCustomerShopRespDTO {
  code?: string;
  data?: CustomerShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«DataDictRespDTO» */
export interface BizResponseDataDictRespDTO {
  code?: string;
  data?: DataDictRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«DepartmentDetailRespDTO» */
export interface BizResponseDepartmentDetailRespDTO {
  code?: string;
  data?: DepartmentDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«EmailSendRespDTO» */
export interface BizResponseEmailSendRespDTO {
  code?: string;
  data?: EmailSendRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«FreeCountRespDTO» */
export interface BizResponseFreeCountRespDTO {
  code?: string;
  data?: FreeCountRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«FrogArticleDetailRespDTO» */
export interface BizResponseFrogArticleDetailRespDTO {
  code?: string;
  data?: FrogArticleDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«FrogArticlePrepAndNextRespDTO» */
export interface BizResponseFrogArticlePrepAndNextRespDTO {
  code?: string;
  data?: FrogArticlePrepAndNextRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«GetActivitiesRespDTO» */
export interface BizResponseGetActivitiesRespDTO {
  code?: string;
  /** 获取直播间列表 */
  data?: GetActivitiesRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«GetThirdDataRespDTO» */
export interface BizResponseGetThirdDataRespDTO {
  code?: string;
  data?: GetThirdDataRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«HashSet«long»» */
export interface BizResponseHashSetLong {
  code?: string;
  data?: number[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«ImportantNoticeDetailDTO» */
export interface BizResponseImportantNoticeDetailDTO {
  code?: string;
  data?: ImportantNoticeDetailDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«IntAreaDTO» */
export interface BizResponseIntAreaDTO {
  code?: string;
  data?: IntAreaDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«InvitationInfoRespDTO» */
export interface BizResponseInvitationInfoRespDTO {
  code?: string;
  data?: InvitationInfoRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«JSONArray» */
export interface BizResponseJSONArray {
  code?: string;
  data?: object[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«JSONObject» */
export interface BizResponseJSONObject {
  code?: string;
  data?: Record<string, object>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«AdditionTemplateRespDTO»» */
export interface BizResponseListAdditionTemplateRespDTO {
  code?: string;
  data?: AdditionTemplateRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CategoryCodeRespDTO»» */
export interface BizResponseListCategoryCodeRespDTO {
  code?: string;
  data?: CategoryCodeRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerCanTransformRespDTO»» */
export interface BizResponseListCustomerCanTransformRespDTO {
  code?: string;
  data?: CustomerCanTransformRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerDetailRespDTO»» */
export interface BizResponseListCustomerDetailRespDTO {
  code?: string;
  data?: CustomerDetailRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerMembershipResDTO»» */
export interface BizResponseListCustomerMembershipResDTO {
  code?: string;
  data?: CustomerMembershipResDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerMembership对象»» */
export interface BizResponseListCustomerMembership {
  code?: string;
  data?: CustomerMembership[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerShopBySuperRespDTO»» */
export interface BizResponseListCustomerShopBySuperRespDTO {
  code?: string;
  data?: CustomerShopBySuperRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerShopPageDTO»» */
export interface BizResponseListCustomerShopPageDTO {
  code?: string;
  data?: CustomerShopPageDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerShopRespDTO»» */
export interface BizResponseListCustomerShopRespDTO {
  code?: string;
  data?: CustomerShopRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerShopShipRespDTO»» */
export interface BizResponseListCustomerShopShipRespDTO {
  code?: string;
  data?: CustomerShopShipRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerStationDTO»» */
export interface BizResponseListCustomerStationDTO {
  code?: string;
  data?: CustomerStationDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerTagDTO»» */
export interface BizResponseListCustomerTagDTO {
  code?: string;
  data?: CustomerTagDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerThirdBindRespDTO»» */
export interface BizResponseListCustomerThirdBindRespDTO {
  code?: string;
  data?: CustomerThirdBindRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«Customer»» */
export interface BizResponseListCustomer {
  code?: string;
  data?: Customer[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«DataDictRespDTO»» */
export interface BizResponseListDataDictRespDTO {
  code?: string;
  data?: DataDictRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«DepartmentDetailRespDTO»» */
export interface BizResponseListDepartmentDetailRespDTO {
  code?: string;
  data?: DepartmentDetailRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«DepartmentTreeRespDTO»» */
export interface BizResponseListDepartmentTreeRespDTO {
  code?: string;
  data?: DepartmentTreeRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«DingCompany对象»» */
export interface BizResponseListDingCompany {
  code?: string;
  data?: DingCompany[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«FeedbackInfoRspDTO»» */
export interface BizResponseListFeedbackInfoRspDTO {
  code?: string;
  data?: FeedbackInfoRspDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«FrogArticleArchiveSortRespDTO»» */
export interface BizResponseListFrogArticleArchiveSortRespDTO {
  code?: string;
  data?: FrogArticleArchiveSortRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«FrogArticleType对象»» */
export interface BizResponseListFrogArticleType {
  code?: string;
  data?: FrogArticleType[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«HolidayDateDTO»» */
export interface BizResponseListHolidayDateDTO {
  code?: string;
  data?: HolidayDateDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«HotFrogArticleSortDTO»» */
export interface BizResponseListHotFrogArticleSortDTO {
  code?: string;
  data?: HotFrogArticleSortDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«IntAreaDTO»» */
export interface BizResponseListIntAreaDTO {
  code?: string;
  data?: IntAreaDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ManageBannerRespDTO»» */
export interface BizResponseListManageBannerRespDTO {
  code?: string;
  data?: ManageBannerRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ManageRoleRespDTO»» */
export interface BizResponseListManageRoleRespDTO {
  code?: string;
  data?: ManageRoleRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ManageUserRespDTO»» */
export interface BizResponseListManageUserRespDTO {
  code?: string;
  data?: ManageUserRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MaterialPrice对象»» */
export interface BizResponseListMaterialPrice {
  code?: string;
  data?: MaterialPrice[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MembershipOrderDTO»» */
export interface BizResponseListMembershipOrderDTO {
  code?: string;
  data?: MembershipOrderDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MenuTreeListRespDTO»» */
export interface BizResponseListMenuTreeListRespDTO {
  code?: string;
  data?: MenuTreeListRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MenuTreeRespDTO»» */
export interface BizResponseListMenuTreeRespDTO {
  code?: string;
  data?: MenuTreeRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«OpenShopListRespDTO»» */
export interface BizResponseListOpenShopListRespDTO {
  code?: string;
  data?: OpenShopListRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«QueryOperateLogRespDTO»» */
export interface BizResponseListQueryOperateLogRespDTO {
  code?: string;
  data?: QueryOperateLogRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«RegisterPageImageBackendDTO»» */
export interface BizResponseListRegisterPageImageBackendDTO {
  code?: string;
  data?: RegisterPageImageBackendDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«RoleUserRespDTO»» */
export interface BizResponseListRoleUserRespDTO {
  code?: string;
  data?: RoleUserRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«RouteRespDTO»» */
export interface BizResponseListRouteRespDTO {
  code?: string;
  data?: RouteRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SelectTypeDicDTO»» */
export interface BizResponseListSelectTypeDicDTO {
  code?: string;
  data?: SelectTypeDicDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ShopAdditionRespDTO»» */
export interface BizResponseListShopAdditionRespDTO {
  code?: string;
  data?: ShopAdditionRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ShopClearanceAddressRespDTO»» */
export interface BizResponseListShopClearanceAddressRespDTO {
  code?: string;
  data?: ShopClearanceAddressRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ShopPurchaseRespDTO»» */
export interface BizResponseListShopPurchaseRespDTO {
  code?: string;
  data?: ShopPurchaseRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ShopShippingAddressRespDTO»» */
export interface BizResponseListShopShippingAddressRespDTO {
  code?: string;
  data?: ShopShippingAddressRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SupportCenterContentDTO»» */
export interface BizResponseListSupportCenterContentDTO {
  code?: string;
  data?: SupportCenterContentDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SupportCenterSubjectDTO»» */
export interface BizResponseListSupportCenterSubjectDTO {
  code?: string;
  data?: SupportCenterSubjectDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«TermConfigDTO»» */
export interface BizResponseListTermConfigDTO {
  code?: string;
  data?: TermConfigDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«WashedLabelRespDTOV2»» */
export interface BizResponseListWashedLabelRespDTOV2 {
  code?: string;
  data?: WashedLabelRespDTOV2[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«WorkbenchBannerRespDTO»» */
export interface BizResponseListWorkbenchBannerRespDTO {
  code?: string;
  data?: WorkbenchBannerRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«long»» */
export interface BizResponseListLong {
  code?: string;
  data?: number[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«string»» */
export interface BizResponseListString {
  code?: string;
  data?: string[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageLoginRespDTO» */
export interface BizResponseManageLoginRespDTO {
  code?: string;
  data?: ManageLoginRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageMenuRespDTO» */
export interface BizResponseManageMenuRespDTO {
  code?: string;
  data?: ManageMenuRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageRoleRespDTO» */
export interface BizResponseManageRoleRespDTO {
  code?: string;
  data?: ManageRoleRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageUserDetailRespDTO» */
export interface BizResponseManageUserDetailRespDTO {
  code?: string;
  data?: ManageUserDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageUserInfoRespDTO» */
export interface BizResponseManageUserInfoRespDTO {
  code?: string;
  data?: ManageUserInfoRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageUserLoginRespDTO» */
export interface BizResponseManageUserLoginRespDTO {
  code?: string;
  data?: ManageUserLoginRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ManageUserRespDTO» */
export interface BizResponseManageUserRespDTO {
  code?: string;
  data?: ManageUserRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Map«long,CustomerDistributeQueryRespDTO»» */
export interface BizResponseMapLongCustomerDistributeQueryRespDTO {
  code?: string;
  data?: Record<string, CustomerDistributeQueryRespDTO>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Map«string,List«DepartmentDetailRespDTO»»» */
export interface BizResponseMapStringListDepartmentDetailRespDTO {
  code?: string;
  data?: Record<string, DepartmentDetailRespDTO[]>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Map«string,List«string»»» */
export interface BizResponseMapStringListString {
  code?: string;
  data?: Record<string, string[]>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«NotifyPrivateVO» */
export interface BizResponseNotifyPrivateVO {
  code?: string;
  data?: NotifyPrivateVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ImportantNoticeDTO»» */
export interface BizResponsePageResultImportantNoticeDTO {
  code?: string;
  data?: PageResultImportantNoticeDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ChangeUrlWhiteUserRespDTO»» */
export interface BizResponsePageChangeUrlWhiteUserRespDTO {
  code?: string;
  data?: PageChangeUrlWhiteUserRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerDetailManagerRespDTO»» */
export interface BizResponsePageCustomerDetailManagerRespDTO {
  code?: string;
  data?: PageCustomerDetailManagerRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerDetailRespDTO»» */
export interface BizResponsePageCustomerDetailRespDTO {
  code?: string;
  data?: PageCustomerDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerGoogle对象»» */
export interface BizResponsePageCustomerGoogle {
  code?: string;
  data?: PageCustomerGoogle;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerItemRespDTO»» */
export interface BizResponsePageCustomerItemRespDTO {
  code?: string;
  data?: PageCustomerItemRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerPageDTO»» */
export interface BizResponsePageCustomerPageDTO {
  code?: string;
  data?: PageCustomerPageDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerShopPageDTO»» */
export interface BizResponsePageCustomerShopPageDTO {
  code?: string;
  data?: PageCustomerShopPageDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerShopRespDTO»» */
export interface BizResponsePageCustomerShopRespDTO {
  code?: string;
  data?: PageCustomerShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerShopWmsRespDTO»» */
export interface BizResponsePageCustomerShopWmsRespDTO {
  code?: string;
  data?: PageCustomerShopWmsRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«DeclarationWhitelistRespDTO»» */
export interface BizResponsePageDeclarationWhitelistRespDTO {
  code?: string;
  data?: PageDeclarationWhitelistRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«DepartmentDetailRespDTO»» */
export interface BizResponsePageDepartmentDetailRespDTO {
  code?: string;
  data?: PageDepartmentDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«FrogArticleRespDTO»» */
export interface BizResponsePageFrogArticleRespDTO {
  code?: string;
  data?: PageFrogArticleRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«HotFrogArticleRespDTO»» */
export interface BizResponsePageHotFrogArticleRespDTO {
  code?: string;
  data?: PageHotFrogArticleRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ManageBannerRespDTO»» */
export interface BizResponsePageManageBannerRespDTO {
  code?: string;
  data?: PageManageBannerRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ManageFrogArticleRespDTO»» */
export interface BizResponsePageManageFrogArticleRespDTO {
  code?: string;
  data?: PageManageFrogArticleRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ManageMenuRespDTO»» */
export interface BizResponsePageManageMenuRespDTO {
  code?: string;
  data?: PageManageMenuRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ManageUserRespDTO»» */
export interface BizResponsePageManageUserRespDTO {
  code?: string;
  data?: PageManageUserRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«NotifyPrivateVO»» */
export interface BizResponsePageNotifyPrivateVO {
  code?: string;
  data?: PageNotifyPrivateVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«NotifyPublicVO»» */
export interface BizResponsePageNotifyPublicVO {
  code?: string;
  data?: PageNotifyPublicVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«QueryCustomerDistributeRespDTO»» */
export interface BizResponsePageQueryCustomerDistributeRespDTO {
  code?: string;
  data?: PageQueryCustomerDistributeRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ShopTaxDeductionAccountRespDTO»» */
export interface BizResponsePageShopTaxDeductionAccountRespDTO {
  code?: string;
  data?: PageShopTaxDeductionAccountRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«TakeUserRespDTO»» */
export interface BizResponsePageTakeUserRespDTO {
  code?: string;
  data?: PageTakeUserRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«RegisterPageImageDTO» */
export interface BizResponseRegisterPageImageDTO {
  code?: string;
  data?: RegisterPageImageDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SearchResultDTO» */
export interface BizResponseSearchResultDTO {
  code?: string;
  data?: SearchResultDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopAdditionAddressRespDTO» */
export interface BizResponseShopAdditionAddressRespDTO {
  code?: string;
  data?: ShopAdditionAddressRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopAdditionDetailRespDTO» */
export interface BizResponseShopAdditionDetailRespDTO {
  code?: string;
  data?: ShopAdditionDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopAdditionWashedLabelRespDTO» */
export interface BizResponseShopAdditionWashedLabelRespDTO {
  code?: string;
  data?: ShopAdditionWashedLabelRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopClearanceAddressRespDTO» */
export interface BizResponseShopClearanceAddressRespDTO {
  code?: string;
  data?: ShopClearanceAddressRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopOverviewRespDTO» */
export interface BizResponseShopOverviewRespDTO {
  code?: string;
  data?: ShopOverviewRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopPurchaseRespDTO» */
export interface BizResponseShopPurchaseRespDTO {
  code?: string;
  data?: ShopPurchaseRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopShippingAddressRespDTO» */
export interface BizResponseShopShippingAddressRespDTO {
  code?: string;
  data?: ShopShippingAddressRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopTaxDeductionAccountRespDTO» */
export interface BizResponseShopTaxDeductionAccountRespDTO {
  code?: string;
  data?: ShopTaxDeductionAccountRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SignUpRespDTO» */
export interface BizResponseSignUpRespDTO {
  code?: string;
  data?: SignUpRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupportCenterContentDTO» */
export interface BizResponseSupportCenterContentDTO {
  code?: string;
  data?: SupportCenterContentDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupportCenterSubjectDTO» */
export interface BizResponseSupportCenterSubjectDTO {
  code?: string;
  data?: SupportCenterSubjectDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«TakeUserRespDTO» */
export interface BizResponseTakeUserRespDTO {
  code?: string;
  data?: TakeUserRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«TermConfigDTO» */
export interface BizResponseTermConfigDTO {
  code?: string;
  data?: TermConfigDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdIsBindRespDTO» */
export interface BizResponseThirdIsBindRespDTO {
  code?: string;
  data?: ThirdIsBindRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«UserManagerDetailRespDTO» */
export interface BizResponseUserManagerDetailRespDTO {
  code?: string;
  data?: UserManagerDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«VideoActivityDTO» */
export interface BizResponseVideoActivityDTO {
  code?: string;
  /** 直播间对象 */
  data?: VideoActivityDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Void» */
export interface BizResponseVoid {
  code?: string;
  msg?: string;
  success?: boolean;
}

/** BizResponse«WashedLabelRespDTOV2» */
export interface BizResponseWashedLabelRespDTOV2 {
  code?: string;
  data?: WashedLabelRespDTOV2;
  msg?: string;
  success?: boolean;
}

/** BizResponse«bigdecimal» */
export interface BizResponseBigdecimal {
  code?: string;
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«boolean» */
export interface BizResponseBoolean {
  code?: string;
  data?: boolean;
  msg?: string;
  success?: boolean;
}

/** BizResponse«int» */
export interface BizResponseInt {
  code?: string;
  /** @format int32 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«long» */
export interface BizResponseLong {
  code?: string;
  /** @format int64 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«object» */
export interface BizResponseObject {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/** BizResponse«string» */
export interface BizResponseString {
  code?: string;
  data?: string;
  msg?: string;
  success?: boolean;
}

/**
 * CustomerGoogle对象
 * 客户谷歌表
 */
export interface CustomerGoogle {
  /** @example "yyyy-MM-dd HH:mm:ss" */
  createTime?: string;
  createrId?: string;
  /** @format int64 */
  customerGooleId?: number;
  /** @format int32 */
  customerId?: number;
  developerCredentials?: string;
  googleId?: string;
  googleUrl?: string;
  managerId?: string;
  managerName?: string;
  remark?: string;
  /** @format int32 */
  status?: number;
  unificationCustomerFullName?: string;
  /** @example "yyyy-MM-dd HH:mm:ss" */
  updateTime?: string;
}

/**
 * CustomerMembership对象
 * 客户与会员身份关联数据
 */
export interface CustomerMembership {
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  customerMembershipId?: number;
  /**
   * 状态：1-正常；2-停用
   * @format int32
   */
  customerMembershipStatus?: number;
  /** 客户姓名 */
  customerName?: string;
  /**
   * 过期日期
   * @format date-time
   */
  expiresDate?: string;
  /** @format int32 */
  historyMemberLevel?: number;
  /**
   * 会员身份模板
   * @format int64
   */
  membershipTemplateId?: number;
  /** 会员身份名称 */
  membershipTemplateName?: string;
  /**
   * 会员身份收费标准
   * @format int64
   */
  membershipTemplatePriceId?: number;
  /** 会员身份收费标准名称 */
  membershipTemplatePriceName?: string;
  /**
   * 会员类型:0-普通,1-特殊
   * @format int32
   */
  specialType?: number;
  stationCode?: string;
  /**
   * 客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 会员等级，从低到高，0最低
   * @format int32
   */
  templateLevel?: number;
  /**
   * 试用标志:0-不是,1是
   * @format int32
   */
  trialFlag?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/**
 * DingCompany对象
 * 公司钉钉信息表
 */
export interface DingCompany {
  agentId?: string;
  appKey?: string;
  appSecret?: string;
  corpId?: string;
  /** @format date-time */
  createTime?: string;
  deleted?: string;
  dingCompanyId?: string;
  leader?: string;
  name?: string;
  /** @format date-time */
  updateTime?: string;
}

/** FrogArticleType对象 */
export interface FrogArticleType {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  id?: number;
  name?: string;
  nameZh?: string;
  /** @format int32 */
  sort?: number;
  stationCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** Map«long,CustomerDistributeQueryRespDTO» */
export type MapLongCustomerDistributeQueryRespDTO = Record<
  string,
  CustomerDistributeQueryRespDTO
>;

/** Map«string,List«DepartmentDetailRespDTO»» */
export type MapStringListDepartmentDetailRespDTO = Record<string, any>;

/** Map«string,List«string»» */
export type MapStringListString = Record<string, any>;

/**
 * MaterialPrice对象
 * 国际料金表
 */
export interface MaterialPrice {
  /** 创建时间 */
  createTime?: string;
  /** @format int64 */
  materialPriceId?: number;
  /** 名称 */
  name?: string;
  stationCode?: string;
  /** 显示位置 */
  systemSource?: string;
  /** 文件类型 */
  type?: string;
  /** 更新时间 */
  updateTime?: string;
  /** 操作人 */
  updateUser?: string;
  /** 链接 */
  url?: string;
}

/** PageResult«ImportantNoticeDTO» */
export interface PageResultImportantNoticeDTO {
  /** @format int64 */
  current?: number;
  records?: ImportantNoticeDTO[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** Page«ChangeUrlWhiteUserRespDTO» */
export interface PageChangeUrlWhiteUserRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ChangeUrlWhiteUserRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerDetailManagerRespDTO» */
export interface PageCustomerDetailManagerRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerDetailManagerRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerDetailRespDTO» */
export interface PageCustomerDetailRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerDetailRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerGoogle对象» */
export interface PageCustomerGoogle {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerGoogle[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerItemRespDTO» */
export interface PageCustomerItemRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerItemRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerPageDTO» */
export interface PageCustomerPageDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerPageDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerShopPageDTO» */
export interface PageCustomerShopPageDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerShopPageDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerShopRespDTO» */
export interface PageCustomerShopRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerShopRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerShopWmsRespDTO» */
export interface PageCustomerShopWmsRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerShopWmsRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«DeclarationWhitelistRespDTO» */
export interface PageDeclarationWhitelistRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: DeclarationWhitelistRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«DepartmentDetailRespDTO» */
export interface PageDepartmentDetailRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: DepartmentDetailRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«FrogArticleRespDTO» */
export interface PageFrogArticleRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: FrogArticleRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«HotFrogArticleRespDTO» */
export interface PageHotFrogArticleRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: HotFrogArticleRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ManageBannerRespDTO» */
export interface PageManageBannerRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ManageBannerRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ManageFrogArticleRespDTO» */
export interface PageManageFrogArticleRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ManageFrogArticleRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ManageMenuRespDTO» */
export interface PageManageMenuRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ManageMenuRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ManageUserRespDTO» */
export interface PageManageUserRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ManageUserRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«NotifyPrivateVO» */
export interface PageNotifyPrivateVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: NotifyPrivateVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«NotifyPublicVO» */
export interface PageNotifyPublicVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: NotifyPublicVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«QueryCustomerDistributeRespDTO» */
export interface PageQueryCustomerDistributeRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: QueryCustomerDistributeRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ShopTaxDeductionAccountRespDTO» */
export interface PageShopTaxDeductionAccountRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ShopTaxDeductionAccountRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«TakeUserRespDTO» */
export interface PageTakeUserRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: TakeUserRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** 手机号登录请求DTO */
export interface _DTO {
  /** @format int32 */
  buType?: number;
  customerMobile?: string;
  /** 国际区号 */
  globalRoaming?: string;
  /** @format int32 */
  platformType?: number;
  stationCode?: string;
  /** 三方平台用户账号,可以理解为唯一标识 */
  thirdCustomerId?: string;
  /** 三方平台用户名称 */
  thirdCustomerName?: string;
  /** 三方平台用户邮箱 */
  thirdEmail?: string;
  /** 三方平台标识 */
  thirdPlatform?: string;
  verificationCode?: string;
}

/** 绑定邮箱请求DTO */
export interface DTO2 {
  /** 新的邮箱 */
  newCustomerEmail?: string;
  /** 邮箱验证码 */
  verificationCode?: string;
}

/** 请求验证码DTO */
export interface DTO3 {
  /**
   * 1注册 2重置密码 3登录 4 修改手机号
   * @format int32
   */
  bizType?: number;
  /** 国家code */
  countryPlaceCode?: string;
  /** 用户手机号 */
  customerMobile?: string;
  /** 国际区号 */
  globalRoaming?: string;
  /** 语言代码 */
  langcode?: string;
  /** 人机校验code,不能为空 */
  recaptchaCode?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "//master-gateway.theckb.com:443/customer";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title API文档
 * @version v1.0.0
 * @baseUrl //master-gateway.theckb.com:443/customer
 * @contact 史尼芙 (https://www.taobaockb.com/)
 *
 * 史尼芙API文档
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  probe = {
    /**
     * No description
     *
     * @tags livens-probe-controller
     * @name TestUsingGet
     * @summary 执行一次健康检查探针
     * @request GET:/Probe/test
     */
    testUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/Probe/test`,
        method: "GET",
        ...params,
      }),
  };
  actuator1 = {
    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingGet
     * @summary jvmInfo
     * @request GET:/actuator1/jvmInfo
     */
    jvmInfoUsingGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingHead
     * @summary jvmInfo
     * @request HEAD:/actuator1/jvmInfo
     */
    jvmInfoUsingHead: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingPost
     * @summary jvmInfo
     * @request POST:/actuator1/jvmInfo
     */
    jvmInfoUsingPost: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingPut
     * @summary jvmInfo
     * @request PUT:/actuator1/jvmInfo
     */
    jvmInfoUsingPut: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingDelete
     * @summary jvmInfo
     * @request DELETE:/actuator1/jvmInfo
     */
    jvmInfoUsingDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingOptions
     * @summary jvmInfo
     * @request OPTIONS:/actuator1/jvmInfo
     */
    jvmInfoUsingOptions: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-contorller
     * @name JvmInfoUsingPatch
     * @summary jvmInfo
     * @request PATCH:/actuator1/jvmInfo
     */
    jvmInfoUsingPatch: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),
  };
  addConcat = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name AddConcatUsingPost
     * @summary 添加联系方式
     * @request POST:/addConcat
     */
    addConcatUsingPost: (
      concatReqDTO: ConcatReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/addConcat`,
        method: "POST",
        body: concatReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  addEmail = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name AddEmailUsingPost
     * @summary 更改新邮箱
     * @request POST:/addEmail
     */
    addEmailUsingPost: (changeEmailReqDTO: DTO2, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/addEmail`,
        method: "POST",
        body: changeEmailReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  additional = {
    /**
     * No description
     *
     * @tags additional-controller
     * @name AddUsingPost
     * @summary 添加商品附加项
     * @request POST:/additional/add
     */
    addUsingPost: (reqDTO: AddAdditionReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/additional/add`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name AddWashedlabelUsingPost
     * @summary 新增水洗标配置接口
     * @request POST:/additional/addWashedlabel
     */
    addWashedlabelUsingPost: (
      shopWashedLabelAdditionReqDTO: ShopWashedLabelAdditionReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/additional/addWashedlabel`,
        method: "POST",
        body: shopWashedLabelAdditionReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name DeleteAdditionUsingGet
     * @summary 删除附加项详情
     * @request GET:/additional/delete
     */
    deleteAdditionUsingGet: (
      query?: {
        /**
         * shopAdditionId
         * @format int64
         */
        shopAdditionId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/additional/delete`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetAdditionUsingGet
     * @summary 获取附加项配置详情
     * @request GET:/additional/get
     */
    getAdditionUsingGet: (
      query?: {
        /**
         * shopAdditionId
         * @format int64
         */
        shopAdditionId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopAdditionDetailRespDTO, any>({
        path: `/additional/get`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-additional-feign-api-impl
     * @name GetAdditionFeignUsingGet
     * @summary getAdditionFeign
     * @request GET:/additional/getAdditionFeign
     */
    getAdditionFeignUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListShopAdditionRespDTO, any>({
        path: `/additional/getAdditionFeign`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetAddressUsingGet
     * @summary 获取国际物流附加项
     * @request GET:/additional/getAddress
     */
    getAddressUsingGet: (
      query?: {
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopAdditionAddressRespDTO, any>({
        path: `/additional/getAddress`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-additional-feign-api-impl
     * @name GetAddressByShopIdFeignUsingGet
     * @summary getAddressByShopIdFeign
     * @request GET:/additional/getAddressByShopIdFeign
     */
    getAddressByShopIdFeignUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopAdditionAddressRespDTO, any>({
        path: `/additional/getAddressByShopIdFeign`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetAddressFeignUsingGet
     * @summary 获取国际物流附加项(Feign)
     * @request GET:/additional/getAddressFeign
     */
    getAddressFeignUsingGet: (
      query?: {
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopAdditionAddressRespDTO, any>({
        path: `/additional/getAddressFeign`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetCategoryConfiguredUsingGet
     * @summary 查询店铺已配置附加项的类目
     * @request GET:/additional/getCategoryConfigured
     */
    getCategoryConfiguredUsingGet: (
      query?: {
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCategoryCodeRespDTO, any>({
        path: `/additional/getCategoryConfigured`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-additional-feign-api-impl
     * @name GetGoodsAdditionFeignUsingGet
     * @summary getGoodsAdditionFeign
     * @request GET:/additional/getGoodsAdditionFeign
     */
    getGoodsAdditionFeignUsingGet: (
      query: {
        /**
         * categoryCateId
         * @format int64
         */
        categoryCateId: number;
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopAdditionDetailRespDTO, any>({
        path: `/additional/getGoodsAdditionFeign`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetTemplateListUsingGet
     * @summary 获取附加项模板
     * @request GET:/additional/getList
     */
    getTemplateListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListAdditionTemplateRespDTO, any>({
        path: `/additional/getList`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-additional-feign-api-impl
     * @name GetShopLogisticsInfoUsingGet
     * @summary getShopLogisticsInfo
     * @request GET:/additional/getShopLogisticsInfo
     */
    getShopLogisticsInfoUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopAddressRespDTO, any>({
        path: `/additional/getShopLogisticsInfo`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetWashedlabelUsingGet
     * @summary 获取水洗标配置
     * @request GET:/additional/getWashedlabel
     */
    getWashedlabelUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseShopAdditionWashedLabelRespDTO, any>({
        path: `/additional/getWashedlabel`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetWashedlabelListUsingGet
     * @summary 获取水洗标配置列表
     * @request GET:/additional/getWashedlabelList
     */
    getWashedlabelListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListWashedLabelRespDTOV2, any>({
        path: `/additional/getWashedlabelList`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetWashedlabelV2UsingGet
     * @summary 获取店铺水洗标模板信息，没传 id 返回默认的
     * @request GET:/additional/getWashedlabelV2
     */
    getWashedlabelV2UsingGet: (
      query?: {
        /**
         * washedlabelAdditionId
         * @format int64
         */
        washedlabelAdditionId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseWashedLabelRespDTOV2, any>({
        path: `/additional/getWashedlabelV2`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetWashedlabelWarehouseUsingGet
     * @summary 获取水洗标配置-仓库
     * @request GET:/additional/getWashedlabelWarehouse
     */
    getWashedlabelWarehouseUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopAdditionWashedLabelRespDTO, any>({
        path: `/additional/getWashedlabelWarehouse`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name GetAdditionListUsingGet
     * @summary 获取附加项配置表
     * @request GET:/additional/list
     */
    getAdditionListUsingGet: (
      query?: {
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListShopAdditionRespDTO, any>({
        path: `/additional/list`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name UpdateUsingPost
     * @summary 更新商品附加项
     * @request POST:/additional/update
     */
    updateUsingPost: (
      reqDTO: UpdateAdditionReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/additional/update`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name UpdateAddressUsingPost
     * @summary 更新国际物流附加项
     * @request POST:/additional/updateAddress
     */
    updateAddressUsingPost: (
      reqDTO: UpdateAdditionAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/additional/updateAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name UpdateWashedlabelUsingPost
     * @summary 更新水洗标配置
     * @request POST:/additional/updateWashedlabel
     */
    updateWashedlabelUsingPost: (
      reqDTO: UpdateAdditionWashedLabelReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/additional/updateWashedlabel`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags additional-controller
     * @name UpdateWashedlabelV2UsingPost
     * @summary 更新水洗标配置接口V2
     * @request POST:/additional/updateWashedlabelV2
     */
    updateWashedlabelV2UsingPost: (
      shopWashedLabelAdditionReqDTO: ShopWashedLabelAdditionReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/additional/updateWashedlabelV2`,
        method: "POST",
        body: shopWashedLabelAdditionReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  area = {
    /**
     * No description
     *
     * @tags 地区设置
     * @name GetAreaByIdUsingPost
     * @summary 查询地区信息通过id
     * @request POST:/area/getAreaById
     */
    getAreaByIdUsingPost: (
      query: {
        /**
         * intAreaId
         * @format int64
         */
        intAreaId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/area/getAreaById`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetAreaListByIdUsingPost
     * @summary 批量查询地区信息通过ids
     * @request POST:/area/getAreaListByIds
     */
    getAreaListByIdUsingPost: (
      query: {
        /** intAreaIds */
        intAreaIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListIntAreaDTO, any>({
        path: `/area/getAreaListByIds`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetByIdUsingGet
     * @summary getById
     * @request GET:/area/getById
     */
    getByIdUsingGet: (
      query: {
        /**
         * id
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/area/getById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetByKrNameLikeUsingGet
     * @summary getByKrNameLike
     * @request GET:/area/getByKrNameLike
     */
    getByKrNameLikeUsingGet: (
      query: {
        /** krName */
        krName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/area/getByKrNameLike`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetByPidUsingGet
     * @summary 查询下级地区信息
     * @request GET:/area/getByPid
     */
    getByPidUsingGet: (
      query: {
        /**
         * pid
         * @format int64
         */
        pid: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListIntAreaDTO, any>({
        path: `/area/getByPid`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetCountryByCountryCodeUsingGet
     * @summary getCountryByCountryCode
     * @request GET:/area/getCountryByCountryCode
     */
    getCountryByCountryCodeUsingGet: (
      query: {
        /** countryCode */
        countryCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/area/getCountryByCountryCode`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetJapanProvinceByEnLikeUsingGet
     * @summary getJapanProvinceByEnLike
     * @request GET:/area/getJapanProvinceByEnLike
     */
    getJapanProvinceByEnLikeUsingGet: (
      query: {
        /** nameEn */
        nameEn: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/area/getJapanProvinceByEnLike`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetJapanProvinceByNameLikeUsingGet
     * @summary getJapanProvinceByNameLike
     * @request GET:/area/getJapanProvinceByNameLike
     */
    getJapanProvinceByNameLikeUsingGet: (
      query: {
        /** name */
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/area/getJapanProvinceByNameLike`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 地区设置
     * @name GetTreeUsingPost1
     * @summary 查询地区信息全部
     * @request POST:/area/getTree
     */
    getTreeUsingPost1: (
      query?: {
        /**
         * 查询级别： 1洲 2国 3省
         * @format int64
         */
        level?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListIntAreaDTO, any>({
        path: `/area/getTree`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  assignManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name AssignManagerUsingPost
     * @summary assignManager
     * @request POST:/assignManager
     */
    assignManagerUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/assignManager`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  assignMarketingManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name AssignMarketingManagerUsingPost
     * @summary assignMarketingManager
     * @request POST:/assignMarketingManager
     */
    assignMarketingManagerUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/assignMarketingManager`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  assignSupervisionManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name AssignSupervisionManagerUsingPost
     * @summary assignSupervisionManager
     * @request POST:/assignSupervisionManager
     */
    assignSupervisionManagerUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/assignSupervisionManager`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  backdoor = {
    /**
     * No description
     *
     * @tags 省市区后门接口
     * @name InitJapanEnNameUsingGet
     * @summary initJapanEnName
     * @request GET:/backdoor/area/initJapanEnName
     */
    initJapanEnNameUsingGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backdoor/area/initJapanEnName`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 省市区后门接口
     * @name SetCountryCodeUsingGet
     * @summary setCountryCode
     * @request GET:/backdoor/area/setCountryCode
     */
    setCountryCodeUsingGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backdoor/area/setCountryCode`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户后门接口
     * @name CreateUserUsingPost
     * @summary 新建一个用户
     * @request POST:/backdoor/customer/createNew
     */
    createUserUsingPost: (
      query?: {
        /**
         * 业务类型 0直采 1代采
         * @format int32
         */
        buType?: number;
        /** 渠道 */
        channel?: string;
        /** chartWorkId */
        chatWorkId?: string;
        /** 公司名称 */
        corpName?: string;
        /** 区号 */
        countryCode?: string;
        /** 国家code */
        countryPlaceCode?: string;
        /** 邮箱地址 */
        customerEmail?: string;
        /** 客户手机号 */
        customerMobile?: string;
        /** 联系人姓名 */
        customerName?: string;
        /**
         * 客户状态：1-正常；2-停用
         * @format int32
         * @example 1
         */
        customerStatus?: number;
        "ext.innerMap"?: object;
        /**
         * 性别：1-男；2-女；3-未知
         * @format int32
         * @example 1
         */
        gender?: number;
        /**
         * 是否初始化店铺 0：否，1：是
         * @format int32
         */
        initShopFlag?: number;
        /** 三方邀请码 */
        invitationCode?: string;
        /**
         * 邀请平台:0-内部,1-aucfan
         * @format int32
         */
        invitationPlatform?: number;
        /** 语言代码 */
        langcode?: string;
        /** 登录名 */
        loginName?: string;
        /** 登录密码 */
        password?: string;
        /**
         * 平台类型:1网页端,2APP,3插件,4H5
         * @format int32
         */
        platformType?: number;
        /** 三方推荐邮箱 */
        recommendationEmail?: string;
        /** skype */
        skype?: string;
        /** spm */
        spm?: string;
        /** 站点code */
        stationCode?: string;
        /**
         * 隐私协议id
         * @format int64
         */
        termId?: number;
        /** 三方平台用户账号,可以理解为唯一标识 */
        thirdCustomerId?: string;
        /** 三方平台用户名称 */
        thirdCustomerName?: string;
        /** 三方平台用户邮箱 */
        thirdEmail?: string;
        /** 三方平台标识 */
        thirdPlatform?: string;
        /** 时区 */
        utcTimeZone?: string;
        /** 验证码 */
        verificationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/backdoor/customer/createNew`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户后门接口
     * @name DeleteCustomerBackUsingDelete
     * @summary 后台删除用户接口,松松使用
     * @request DELETE:/backdoor/customer/deleteCustomerBack
     */
    deleteCustomerBackUsingDelete: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/backdoor/customer/deleteCustomerBack`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户后门接口
     * @name AllocationManagerByMainCustomerIdUsingPost
     * @summary 导入模板-重新分配主账号营销经理和复购单经理
     * @request POST:/backdoor/customer/import/allocationManagerByMainCustomerId
     */
    allocationManagerByMainCustomerIdUsingPost: (
      data: {
        /**
         * file
         * @format binary
         */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/backdoor/customer/import/allocationManagerByMainCustomerId`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户后门接口
     * @name InternalCustomerBackUsingPost
     * @summary 标记用户为内部用户,松松使用
     * @request POST:/backdoor/customer/internalCustomerBack
     */
    internalCustomerBackUsingPost: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/backdoor/customer/internalCustomerBack`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户后门接口
     * @name ManagerLogSaveAndDelayDelUsingPost
     * @summary 获取经济舱或退会的客户总监客户经理存入数据库
     * @request POST:/backdoor/customer/managerLogSaveAndDelayDel
     */
    managerLogSaveAndDelayDelUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/backdoor/customer/managerLogSaveAndDelayDel`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户后门接口
     * @name InitKrAndEnContentUsingGet
     * @summary 初始化英文和韩文文案
     * @request GET:/backdoor/notify/initKrAndEnContent
     */
    initKrAndEnContentUsingGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backdoor/notify/initKrAndEnContent`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recall-backdoor-controller
     * @name RecallEmailSendUsingGet
     * @summary recallEmailSend
     * @request GET:/backdoor/recall/emailSend
     */
    recallEmailSendUsingGet: (
      query?: {
        /** email */
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<number[], any>({
        path: `/backdoor/recall/emailSend`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心后面接口
     * @name InitContentUsingGet
     * @summary initContent
     * @request GET:/backdoor/supportContent/initContent
     */
    initContentUsingGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/backdoor/supportContent/initContent`,
        method: "GET",
        ...params,
      }),
  };
  banner = {
    /**
     * No description
     *
     * @tags banner管理接口
     * @name CreateBannerUsingPost
     * @summary 创建Banner
     * @request POST:/banner/create
     */
    createBannerUsingPost: (
      addBannerReqDTO: AddBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/banner/create`,
        method: "POST",
        body: addBannerReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name DeleteBannerUsingDelete
     * @summary 删除banner
     * @request DELETE:/banner/delete
     */
    deleteBannerUsingDelete: (
      query: {
        /**
         * bannerId
         * @format int64
         */
        bannerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/banner/delete`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name GetMarketBannerByCategoryUsingPost
     * @summary getMarketBannerByCategory
     * @request POST:/banner/getByCategory
     */
    getMarketBannerByCategoryUsingPost: (
      reqDTO: ManageBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageBannerRespDTO, any>({
        path: `/banner/getByCategory`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name IncrementClickNumUsingPost
     * @summary 累加点击数
     * @request POST:/banner/increment
     */
    incrementClickNumUsingPost: (
      dto: UpdateManageBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/banner/increment`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name GetManageBannerPageUsingPost
     * @summary 查询banner分页
     * @request POST:/banner/page
     */
    getManageBannerPageUsingPost: (
      getManageBannerPageReqDTO: GetManageBannerPageReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageManageBannerRespDTO, any>({
        path: `/banner/page`,
        method: "POST",
        body: getManageBannerPageReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name GetBannerUsingGet
     * @summary 获取用户显示的banner(前台)
     * @request GET:/banner/show
     */
    getBannerUsingGet: (
      query?: {
        /**
         * bannerType
         * @format int32
         */
        bannerType?: number;
        /** stationCode */
        stationCode?: string;
        /**
         * systemSource
         * @format int32
         */
        systemSource?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageBannerRespDTO, any>({
        path: `/banner/show`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name GetMarketBannerUsingGet
     * @summary 根据banner类型获取banner列表
     * @request GET:/banner/show/market
     */
    getMarketBannerUsingGet: (
      query: {
        /**
         * bannerType
         * @format int32
         */
        bannerType: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageBannerRespDTO, any>({
        path: `/banner/show/market`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name ToggleStatusUsingPost
     * @summary 开启/关闭banner状态
     * @request POST:/banner/toggle/status
     */
    toggleStatusUsingPost: (
      dto: UpdateManageBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/banner/toggle/status`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags banner管理接口
     * @name UpdateBannerUsingPut
     * @summary 修改Banner
     * @request PUT:/banner/update
     */
    updateBannerUsingPut: (
      updateBannerReqDTO: UpdateBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/banner/update`,
        method: "PUT",
        body: updateBannerReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  base = {
    /**
     * No description
     *
     * @tags 官网接口
     * @name AddFeedbackInfoUsingPost
     * @summary 保存客户信息
     * @request POST:/base/feedback/addFeedbackInfo
     */
    addFeedbackInfoUsingPost: (
      feedbackInfoReqDTO: FeedbackInfoReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/base/feedback/addFeedbackInfo`,
        method: "POST",
        body: feedbackInfoReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 官网接口
     * @name ListFeedbackInfoUsingGet
     * @summary 查询列表
     * @request GET:/base/feedback/list
     */
    listFeedbackInfoUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListFeedbackInfoRspDTO, any>({
        path: `/base/feedback/list`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 注册页配图
     * @name EditUsingPost
     * @summary 编辑(后台)
     * @request POST:/base/registerPageImage/backend/edit
     */
    editUsingPost: (
      dto: RegisterPageImageBackendUpdateDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/registerPageImage/backend/edit`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 注册页配图
     * @name QueryUsingGet1
     * @summary 查询列表(后台)
     * @request GET:/base/registerPageImage/backend/query
     */
    queryUsingGet1: (params: RequestParams = {}) =>
      this.request<BizResponseListRegisterPageImageBackendDTO, any>({
        path: `/base/registerPageImage/backend/query`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 注册页配图
     * @name GetRegisterImageUsingGet
     * @summary 查询注册页配图
     * @request GET:/base/registerPageImage/getRegisterImage
     */
    getRegisterImageUsingGet: (
      query?: {
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseRegisterPageImageDTO, any>({
        path: `/base/registerPageImage/getRegisterImage`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 类型选择字典
     * @name GetSelectTypeUsingGet
     * @summary 查询类型字典
     * @request GET:/base/selectTypeDic/getSelectType
     */
    getSelectTypeUsingGet: (
      query?: {
        /** businessType */
        businessType?: string;
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectTypeDicDTO, any>({
        path: `/base/selectTypeDic/getSelectType`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 全球化基础站点信息
     * @name GetSupportStationUsingGet
     * @summary 查询支持的站点信息
     * @request GET:/base/station/getSupportStation
     */
    getSupportStationUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListCustomerStationDTO, any>({
        path: `/base/station/getSupportStation`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name AddContentUsingPost
     * @summary 添加文档
     * @request POST:/base/supportCenter/content/add
     */
    addContentUsingPost: (
      updateBackendDTO: SupportCenterContentUpdateBackendDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/supportCenter/content/add`,
        method: "POST",
        body: updateBackendDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name DeleteContentUsingPost
     * @summary 删除文档
     * @request POST:/base/supportCenter/content/delete/{contentId}
     */
    deleteContentUsingPost: (contentId: number, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/base/supportCenter/content/delete/${contentId}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name QueryContentUsingGet
     * @summary 查询文档
     * @request GET:/base/supportCenter/content/query
     */
    queryContentUsingGet: (
      query?: {
        /** bizType */
        bizType?: string;
        /** contentType */
        contentType?: string;
        /** keyword */
        keyword?: string;
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSupportCenterContentDTO, any>({
        path: `/base/supportCenter/content/query`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name UpdateContentUsingPost
     * @summary 更新文档
     * @request POST:/base/supportCenter/content/update
     */
    updateContentUsingPost: (
      updateBackendDTO: SupportCenterContentUpdateBackendDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/supportCenter/content/update`,
        method: "POST",
        body: updateBackendDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name GetSupportSubjectByParentIdUsingGet
     * @summary 查询帮助中心子目录，用于构建帮助中心目录（前台）
     * @request GET:/base/supportCenter/getSupportSubjectByParentId
     */
    getSupportSubjectByParentIdUsingGet: (
      query?: {
        /** bizType */
        bizType?: string;
        /**
         * parentId
         * @format int64
         */
        parentId?: number;
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSupportCenterSubjectDTO, any>({
        path: `/base/supportCenter/getSupportSubjectByParentId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name QueryByPathUsingGet
     * @summary 帮助中心根据路径查全路径
     * @request GET:/base/supportCenter/query/byPath
     */
    queryByPathUsingGet: (
      query?: {
        /** path */
        path?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseSupportCenterSubjectDTO, any>({
        path: `/base/supportCenter/query/byPath`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name GetSupportCenterContentByIdUsingGet
     * @summary 帮助中心根据id查内容
     * @request GET:/base/supportCenter/query/getSupportCenterContentById
     */
    getSupportCenterContentByIdUsingGet: (
      query?: {
        /**
         * contentId
         * @format int32
         */
        contentId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseSupportCenterContentDTO, any>({
        path: `/base/supportCenter/query/getSupportCenterContentById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name BatchUpdateContentSortUsingPost
     * @summary 批量更新排序
     * @request POST:/base/supportCenter/subject/batchUpdateContentSort
     */
    batchUpdateContentSortUsingPost: (
      updateBackendDTOList: SupportCenterContentUpdateBackendDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/supportCenter/subject/batchUpdateContentSort`,
        method: "POST",
        body: updateBackendDTOList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name BatchUpdateSortUsingPost
     * @summary 批量更新目录排序
     * @request POST:/base/supportCenter/subject/batchUpdateSort
     */
    batchUpdateSortUsingPost: (
      updateBackendDTOList: SupportCenterSubjectUpdateBackendDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/supportCenter/subject/batchUpdateSort`,
        method: "POST",
        body: updateBackendDTOList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name BatchUpdateSubjectUsingPost
     * @summary 批量更新分类
     * @request POST:/base/supportCenter/subject/batchUpdateSubject
     */
    batchUpdateSubjectUsingPost: (
      updateBackendDTOList: SupportCenterSubjectUpdateBackendDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/supportCenter/subject/batchUpdateSubject`,
        method: "POST",
        body: updateBackendDTOList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name GetContentBySubjectIdUsingGet
     * @summary 获取帮助中心内容
     * @request GET:/base/supportCenter/subject/contentList
     */
    getContentBySubjectIdUsingGet: (
      query?: {
        /**
         * subjectId
         * @format int64
         */
        subjectId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSupportCenterContentDTO, any>({
        path: `/base/supportCenter/subject/contentList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 帮助中心
     * @name TreeUsingGet1
     * @summary 帮助中心目录-树结构
     * @request GET:/base/supportCenter/tree
     */
    treeUsingGet1: (
      query?: {
        /** bizType */
        bizType?: string;
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSupportCenterSubjectDTO, any>({
        path: `/base/supportCenter/tree`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 条款配置
     * @name AgreeTermUsingGet
     * @summary 用户同意条款
     * @request GET:/base/term/agreeTerm
     */
    agreeTermUsingGet: (
      query?: {
        /**
         * termId
         * @format int64
         */
        termId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/term/agreeTerm`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 条款配置
     * @name GetCustomerAgreeEffectTermByTypeUsingGet
     * @summary 获取用户同意过的条款
     * @request GET:/base/term/getCustomerAgreeEffectTermByType
     */
    getCustomerAgreeEffectTermByTypeUsingGet: (
      query?: {
        /** stationCode */
        stationCode?: string;
        /** type */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseTermConfigDTO, any>({
        path: `/base/term/getCustomerAgreeEffectTermByType`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 条款配置
     * @name GetEffectTermByTypeUsingGet
     * @summary 获取最新的条款配置
     * @request GET:/base/term/getEffectTermByType
     */
    getEffectTermByTypeUsingGet: (
      query?: {
        /** stationCode */
        stationCode?: string;
        /** type */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListTermConfigDTO, any>({
        path: `/base/term/getEffectTermByType`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 条款配置
     * @name GetTermUpdateLogUsingGet
     * @summary 查询条款的修改记录
     * @request GET:/base/term/getTermUpdateLog
     */
    getTermUpdateLogUsingGet: (
      query?: {
        /** stationCode */
        stationCode?: string;
        /** type */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListTermConfigDTO, any>({
        path: `/base/term/getTermUpdateLog`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 条款配置
     * @name UpdateTermContentUsingPost
     * @summary 更新条款内容(管理后台)
     * @request POST:/base/term/updateTermContent
     */
    updateTermContentUsingPost: (
      termUpdateDTO: TermUpdateDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/base/term/updateTermContent`,
        method: "POST",
        body: termUpdateDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  batchChangeWarehouseTask = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name BatchChangeWarehouseTaskUsingPost
     * @summary 批量
     * @request POST:/batchChangeWarehouseTask
     */
    batchChangeWarehouseTaskUsingPost: (
      customerIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/batchChangeWarehouseTask`,
        method: "POST",
        body: customerIds,
        type: ContentType.Json,
        ...params,
      }),
  };
  bind = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name BindThirdUsingPost
     * @summary 绑定第三方账号
     * @request POST:/bind/third
     */
    bindThirdUsingPost: (reqDTO: BindThirdReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/bind/third`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name CancelBindThirdUsingPost
     * @summary 解绑第三方账号
     * @request POST:/bind/third/cancel
     */
    cancelBindThirdUsingPost: (
      reqDTO: BindThirdReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/bind/third/cancel`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name BindThirdListUsingGet
     * @summary 第三方账号已绑定列表
     * @request GET:/bind/third/getBindList
     */
    bindThirdListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListCustomerThirdBindRespDTO, any>({
        path: `/bind/third/getBindList`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name IsBindThirdUsingPost
     * @summary 第三方账号是否已绑定系统账号
     * @request POST:/bind/third/isBind
     */
    isBindThirdUsingPost: (
      reqDTO: BindThirdReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdIsBindRespDTO, any>({
        path: `/bind/third/isBind`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  cancelAllCustomerCheck = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name CancelAllCustomerCheckUsingGet
     * @summary 注销全部账号校验
     * @request GET:/cancelAllCustomerCheck
     */
    cancelAllCustomerCheckUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/cancelAllCustomerCheck`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  cancelCustomer = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name CancelCustomerUsingGet
     * @summary 注销全部账号
     * @request GET:/cancelCustomer
     */
    cancelCustomerUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/cancelCustomer`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  cancelSubCustomer = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name CancelSubCustomerUsingGet
     * @summary 注销子账号
     * @request GET:/cancelSubCustomer
     */
    cancelSubCustomerUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/cancelSubCustomer`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  cancelSubCustomerCheck = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name CancelSubCustomerCheckUsingGet
     * @summary 注销子账号校验
     * @request GET:/cancelSubCustomerCheck
     */
    cancelSubCustomerCheckUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/cancelSubCustomerCheck`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  changeEmailsendEmail = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name ChangeEmailSendEmailUsingGet
     * @summary 更改邮箱发送邮件
     * @request GET:/changeEmailsendEmail
     */
    changeEmailSendEmailUsingGet: (
      query: {
        /**
         * buType
         * @format int32
         */
        buType?: number;
        /** newCustomerEmail */
        newCustomerEmail: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/changeEmailsendEmail`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  changeLogin = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name ChangeLoginUsingPost
     * @summary 切换登陆登录(2B-2C)
     * @request POST:/changeLogin
     */
    changeLoginUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/changeLogin`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  changeLoginByType = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name ChangeLoginByTypeUsingGet
     * @summary 根据类型切换登录
     * @request GET:/changeLoginByType
     */
    changeLoginByTypeUsingGet: (
      query: {
        /**
         * type
         * @format int32
         */
        type: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/changeLoginByType`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  changeMobile = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name ChangeMobileUsingPost
     * @summary 修改手机号码
     * @request POST:/changeMobile
     */
    changeMobileUsingPost: (
      reqDTO: ChangeMobileReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/changeMobile`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  changeNewEmail = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name ChangeNewEmailUsingPost
     * @summary 更改新邮箱
     * @request POST:/changeNewEmail
     */
    changeNewEmailUsingPost: (
      changeEmailReqDTO: ChangeEmailReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/changeNewEmail`,
        method: "POST",
        body: changeEmailReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  changePriceTrackingFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name ChangePriceTrackingFlagUsingGet
     * @summary 开启关闭价格跟踪
     * @request GET:/changePriceTrackingFlag
     */
    changePriceTrackingFlagUsingGet: (
      query: {
        /**
         * priceTrackingFlag
         * @format int32
         */
        priceTrackingFlag: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/changePriceTrackingFlag`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  changeShop = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name ChangeShopUsingGet
     * @summary 切换店铺
     * @request GET:/changeShop
     */
    changeShopUsingGet: (
      query: {
        /**
         * shopId
         * @format int64
         */
        shopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/changeShop`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  changeWarehouseTask = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name ChangeWarehouseTaskUsingPost
     * @summary 创建换仓任务
     * @request POST:/changeWarehouseTask
     */
    changeWarehouseTaskUsingPost: (
      changeWarehouseTaskReqDTO: ChangeWarehouseTaskReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/changeWarehouseTask`,
        method: "POST",
        body: changeWarehouseTaskReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  checkAdmin = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name CheckAdminUsingGet
     * @summary checkAdmin
     * @request GET:/checkAdmin
     */
    checkAdminUsingGet: (
      query: {
        /** userId */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/checkAdmin`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  checkPalletWhite = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name CheckPalletWhiteUsingGet1
     * @summary 检测货盘白名单
     * @request GET:/checkPalletWhite
     */
    checkPalletWhiteUsingGet1: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/checkPalletWhite`,
        method: "GET",
        ...params,
      }),
  };
  checkSmcBlack = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name CheckSmcBlackUsingGet
     * @summary 检测推广联盟黑名单
     * @request GET:/checkSMCBlack
     */
    checkSmcBlackUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/checkSMCBlack`,
        method: "GET",
        ...params,
      }),
  };
  clearCache = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name ClearCacheUsingGet
     * @summary 清空缓存
     * @request GET:/clearCache
     */
    clearCacheUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/clearCache`,
        method: "GET",
        ...params,
      }),
  };
  closeAutorenewQuestionnaire = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name CloseAutorenewQuestionnaireUsingPost
     * @summary 关闭自动续费问卷调查
     * @request POST:/closeAutorenewQuestionnaire
     */
    closeAutorenewQuestionnaireUsingPost: (
      questionnaire: JSONObject,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/closeAutorenewQuestionnaire`,
        method: "POST",
        body: questionnaire,
        type: ContentType.Json,
        ...params,
      }),
  };
  config = {
    /**
     * No description
     *
     * @tags customer-config-controller
     * @name GetUsingGet
     * @summary 获取用户配置
     * @request GET:/config/get
     */
    getUsingGet: (
      query: {
        /** configCode */
        configCode: string;
        /**
         * 级别 1-superCustomerId 2-mainCustomerId 3-customerId
         * @format int32
         */
        level?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerConfigRespDTO, any>({
        path: `/config/get`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-config-controller
     * @name GetStockNotifyConfigUsingGet
     * @summary 获取用户库存提醒配置信息
     * @request GET:/config/getStockNotifyConfig
     */
    getStockNotifyConfigUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBigdecimal, any>({
        path: `/config/getStockNotifyConfig`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-config-controller
     * @name GetStockNotifyConfigByCustomerIdUsingGet
     * @summary 获取用户库存提醒配置信息
     * @request GET:/config/getStockNotifyConfigByCustomerId
     */
    getStockNotifyConfigByCustomerIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBigdecimal, any>({
        path: `/config/getStockNotifyConfigByCustomerId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-config-controller
     * @name SaveUsingPost
     * @summary 保存用户配置
     * @request POST:/config/save
     */
    saveUsingPost: (
      saveCustomerConfigReqDTO: SaveCustomerConfigReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/config/save`,
        method: "POST",
        body: saveCustomerConfigReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-config-controller
     * @name SaveOrUpdateUsingPost
     * @summary 保存或更新用户配置
     * @request POST:/config/saveOrUpdate
     */
    saveOrUpdateUsingPost: (
      request: SaveOrUpdateCustomerConfigReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/config/saveOrUpdate`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-config-controller
     * @name SaveStockNotifyConfigUsingPost
     * @summary 保存用户库存提醒配置信息
     * @request POST:/config/saveStockNotifyConfig
     */
    saveStockNotifyConfigUsingPost: (
      request: SaveOrUpdateCustomerConfigReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/config/saveStockNotifyConfig`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),
  };
  create2D = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name Create2DUsingPost
     * @summary 创建2D账号
     * @request POST:/create2D
     */
    create2DUsingPost: (
      superCustomerIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseInt, any>({
        path: `/create2D`,
        method: "POST",
        body: superCustomerIds,
        type: ContentType.Json,
        ...params,
      }),
  };
  crossBorder = {
    /**
     * No description
     *
     * @tags shop
     * @name GetUsingPost
     * @summary get shop list
     * @request POST:/crossBorder/shop/list
     */
    getUsingPost: (dto: OpenBaseReqDto, params: RequestParams = {}) =>
      this.request<BizResponseListOpenShopListRespDTO, any>({
        path: `/crossBorder/shop/list`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  customer = {
    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name GetBeforeTodayExpireListUsingPost
     * @summary 查询会员信息List
     * @request POST:/customer/membership/getBeforeTodayExpireList
     */
    getBeforeTodayExpireListUsingPost: (
      queryDTO: CustomerMembershipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerMembershipResDTO, any>({
        path: `/customer/membership/getBeforeTodayExpireList`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name GetExpiresDateUsingGet
     * @summary 计算过期日期
     * @request GET:/customer/membership/getExpiresDate
     */
    getExpiresDateUsingGet: (
      query: {
        /**
         * start
         * @format date-time
         */
        start: string;
        /**
         * validPeriod
         * @format int32
         */
        validPeriod: number;
        /**
         * validPeriodUnit
         * @format int32
         */
        validPeriodUnit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/membership/getExpiresDate`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name GetExpiresDateBySuperCustomerIdUsingGet
     * @summary 基于会员等级数据计算过期日期
     * @request GET:/customer/membership/getExpiresDateBySuperCustomerId
     */
    getExpiresDateBySuperCustomerIdUsingGet: (
      query: {
        /**
         * idDelay
         * @format int64
         */
        idDelay: number;
        /**
         * membershipTemplateId
         * @format int64
         */
        membershipTemplateId?: number;
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
        /**
         * validPeriod
         * @format int32
         */
        validPeriod: number;
        /**
         * validPeriodUnit
         * @format int32
         */
        validPeriodUnit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/membership/getExpiresDateBySuperCustomerId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name InsertUsingPost
     * @summary 添加会员信息
     * @request POST:/customer/membership/insert
     */
    insertUsingPost: (
      dto: CustomerMembershipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/membership/insert`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name SelectCustomerMembershipUsingPost
     * @summary 查询会员信息
     * @request POST:/customer/membership/selectCustomerMembership
     */
    selectCustomerMembershipUsingPost: (
      queryDTO: CustomerMembershipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerMembershipResDTO, any>({
        path: `/customer/membership/selectCustomerMembership`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name SelectNoExpiredListByTemplateIdUsingPost
     * @summary 根据会员身份模板获取未过期用户列表
     * @request POST:/customer/membership/selectNoExpiredListByTemplateId
     */
    selectNoExpiredListByTemplateIdUsingPost: (
      query: {
        /**
         * membershipTemplateId
         * @format int64
         */
        membershipTemplateId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerMembershipResDTO, any>({
        path: `/customer/membership/selectNoExpiredListByTemplateId`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name UpdateByIdUsingPost
     * @summary 更新会员信息
     * @request POST:/customer/membership/updateById
     */
    updateByIdUsingPost: (
      dto: CustomerMembershipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/membership/updateById`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 会员信息列表操作
     * @name ValidMembershipUsingGet
     * @summary 查询会员信息/是否过期
     * @request GET:/customer/membership/validMembership
     */
    validMembershipUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/customer/membership/validMembership`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-service-controller
     * @name BizProcessUsingPost
     * @summary bizProcess
     * @request POST:/customer/service/echatBizProcess
     */
    bizProcessUsingPost: (reqDTO: EchatBizReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/customer/service/echatBizProcess`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-service-controller
     * @name EchatMsgPushUsingPost
     * @summary echatMsgPush
     * @request POST:/customer/service/echatMsgPush
     */
    echatMsgPushUsingPost: (body: JSONObject, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/customer/service/echatMsgPush`,
        method: "POST",
        body: body,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name ActivateSubCustomerUsingPost
     * @summary 激活子账号
     * @request POST:/customer/shop/activateSubCustomer
     */
    activateSubCustomerUsingPost: (
      reqDTO: AddSubCustomerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/activateSubCustomer`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name AddCustomerShopUsingPost
     * @summary 添加店铺
     * @request POST:/customer/shop/add
     */
    addCustomerShopUsingPost: (
      dto: AddCustomerShopReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/customer/shop/add`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name AddClearanceAddressUsingPost
     * @summary 添加清关地址
     * @request POST:/customer/shop/addClearanceAddress
     */
    addClearanceAddressUsingPost: (
      reqDTO: AddClearanceAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/customer/shop/addClearanceAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name AddShippingAddressUsingPost
     * @summary 添加收货地址
     * @request POST:/customer/shop/addShippingAddress
     */
    addShippingAddressUsingPost: (
      reqDTO: AddShippingAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/customer/shop/addShippingAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name ConvertAutoOrderFlagUsingPost
     * @summary 开启/关闭自动下单
     * @request POST:/customer/shop/auto/order/switch
     */
    convertAutoOrderFlagUsingPost: (
      dto: CustomerShopOptDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/customer/shop/auto/order/switch`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name DeleteClearanceAddressV2UsingPost
     * @summary 删除清关地址
     * @request POST:/customer/shop/deleteClearanceAddress/v2
     */
    deleteClearanceAddressV2UsingPost: (
      deleteClearanceAddressReqDTO: DeleteClearanceAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/deleteClearanceAddress/v2`,
        method: "POST",
        body: deleteClearanceAddressReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name DeleteClearanceAddressUsingPost
     * @summary 删除清关地址
     * @request POST:/customer/shop/deleteDefaultClearanceAddress
     */
    deleteClearanceAddressUsingPost: (
      query?: {
        /**
         * shopClearanceAddressId
         * @format int64
         */
        shopClearanceAddressId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/deleteDefaultClearanceAddress`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name DeleteDefaultShippingAddressUsingPost
     * @summary 删除收货地址
     * @request POST:/customer/shop/deleteShippingAddress
     */
    deleteDefaultShippingAddressUsingPost: (
      query?: {
        /**
         * shopShippingAddressId
         * @format int64
         */
        shopShippingAddressId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/deleteShippingAddress`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name DeleteDefaultShippingAddressV2UsingPost
     * @summary 删除收货地址
     * @request POST:/customer/shop/deleteShippingAddress/v2
     */
    deleteDefaultShippingAddressV2UsingPost: (
      deleteShippingAddressReqDTO: DeleteShippingAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/deleteShippingAddress/v2`,
        method: "POST",
        body: deleteShippingAddressReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetCustomerShopUsingPost1
     * @summary 取得用户店铺
     * @request POST:/customer/shop/get
     */
    getCustomerShopUsingPost1: (
      dto: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopRespDTO, any>({
        path: `/customer/shop/get`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetCustomerShopUsingPost
     * @summary 店铺分页_可根据账户id
     * @request POST:/customer/shop/get/shop
     */
    getCustomerShopUsingPost: (
      dto: GetCustomerShopListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/customer/shop/get/shop`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetBaseCustomerAuthStatusUsingPost
     * @summary 获取BASE店铺绑定且token失效
     * @request POST:/customer/shop/getBaseCustomerAuthStatus
     */
    getBaseCustomerAuthStatusUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/customer/shop/getBaseCustomerAuthStatus`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetBaseCustomerAuthStatusByShopIdUsingPost
     * @summary 根据店铺ID获取BASE店铺绑定且token失效
     * @request POST:/customer/shop/getBaseCustomerAuthStatusByShopId
     */
    getBaseCustomerAuthStatusByShopIdUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseCustomerShopRespDTO, any>({
        path: `/customer/shop/getBaseCustomerAuthStatusByShopId`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetClearanceAddressUsingGet
     * @summary 获取单个店铺清关地址
     * @request GET:/customer/shop/getClearanceAddress
     */
    getClearanceAddressUsingGet: (
      query?: {
        /**
         * shopClearanceAddressId
         * @format int64
         */
        shopClearanceAddressId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopClearanceAddressRespDTO, any>({
        path: `/customer/shop/getClearanceAddress`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetClearanceAddressListUsingGet
     * @summary 获取店铺收货清关列表
     * @request GET:/customer/shop/getClearanceAddressList
     */
    getClearanceAddressListUsingGet: (
      query?: {
        /** exportCountry */
        exportCountry?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListShopClearanceAddressRespDTO, any>({
        path: `/customer/shop/getClearanceAddressList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetShippingAddressUsingGet
     * @summary 获取单个店铺收货地址
     * @request GET:/customer/shop/getShippingAddress
     */
    getShippingAddressUsingGet: (
      query?: {
        /**
         * shopShippingAddressId
         * @format int64
         */
        shopShippingAddressId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopShippingAddressRespDTO, any>({
        path: `/customer/shop/getShippingAddress`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetShippingAddressListUsingGet
     * @summary 获取店铺收货地址列表
     * @request GET:/customer/shop/getShippingAddressList
     */
    getShippingAddressListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListShopShippingAddressRespDTO, any>({
        path: `/customer/shop/getShippingAddressList`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetShopNumLimitUsingGet
     * @summary 获取店铺数量限制
     * @request GET:/customer/shop/getShopNumLimit
     */
    getShopNumLimitUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseCustomerShopLimitRespDTO, any>({
        path: `/customer/shop/getShopNumLimit`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetShopPurchaseUsingGet
     * @summary 获取店铺采购配置信息
     * @request GET:/customer/shop/getShopPurchase
     */
    getShopPurchaseUsingGet: (
      query?: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId?: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopPurchaseRespDTO, any>({
        path: `/customer/shop/getShopPurchase`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name HasCustomerShopUsingGet
     * @summary 检查用户是否包含子账户
     * @request GET:/customer/shop/hasCustomerShop
     */
    hasCustomerShopUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/customer/shop/hasCustomerShop`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetCustomerShopListUsingPost
     * @summary 店铺列表
     * @request POST:/customer/shop/list
     */
    getCustomerShopListUsingPost: (
      dto: GetCustomerShopListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/customer/shop/list`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetAllCustomerSubShopListUsingPost
     * @summary 所有子店铺店铺列表
     * @request POST:/customer/shop/listSubAll
     */
    getAllCustomerSubShopListUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/customer/shop/listSubAll`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name GetCustomerShopPageUsingPost
     * @summary 店铺分页
     * @request POST:/customer/shop/page
     */
    getCustomerShopPageUsingPost: (
      dto: GetCustomerShopListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerShopRespDTO, any>({
        path: `/customer/shop/page`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name QueryUsingGet
     * @summary wms查询店铺分页数据
     * @request GET:/customer/shop/query
     */
    queryUsingGet: (
      query?: {
        customerShopName?: string;
        /** @format int32 */
        pageNum?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        startIndex?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerShopWmsRespDTO, any>({
        path: `/customer/shop/query`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name SetDefaultClearanceAddressUsingPost
     * @summary 清关地址设为-默认
     * @request POST:/customer/shop/setDefaultClearanceAddress
     */
    setDefaultClearanceAddressUsingPost: (
      reqDTO: UpdateClearanceDefaultAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/setDefaultClearanceAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name SetDefaultShippingAddressUsingPost
     * @summary 收货地址设为默认
     * @request POST:/customer/shop/setDefaultShippingAddress
     */
    setDefaultShippingAddressUsingPost: (
      reqDTO: UpdateShippingDefaultAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/setDefaultShippingAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name UpdateCustomerShopUsingPost
     * @summary 编辑店铺
     * @request POST:/customer/shop/update
     */
    updateCustomerShopUsingPost: (
      dto: UpdateCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/customer/shop/update`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name UpdateClearanceAddressUsingPost
     * @summary 更新清关地址
     * @request POST:/customer/shop/updateClearanceAddress
     */
    updateClearanceAddressUsingPost: (
      reqDTO: UpdateClearanceAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/customer/shop/updateClearanceAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name UpdateShippingAddressUsingPost
     * @summary 更新收货地址
     * @request POST:/customer/shop/updateShippingAddress
     */
    updateShippingAddressUsingPost: (
      reqDTO: UpdateShippingAddressReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/customer/shop/updateShippingAddress`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name UpdateShopDeliveryUsingPost
     * @summary 更新店发货配置信息
     * @request POST:/customer/shop/updateShopDelivery
     */
    updateShopDeliveryUsingPost: (
      reqDTO: UpdateShopDeliveryReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/updateShopDelivery`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户店铺
     * @name UpdateShopPurchaseUsingPost
     * @summary 更新店铺采购配置信息
     * @request POST:/customer/shop/updateShopPurchase
     */
    updateShopPurchaseUsingPost: (
      reqDTO: UpdateShopPurchaseReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/customer/shop/updateShopPurchase`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 工具类
     * @name AddCustomerShopUsingPost2
     * @summary 导入excel，建立关系
     * @request POST:/customer/tool/import_relation
     */
    addCustomerShopUsingPost2: (
      data: {
        /**
         * excelFile
         * @format binary
         */
        excelFile: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/customer/tool/import_relation`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  customerTag = {
    /**
     * No description
     *
     * @tags customer-tag-feign-api-impl
     * @name SearchUsingPost
     * @summary 根据客户ids和标签查询标签信息
     * @request POST:/customerTag/search
     */
    searchUsingPost: (req: CustomerTagSearchReq, params: RequestParams = {}) =>
      this.request<BizResponseListCustomerTagDTO, any>({
        path: `/customerTag/search`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  data = {
    /**
     * No description
     *
     * @tags 数据字典
     * @name SelectListByParentKeyUsingGet
     * @summary 根据父级字典key获取下级字典信息集合
     * @request GET:/data/dict/list
     */
    selectListByParentKeyUsingGet: (
      query: {
        /** parentKey */
        parentKey: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListDataDictRespDTO, any>({
        path: `/data/dict/list`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 数据字典
     * @name SelectOneByKeyUsingGet
     * @summary 根据字典key获取字典信息
     * @request GET:/data/dict/one
     */
    selectOneByKeyUsingGet: (
      query: {
        /** 字典key */
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseDataDictRespDTO, any>({
        path: `/data/dict/one`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 数据字典
     * @name SelectListByTypeUsingGet
     * @summary 根据类型获取下级字典信息集合
     * @request GET:/data/dict/selectListByType
     */
    selectListByTypeUsingGet: (
      query: {
        /**
         * type
         * @format int32
         */
        type: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListDataDictRespDTO, any>({
        path: `/data/dict/selectListByType`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  declaration = {
    /**
     * No description
     *
     * @tags 申报白名单接口
     * @name AddDeclarationWhitelistUsingPost
     * @summary 增加白名單
     * @request POST:/declaration/whitelist/add
     */
    addDeclarationWhitelistUsingPost: (
      mainCustomerIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/declaration/whitelist/add`,
        method: "POST",
        body: mainCustomerIds,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 申报白名单接口
     * @name CheckCustomerMainIdInWhitelistUsingPost
     * @summary 校验是否在白名单中
     * @request POST:/declaration/whitelist/check/{mainCustomerId}
     */
    checkCustomerMainIdInWhitelistUsingPost: (
      mainCustomerId: number,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/declaration/whitelist/check/${mainCustomerId}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 申报白名单接口
     * @name GetPageUsingPost
     * @summary 分页查询
     * @request POST:/declaration/whitelist/getPage
     */
    getPageUsingPost: (
      pageDTO: DeclarationWhitelistPageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageDeclarationWhitelistRespDTO, any>({
        path: `/declaration/whitelist/getPage`,
        method: "POST",
        body: pageDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 申报白名单接口
     * @name RemoveDeclarationWhitelistUsingPost
     * @summary 删除白名單
     * @request POST:/declaration/whitelist/removeById/{id}
     */
    removeDeclarationWhitelistUsingPost: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/declaration/whitelist/removeById/${id}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  defectiveProductRiskFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name DefectiveProductRiskFlagUsingGet
     * @summary 是否已读不良品风险弹窗
     * @request GET:/defectiveProductRiskFlag
     */
    defectiveProductRiskFlagUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/defectiveProductRiskFlag`,
        method: "GET",
        ...params,
      }),
  };
  deleteAccount = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name DeleteAccountUsingDelete
     * @summary 删除账号，危险操作
     * @request DELETE:/deleteAccount
     */
    deleteAccountUsingDelete: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
        /** token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/deleteAccount`,
        method: "DELETE",
        query: query,
        ...params,
      }),
  };
  depts = {
    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name AddDepartmentUsingPost
     * @summary 新增组织接口
     * @request POST:/depts/add
     */
    addDepartmentUsingPost: (
      reqDTO: AddDepartmentReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/depts/add`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name DeleteUsingDelete
     * @summary 批量删除组织机构公司部门（子公司，子部门）接口
     * @request DELETE:/depts/deleteByIds
     */
    deleteUsingDelete: (ids: string[], params: RequestParams = {}) =>
      this.request<BizResponseMapStringListDepartmentDetailRespDTO, any>({
        path: `/depts/deleteByIds`,
        method: "DELETE",
        body: ids,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name GetDepartmentUserUsingPost
     * @summary 根据组织目录id和条件查询目录下面的部门列表分页展示
     * @request POST:/depts/getDepartmentUser
     */
    getDepartmentUserUsingPost: (
      reqDTO: GetDepartmentUserReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageDepartmentDetailRespDTO, any>({
        path: `/depts/getDepartmentUser`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name GetTreeUsingPost
     * @summary 查询展示组织机构左侧目录
     * @request POST:/depts/getTree
     */
    getTreeUsingPost: (
      treeReqDTO: GetDepartmentTreeReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListDepartmentTreeRespDTO, any>({
        path: `/depts/getTree`,
        method: "POST",
        body: treeReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name GetTreeByDepIdUsingPost
     * @summary 查询根据组织机构目录id展示其下面的目录
     * @request POST:/depts/getTreeByDeptId
     */
    getTreeByDepIdUsingPost: (
      treeDeptIdVO: GetDepartmentTreeByIdReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListDepartmentTreeRespDTO, any>({
        path: `/depts/getTreeByDeptId`,
        method: "POST",
        body: treeDeptIdVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name GetTreeByNameUsingPost
     * @summary 用户角色添加用户条件查询
     * @request POST:/depts/getTreeByName
     */
    getTreeByNameUsingPost: (
      treeReqDTO: GetDepartmentTreeByNameReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListDepartmentTreeRespDTO, any>({
        path: `/depts/getTreeByName`,
        method: "POST",
        body: treeReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name UpdateUsingPut
     * @summary 修改公司部门（子部门，子公司）详细
     * @request PUT:/depts/update
     */
    updateUsingPut: (
      reqDTO: UpdateDepartmentReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/depts/update`,
        method: "PUT",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 组织架构目录接口
     * @name DetailUsingGet
     * @summary 查询组织机构详情
     * @request GET:/depts/{depId}
     */
    detailUsingGet: (depId: string, params: RequestParams = {}) =>
      this.request<BizResponseDepartmentDetailRespDTO, any>({
        path: `/depts/${depId}`,
        method: "GET",
        ...params,
      }),
  };
  dingding = {
    /**
     * @description 根据选择字段导出钉钉通讯录(该接口官方不支持)
     *
     * @tags 钉钉接口
     * @name ExportExcelUsingGet
     * @summary 根据选择字段导出钉钉通讯录(该接口官方不支持)
     * @request GET:/dingding/exportExcel
     */
    exportExcelUsingGet: (
      query: {
        /** columns */
        columns?: string;
        /** companyId */
        companyId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/dingding/exportExcel`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description 根据部门ID获取指定部门详情
     *
     * @tags 钉钉接口
     * @name GetDepartmentByIdUsingGet
     * @summary 根据部门ID获取指定部门详情
     * @request GET:/dingding/getDepartmentById
     */
    getDepartmentByIdUsingGet: (
      query: {
        /**
         * deptId
         * @format int64
         */
        deptId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseJSONObject, any>({
        path: `/dingding/getDepartmentById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description 获取某个部门下的所有子部门
     *
     * @tags 钉钉接口
     * @name GetDepartmentsUsingGet
     * @summary 获取某个部门下的所有子部门
     * @request GET:/dingding/getDepartments
     */
    getDepartmentsUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseJSONArray, any>({
        path: `/dingding/getDepartments`,
        method: "GET",
        ...params,
      }),

    /**
     * @description 获取全部的子部门和用户数据
     *
     * @tags 钉钉接口
     * @name GetDepartmentsAndUsersUsingGet
     * @summary 获取全部的子部门和用户数据
     * @request GET:/dingding/getDepartmentsAndUsers
     */
    getDepartmentsAndUsersUsingGet: (
      query: {
        /** companyId */
        companyId: string;
        /** userId */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseJSONArray, any>({
        path: `/dingding/getDepartmentsAndUsers`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description 获取指定部门中的用户详细信息(本接口只支持获取指定部门下的员工详情信息，子部门员工信息获取不到)
     *
     * @tags 钉钉接口
     * @name GetUserListByDepartmentIdUsingGet
     * @summary 获取指定部门中的用户详细信息
     * @request GET:/dingding/getUserListByDepartmentId
     */
    getUserListByDepartmentIdUsingGet: (
      query: {
        /** companyId */
        companyId: string;
        /**
         * deptId
         * @format int64
         */
        deptId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseJSONObject, any>({
        path: `/dingding/getUserListByDepartmentId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description 获取某个部门下的全部用户信息
     *
     * @tags 钉钉接口
     * @name GetUsersByDepartmentIdUsingGet
     * @summary 获取某个部门下的全部用户信息
     * @request GET:/dingding/getUsersByDepartmentId
     */
    getUsersByDepartmentIdUsingGet: (
      query: {
        /** companyId */
        companyId: string;
        /**
         * deptId
         * @format int64
         */
        deptId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseJSONObject, any>({
        path: `/dingding/getUsersByDepartmentId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 钉钉接口
     * @name QueryListUsingGet
     * @summary 获取全部公司钉钉信息表
     * @request GET:/dingding/queryList
     */
    queryListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListDingCompany, any>({
        path: `/dingding/queryList`,
        method: "GET",
        ...params,
      }),
  };
  distribute = {
    /**
     * No description
     *
     * @tags 客户分配
     * @name AddUserUsingPost
     * @summary 新增白名单
     * @request POST:/distribute/addUser
     */
    addUserUsingPost: (reqDTO: AddUserReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/distribute/addUser`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 客户分配
     * @name BatchModifyUsingPost
     * @summary 批量修改
     * @request POST:/distribute/batchModify
     */
    batchModifyUsingPost: (
      reqDTO: BatchModifyPurchaseReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/distribute/batchModify`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 客户分配
     * @name BatchRemoveUserUsingPost
     * @summary 单个/批量移除白名单
     * @request POST:/distribute/batchRemoveUser
     */
    batchRemoveUserUsingPost: (
      reqDTO: BatchRemoveUserReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/distribute/batchRemoveUser`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 客户分配
     * @name ListUsingPost
     * @summary 获取用户列表
     * @request POST:/distribute/list
     */
    listUsingPost: (
      reqDTO: QueryCustomerDistributeReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageQueryCustomerDistributeRespDTO, any>({
        path: `/distribute/list`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 客户分配
     * @name QueryChangeUrlUsersUsingPost
     * @summary 获取白名单用户列表
     * @request POST:/distribute/queryChangeUrlUsers
     */
    queryChangeUrlUsersUsingPost: (
      reqDTO: ChangeUrlWhiteUserReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageChangeUrlWhiteUserRespDTO, any>({
        path: `/distribute/queryChangeUrlUsers`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 客户分配
     * @name QueryCustomerOperateLogUsingGet
     * @summary 查询用户操作日志
     * @request GET:/distribute/queryOperateLog
     */
    queryCustomerOperateLogUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListQueryOperateLogRespDTO, any>({
        path: `/distribute/queryOperateLog`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  editLoginName = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name EditLoginNameUsingPost
     * @summary 修改登录名
     * @request POST:/editLoginName
     */
    editLoginNameUsingPost: (
      query: {
        /** loginName */
        loginName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/editLoginName`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  email = {
    /**
     * No description
     *
     * @tags email-send-feign-api-impl
     * @name SendEmailUsingPost
     * @summary sendEmail
     * @request POST:/email/send/single
     */
    sendEmailUsingPost: (req: EmailSendReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseEmailSendRespDTO, any>({
        path: `/email/send/single`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  emailLogin = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name EmailLoginUsingPost
     * @summary 邮箱验证登录
     * @request POST:/emailLogin
     */
    emailLoginUsingPost: (
      queryDTO: EmailLoginReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/emailLogin`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SendLoginEmailUsingPost
     * @summary 邮箱登录发送验证码
     * @request POST:/emailLogin/send/code
     */
    sendLoginEmailUsingPost: (
      checkEmailReqDTO: CheckEmailReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/emailLogin/send/code`,
        method: "POST",
        body: checkEmailReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  forgetPasswordResetPassword = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name ForgetPasswordResetPasswordUsingPost
     * @summary 忘记密码重置密码
     * @request POST:/forgetPasswordResetPassword
     */
    forgetPasswordResetPasswordUsingPost: (
      resetPasswordReqDTO: ResetPasswordReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/forgetPasswordResetPassword`,
        method: "POST",
        body: resetPasswordReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  forgetPasswordSendEmail = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name ForgetPasswordSendEmailUsingGet
     * @summary 忘记密码发送邮件
     * @request GET:/forgetPasswordSendEmail
     */
    forgetPasswordSendEmailUsingGet: (
      query: {
        /**
         * buType
         * @format int32
         */
        buType?: number;
        /** customerEmail */
        customerEmail: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/forgetPasswordSendEmail`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  free = {
    /**
     * No description
     *
     * @tags free-count-controller
     * @name DeductionUsingPost
     * @summary deduction
     * @request POST:/free/count/deduction
     */
    deductionUsingPost: (
      dto: FreeCountOperationReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/free/count/deduction`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags free-count-controller
     * @name GetOemChargeUsingGet
     * @summary getOemCharge
     * @request GET:/free/count/getOemCharge
     */
    getOemChargeUsingGet: (
      query: {
        /**
         * level
         * @format int32
         */
        level: number;
        /** stationCode */
        stationCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBigdecimal, any>({
        path: `/free/count/getOemCharge`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags free-count-controller
     * @name RollbackUsingPost
     * @summary rollback
     * @request POST:/free/count/rollback
     */
    rollbackUsingPost: (
      dto: FreeCountOperationReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/free/count/rollback`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags free-count-controller
     * @name SelectFreeCountByTypeUsingGet
     * @summary 根据类型查询免费次数
     * @request GET:/free/count/selectFreeCountByType
     */
    selectFreeCountByTypeUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId?: number;
        /**
         * type
         * @format int32
         */
        type: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseFreeCountRespDTO, any>({
        path: `/free/count/selectFreeCountByType`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  frog = {
    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetArchiveUsingPost
     * @summary 获取归档列表
     * @request POST:/frog/article/archive
     */
    getArchiveUsingPost: (
      request: GetFrogArticleArchivePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListFrogArticleArchiveSortRespDTO, any>({
        path: `/frog/article/archive`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetArchivePageUsingPost
     * @summary 查询归档文章分页
     * @request POST:/frog/article/archive/page
     */
    getArchivePageUsingPost: (
      request: GetFrogArticleArchivePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageFrogArticleRespDTO, any>({
        path: `/frog/article/archive/page`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name AddViewCountUsingGet
     * @summary 累加阅读量
     * @request GET:/frog/article/count
     */
    addViewCountUsingGet: (
      query: {
        /**
         * frogArticleId
         * @format int64
         */
        frogArticleId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/frog/article/count`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name CreateArticleUsingPost
     * @summary 创建青蛙文章
     * @request POST:/frog/article/create
     */
    createArticleUsingPost: (
      article: AddFrogArticleReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/create`,
        method: "POST",
        body: article,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name DeleteArticleUsingDelete
     * @summary 删除文章
     * @request DELETE:/frog/article/delete
     */
    deleteArticleUsingDelete: (
      query: {
        /**
         * frogArticleId
         * @format int64
         */
        frogArticleId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/delete`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetFrogArticleDetailUsingGet
     * @summary 文章详情
     * @request GET:/frog/article/detail
     */
    getFrogArticleDetailUsingGet: (
      query: {
        /**
         * frogArticleId
         * @format int64
         */
        frogArticleId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseFrogArticleDetailRespDTO, any>({
        path: `/frog/article/detail`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetFrogArticleFootUsingPost
     * @summary 查询青蛙文章浏览记录分页（前台）
     * @request POST:/frog/article/foot/page
     */
    getFrogArticleFootUsingPost: (
      request: GetFrogArticlePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageFrogArticleRespDTO, any>({
        path: `/frog/article/foot/page`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetPrepAndNextUsingPost
     * @summary 查询当前文章上一篇/下一篇文章
     * @request POST:/frog/article/get/prepAndNext
     */
    getPrepAndNextUsingPost: (
      request: GetFrogArticlePrepAndNextReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseFrogArticlePrepAndNextRespDTO, any>({
        path: `/frog/article/get/prepAndNext`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetHotFrogArticleUsingPost
     * @summary 查询热门文章分页
     * @request POST:/frog/article/hot/page
     */
    getHotFrogArticleUsingPost: (
      dto: GetFrogArticleArchivePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageHotFrogArticleRespDTO, any>({
        path: `/frog/article/hot/page`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetManageFrogArticleUsingPost
     * @summary 查询青蛙文章分页（后台）
     * @request POST:/frog/article/manage/page
     */
    getManageFrogArticleUsingPost: (
      request: GetManageFrogArticlePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageManageFrogArticleRespDTO, any>({
        path: `/frog/article/manage/page`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetFrogArticleUsingPost
     * @summary 查询青蛙文章分页（前台）
     * @request POST:/frog/article/page
     */
    getFrogArticleUsingPost: (
      request: GetFrogArticlePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageFrogArticleRespDTO, any>({
        path: `/frog/article/page`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name GetAllFrogArticleUsingPost
     * @summary 查询除平台频道外所有青蛙文章分页（前台）
     * @request POST:/frog/article/page/all
     */
    getAllFrogArticleUsingPost: (
      request: GetAllFrogArticlePageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageFrogArticleRespDTO, any>({
        path: `/frog/article/page/all`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name PinTopArticleUsingGet
     * @summary 置顶文章
     * @request GET:/frog/article/pinTop
     */
    pinTopArticleUsingGet: (
      query: {
        /**
         * frogArticleId
         * @format int64
         */
        frogArticleId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/pinTop`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name SignHotFrogArticleUsingPost
     * @summary 标记热门文章
     * @request POST:/frog/article/sign/hot
     */
    signHotFrogArticleUsingPost: (
      query?: {
        frogArticleMonth?: string;
        frogArticleYear?: string;
        /** @format int32 */
        pageNum?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        startIndex?: number;
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListHotFrogArticleSortDTO, any>({
        path: `/frog/article/sign/hot`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name ToggleStatusUsingPut
     * @summary 开启/关闭文章可见状态
     * @request PUT:/frog/article/toggle/status
     */
    toggleStatusUsingPut: (
      dto: UpdateFrogArticleStatusReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/toggle/status`,
        method: "PUT",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name DeleteArticleTypeUsingGet
     * @summary 删除青蛙文章分类
     * @request GET:/frog/article/type/delete
     */
    deleteArticleTypeUsingGet: (
      query: {
        /**
         * id
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/type/delete`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name ArticleTypeListUsingGet
     * @summary 青蛙文章分类列表
     * @request GET:/frog/article/type/list
     */
    articleTypeListUsingGet: (
      query: {
        /** stationCode */
        stationCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListFrogArticleType, any>({
        path: `/frog/article/type/list`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name CustomerArticleTypeListUsingGet
     * @summary 客户端青蛙文章分类列表(有文章的分类)
     * @request GET:/frog/article/type/list/customer
     */
    customerArticleTypeListUsingGet: (
      query: {
        /** stationCode */
        stationCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListFrogArticleType, any>({
        path: `/frog/article/type/list/customer`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name CreateArticleTypeUsingPost
     * @summary 保存青蛙文章分类
     * @request POST:/frog/article/type/save
     */
    createArticleTypeUsingPost: (
      typeList: FrogArticleType[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/type/save`,
        method: "POST",
        body: typeList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name UnPinTopArticleUsingGet
     * @summary 取消置顶文章
     * @request GET:/frog/article/unPinTop
     */
    unPinTopArticleUsingGet: (
      query: {
        /**
         * frogArticleId
         * @format int64
         */
        frogArticleId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/unPinTop`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 青蛙文章接口
     * @name UpdateArticleUsingPost
     * @summary 修改青蛙文章
     * @request POST:/frog/article/update
     */
    updateArticleUsingPost: (
      article: UpdateFrogArticleReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/frog/article/update`,
        method: "POST",
        body: article,
        type: ContentType.Json,
        ...params,
      }),
  };
  generateCode = {
    /**
     * No description
     *
     * @tags customer-invitation-feign-api-impl
     * @name GenerateCodeUsingGet
     * @summary 生成推广码
     * @request GET:/generateCode
     */
    generateCodeUsingGet: (
      query: {
        /** superCustomerId */
        superCustomerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/generateCode`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getAdminRoles = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetAdminRolesUsingPost
     * @summary getAdminRoles
     * @request POST:/getAdminRoles
     */
    getAdminRolesUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseListManageRoleRespDTO, any>({
        path: `/getAdminRoles`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  getAgentCustomerIdByDirectId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetAgentCustomerIdByDirectIdUsingGet
     * @summary getAgentCustomerIdByDirectId
     * @request GET:/getAgentCustomerIdByDirectId
     */
    getAgentCustomerIdByDirectIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/getAgentCustomerIdByDirectId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getAllArea = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name GetAllAreaUsingGet
     * @summary 获取所有地址列表，会存储到redis
     * @request GET:/getAllArea
     */
    getAllAreaUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListIntAreaDTO, any>({
        path: `/getAllArea`,
        method: "GET",
        ...params,
      }),
  };
  getAllDepartment = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetAllDepartmentUsingGet
     * @summary getAllDepartment
     * @request GET:/getAllDepartment
     */
    getAllDepartmentUsingGet: (
      query: {
        /** token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListDepartmentDetailRespDTO, any>({
        path: `/getAllDepartment`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getAllMainCustomer = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetAllMainCustomerUsingPost
     * @summary getAllMainCustomer
     * @request POST:/getAllMainCustomer
     */
    getAllMainCustomerUsingPost: (
      reqDTO: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerDetailManagerRespDTO, any>({
        path: `/getAllMainCustomer`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getAreaById = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name GetAreaByIdUsingGet
     * @summary 查询地区信息feign
     * @request GET:/getAreaById
     */
    getAreaByIdUsingGet: (
      query: {
        /**
         * intAreaId
         * @format int64
         */
        intAreaId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/getAreaById`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getAreaByIdOnly = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name GetAreaByIdOnlyUsingGet
     * @summary 查询地区信息通过id,没有下级feign
     * @request GET:/getAreaByIdOnly
     */
    getAreaByIdOnlyUsingGet: (
      query: {
        /**
         * intAreaId
         * @format int64
         */
        intAreaId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/getAreaByIdOnly`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getAreaByIds = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name GetAreaByIdsUsingPost
     * @summary 查询地区信息feign
     * @request POST:/getAreaByIds
     */
    getAreaByIdsUsingPost: (
      queryDTO: IntAreaQueryDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListIntAreaDTO, any>({
        path: `/getAreaByIds`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getAreaByLevelOnly = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name GetAreaByLevelOnlyUsingGet
     * @summary 查询地区信息通过地区等级,没有下级feign
     * @request GET:/getAreaByLevelOnly
     */
    getAreaByLevelOnlyUsingGet: (
      query?: {
        /**
         * 查询级别： 1洲 2国 3省
         * @format int64
         */
        level?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListIntAreaDTO, any>({
        path: `/getAreaByLevelOnly`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getByNationCodes = {
    /**
     * No description
     *
     * @tags customer-station-feign-api-impl
     * @name GetByNationCodesUsingGet
     * @summary 根据国家code查询
     * @request GET:/getByNationCodes
     */
    getByNationCodesUsingGet: (
      query: {
        /** nationCodes */
        nationCodes: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerStationDTO, any>({
        path: `/getByNationCodes`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getByStationCode = {
    /**
     * No description
     *
     * @tags customer-station-feign-api-impl
     * @name GetByStationCodeUsingGet
     * @summary 根据站点查询
     * @request GET:/getByStationCode
     */
    getByStationCodeUsingGet: (
      query: {
        /** stationCode */
        stationCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerStationDTO, any>({
        path: `/getByStationCode`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCanTransformList = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCanTransformListUsingGet
     * @summary 获取可转账的账号列表
     * @request GET:/getCanTransformList
     */
    getCanTransformListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListCustomerCanTransformRespDTO, any>({
        path: `/getCanTransformList`,
        method: "GET",
        ...params,
      }),
  };
  getCanTransformListBySuperId = {
    /**
     * No description
     *
     * @tags customer-invitation-feign-api-impl
     * @name GetCanTransformListBySuperIdUsingGet
     * @summary 获取可以提现的列表
     * @request GET:/getCanTransformListBySuperId
     */
    getCanTransformListBySuperIdUsingGet: (
      query: {
        /** superCustomerId */
        superCustomerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerCanTransformRespDTO, any>({
        path: `/getCanTransformListBySuperId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getClientVersion = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name GetClientVersionUsingPost
     * @summary 获取前端版本号
     * @request POST:/getClientVersion
     */
    getClientVersionUsingPost: (
      query: {
        /**
         * project
         * @format int64
         */
        project: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/getClientVersion`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCountByKey = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name GetCountByKeyUsingGet
     * @summary 根据key获取数量
     * @request GET:/getCountByKey
     */
    getCountByKeyUsingGet: (
      query: {
        /** key */
        key: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/getCountByKey`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomer2AgencyGoodsSign = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomer2AgencyGoodsSignUsingGet
     * @summary 获取直采用户跳转代采是否弹框标识
     * @request GET:/getCustomer2AgencyGoodsSign
     */
    getCustomer2AgencyGoodsSignUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/getCustomer2AgencyGoodsSign`,
        method: "GET",
        ...params,
      }),
  };
  getCustomer2AgencySign = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomer2AgencySignUsingGet
     * @summary 获取直采用户跳转代采是否弹框标识
     * @request GET:/getCustomer2AgencySign
     */
    getCustomer2AgencySignUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/getCustomer2AgencySign`,
        method: "GET",
        ...params,
      }),
  };
  getCustomerByDto = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerByDtoUsingPost
     * @summary getCustomerByDto
     * @request POST:/getCustomerByDto
     */
    getCustomerByDtoUsingPost: (
      reqDTO: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerByDto`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerByGoogleUrl = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerByGoogleUrlUsingGet
     * @summary 通过谷歌表获取用户信息
     * @request GET:/getCustomerByGoogleUrl
     */
    getCustomerByGoogleUrlUsingGet: (
      query: {
        /** url */
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomer, any>({
        path: `/getCustomerByGoogleUrl`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerByMainCustomerId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerByMainCustomerIdUsingPost
     * @summary getCustomerByMainCustomerId
     * @request POST:/getCustomerByMainCustomerId
     */
    getCustomerByMainCustomerIdUsingPost: (
      reqDTO: GetCustomerByMainCustomerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerByMainCustomerId`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerByManageId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerBySuperAndManageIdUsingPost
     * @summary getCustomerBySuperAndManageId
     * @request POST:/getCustomerByManageId
     */
    getCustomerBySuperAndManageIdUsingPost: (
      queryCustomerDetailManagerReqDTO: QueryCustomerDetailManagerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerByManageId`,
        method: "POST",
        body: queryCustomerDetailManagerReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerByShopId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerByShopIdUsingGet
     * @summary getCustomerByShopId
     * @request GET:/getCustomerByShopId
     */
    getCustomerByShopIdUsingGet: (
      query: {
        /**
         * shopId
         * @format int64
         */
        shopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getCustomerByShopId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerByShopIds = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerByShopIdsUsingPost
     * @summary getCustomerByShopIds
     * @request POST:/getCustomerByShopIds
     */
    getCustomerByShopIdsUsingPost: (
      query: {
        /** shopIds */
        shopIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerByShopIds`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerBySuperId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerBySuperIdUsingGet
     * @summary getCustomerBySuperId
     * @request GET:/getCustomerBySuperId
     */
    getCustomerBySuperIdUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerBySuperId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerBySuperIds = {
    /**
     * No description
     *
     * @tags customer-invitation-feign-api-impl
     * @name GetCustomerBySuperIdsUsingGet
     * @summary 获取用户信息
     * @request GET:/getCustomerBySuperIds
     */
    getCustomerBySuperIdsUsingGet: (
      query: {
        /** superCustomerIds */
        superCustomerIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerBySuperIds`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerDetail = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerDetailUsingGet1
     * @summary getCustomerDetail
     * @request GET:/getCustomerDetail
     */
    getCustomerDetailUsingGet1: (
      query: {
        /** token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getCustomerDetail`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerDetailByFullName = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerDetailByFullNameUsingGet
     * @summary getCustomerDetailByFullName
     * @request GET:/getCustomerDetailByFullName
     */
    getCustomerDetailByFullNameUsingGet: (
      query?: {
        /** unificationCustomerFullName */
        unificationCustomerFullName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerDetailByFullName`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerDetailById = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerDetailByIdUsingGet
     * @summary getCustomerDetailById
     * @request GET:/getCustomerDetailById
     */
    getCustomerDetailByIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getCustomerDetailById`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerDetailByIdList = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerDetailByIdListUsingPost
     * @summary getCustomerDetailByIdList
     * @request POST:/getCustomerDetailByIdList
     */
    getCustomerDetailByIdListUsingPost: (
      customerId: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerDetailByIdList`,
        method: "POST",
        body: customerId,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerDetailByManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerDetailByManagerUsingPost
     * @summary getCustomerDetailByManager
     * @request POST:/getCustomerDetailByManager
     */
    getCustomerDetailByManagerUsingPost: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
        /** userId */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailManagerRespDTO, any>({
        path: `/getCustomerDetailByManager`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerDetailByMarketing = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name CloseAutorenewQuestionnaireUsingGet
     * @summary 根据用户信息查用户-营销策略
     * @request GET:/getCustomerDetailByMarketing
     */
    closeAutorenewQuestionnaireUsingGet: (
      query?: {
        /** message */
        message?: string;
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getCustomerDetailByMarketing`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerDetails = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerDetailUsingGet
     * @summary 获取用户列表详情
     * @request GET:/getCustomerDetails
     */
    getCustomerDetailUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getCustomerDetails`,
        method: "GET",
        ...params,
      }),
  };
  getCustomerIdByFullName = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerIdByFullNameUsingGet
     * @summary getCustomerIdByFullName
     * @request GET:/getCustomerIdByFullName
     */
    getCustomerIdByFullNameUsingGet: (
      query: {
        /** unificationCustomerFullName */
        unificationCustomerFullName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListLong, any>({
        path: `/getCustomerIdByFullName`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerIdsByManagerId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerIdsByManagerIdUsingGet
     * @summary getCustomerIdsByManagerId
     * @request GET:/getCustomerIdsByManagerId
     */
    getCustomerIdsByManagerIdUsingGet: (
      query: {
        /** managerId */
        managerId: string;
        /** roleEnum */
        roleEnum?:
          | "ADMIN"
          | "CUSTOMER_DIRECTOR"
          | "CUSTOMER_MANAGER"
          | "MARKETING_MANAGER"
          | "PURCHASER"
          | "MERCHANDISER"
          | "PURCHASER_MANAGER"
          | "MERCHANDISER_MANAGER"
          | "OEM_PURCHASER_MANAGER"
          | "BLACK_SUPPLIER_AUDITOR"
          | "OEM_PURCHASER"
          | "FINANCE_DIRECTOR"
          | "FINANCE_CASHIER"
          | "FINANCE_ACCOUNTANT"
          | "FINANCE_JP_ACCOUNTANT"
          | "ONLINE_CS"
          | "BUYER"
          | "BUYER_MANAGER"
          | "AFTER_SALES_COMPENSATION";
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseHashSetLong, any>({
        path: `/getCustomerIdsByManagerId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerIsNewMembership = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerIsNewMembershipUsingGet
     * @summary 获取用户是否主动开启过新会员
     * @request GET:/getCustomerIsNewMembership
     */
    getCustomerIsNewMembershipUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/getCustomerIsNewMembership`,
        method: "GET",
        ...params,
      }),
  };
  getCustomerList = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerListUsingPost
     * @summary 获取用户列表
     * @request POST:/getCustomerList
     */
    getCustomerListUsingPost: (
      reqDTO: GetCustomerListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerItemRespDTO, any>({
        path: `/getCustomerList`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerListNewUsingPost
     * @summary 获取用户列表
     * @request POST:/getCustomerList/new
     */
    getCustomerListNewUsingPost: (
      reqDTO: GetCustomerListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerItemRespDTO, any>({
        path: `/getCustomerList/new`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerListAuth = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerListAuthUsingPost
     * @summary 获取用户列表带权限限制
     * @request POST:/getCustomerListAuth
     */
    getCustomerListAuthUsingPost: (
      reqDTO: GetCustomerListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerItemRespDTO, any>({
        path: `/getCustomerListAuth`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerListByCustomerIds = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerListUsingPost1
     * @summary getCustomerList
     * @request POST:/getCustomerListByCustomerIds
     */
    getCustomerListUsingPost1: (
      reqDTO: GetCustomerListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerItemRespDTO, any>({
        path: `/getCustomerListByCustomerIds`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerMembership = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerMembershipUsingGet
     * @summary 获取登陆用户会员信息
     * @request GET:/getCustomerMembership
     */
    getCustomerMembershipUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseCustomerMembership, any>({
        path: `/getCustomerMembership`,
        method: "GET",
        ...params,
      }),
  };
  getCustomerMembershipById = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerMembershipByIdUsingGet
     * @summary getCustomerMembershipById
     * @request GET:/getCustomerMembershipById
     */
    getCustomerMembershipByIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerMembership, any>({
        path: `/getCustomerMembershipById`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerOverview = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerOverviewUsingPost
     * @summary 获取账户概览-废弃
     * @request POST:/getCustomerOverview
     */
    getCustomerOverviewUsingPost: (
      reqDTO: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerOverviewRespDTO, any>({
        path: `/getCustomerOverview`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerOverviewOtherShop = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerOverviewOtherShopUsingPost
     * @summary 获取账户概览-全部店铺信息
     * @request POST:/getCustomerOverviewOtherShop
     */
    getCustomerOverviewOtherShopUsingPost: (
      reqDTO: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerOverviewRespDTO, any>({
        path: `/getCustomerOverviewOtherShop`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerOverviewOwnerShop = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerOverviewOwnerShopUsingPost
     * @summary 获取账户概览-当前店铺
     * @request POST:/getCustomerOverviewOwnerShop
     */
    getCustomerOverviewOwnerShopUsingPost: (
      reqDTO: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerOverviewRespDTO, any>({
        path: `/getCustomerOverviewOwnerShop`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerOverviewWorkbenchInfo = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetCustomerOverviewWorkbenchInfoUsingPost
     * @summary 获取账户概览-当前店铺-工作台新
     * @request POST:/getCustomerOverviewWorkbenchInfo
     */
    getCustomerOverviewWorkbenchInfoUsingPost: (
      reqDTO: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerOverviewRespDTO, any>({
        path: `/getCustomerOverviewWorkbenchInfo`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getCustomerShopBySuperId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerShopBySuperIdUsingGet
     * @summary getCustomerShopBySuperId
     * @request GET:/getCustomerShopBySuperId
     */
    getCustomerShopBySuperIdUsingGet: (
      query: {
        /** superCustomerIds */
        superCustomerIds: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopBySuperRespDTO, any>({
        path: `/getCustomerShopBySuperId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getCustomerSimple = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetCustomerSimpleUsingGet
     * @summary getCustomerSimple
     * @request GET:/getCustomerSimple
     */
    getCustomerSimpleUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseCustomerRespDTO, any>({
        path: `/getCustomerSimple`,
        method: "GET",
        ...params,
      }),
  };
  getDefaultCustomerBySuperId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetDefaultCustomerBySuperIdUsingGet
     * @summary getDefaultCustomerBySuperId
     * @request GET:/getDefaultCustomerBySuperId
     */
    getDefaultCustomerBySuperIdUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getDefaultCustomerBySuperId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getDetailBySystem = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetDetailBySystemUsingGet
     * @summary 后台获取用户详情,新建寻源单用
     * @request GET:/getDetailBySystem
     */
    getDetailBySystemUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getDetailBySystem`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getMainCustomerDetail = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetMainCustomerDetailUsingGet
     * @summary getMainCustomerDetail
     * @request GET:/getMainCustomerDetail
     */
    getMainCustomerDetailUsingGet: (
      query: {
        /** token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailRespDTO, any>({
        path: `/getMainCustomerDetail`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getManageIdBySupervisionManagerIdAndRoles = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetManageIdBySupervisionManagerIdAndRolesUsingGet
     * @summary getManageIdBySupervisionManagerIdAndRoles
     * @request GET:/getManageIdBySupervisionManagerIdAndRoles
     */
    getManageIdBySupervisionManagerIdAndRolesUsingGet: (
      query: {
        /** managerId */
        managerId: string;
        /** roleEnums */
        roleEnums:
          | "ADMIN"
          | "CUSTOMER_DIRECTOR"
          | "CUSTOMER_MANAGER"
          | "MARKETING_MANAGER"
          | "PURCHASER"
          | "MERCHANDISER"
          | "PURCHASER_MANAGER"
          | "MERCHANDISER_MANAGER"
          | "OEM_PURCHASER_MANAGER"
          | "BLACK_SUPPLIER_AUDITOR"
          | "OEM_PURCHASER"
          | "FINANCE_DIRECTOR"
          | "FINANCE_CASHIER"
          | "FINANCE_ACCOUNTANT"
          | "FINANCE_JP_ACCOUNTANT"
          | "ONLINE_CS"
          | "BUYER"
          | "BUYER_MANAGER"
          | "AFTER_SALES_COMPENSATION";
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseHashSetLong, any>({
        path: `/getManageIdBySupervisionManagerIdAndRoles`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getManageUserById = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManageUserByIdUsingPost
     * @summary getManageUserById
     * @request POST:/getManageUserById
     */
    getManageUserByIdUsingPost: (userId: string, params: RequestParams = {}) =>
      this.request<BizResponseManageUserRespDTO, any>({
        path: `/getManageUserById`,
        method: "POST",
        body: userId,
        type: ContentType.Json,
        ...params,
      }),
  };
  getManageUserByToken = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManageUserByTokenUsingGet
     * @summary getManageUserByToken
     * @request GET:/getManageUserByToken
     */
    getManageUserByTokenUsingGet: (
      query: {
        /** token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseManageUserRespDTO, any>({
        path: `/getManageUserByToken`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getManageUserList = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManageUserListUsingPost
     * @summary getManageUserList
     * @request POST:/getManageUserList
     */
    getManageUserListUsingPost: (
      userIds: string[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/getManageUserList`,
        method: "POST",
        body: userIds,
        type: ContentType.Json,
        ...params,
      }),
  };
  getManageUserListByNickNameList = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManageUserListByNickNameListUsingPost
     * @summary getManageUserListByNickNameList
     * @request POST:/getManageUserListByNickNameList
     */
    getManageUserListByNickNameListUsingPost: (
      nickNames: string[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/getManageUserListByNickNameList`,
        method: "POST",
        body: nickNames,
        type: ContentType.Json,
        ...params,
      }),
  };
  getManageUserListByNickNames = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManageUserListByNickNamesUsingGet
     * @summary getManageUserListByNickNames
     * @request GET:/getManageUserListByNickNames
     */
    getManageUserListByNickNamesUsingGet: (
      query: {
        /** roleId */
        roleId: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/getManageUserListByNickNames`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getManageUserListByRoleId = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManageUserListByRoleIdUsingGet
     * @summary getManageUserListByRoleId
     * @request GET:/getManageUserListByRoleId
     */
    getManageUserListByRoleIdUsingGet: (
      query: {
        /** roleId */
        roleId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/getManageUserListByRoleId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getManagerDetailByCustomerId = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetManagerDetailByCustomerIdUsingGet
     * @summary getManagerDetailByCustomerId
     * @request GET:/getManagerDetailByCustomerId
     */
    getManagerDetailByCustomerIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseUserManagerDetailRespDTO, any>({
        path: `/getManagerDetailByCustomerId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getNationByIdOnly = {
    /**
     * No description
     *
     * @tags area-feign-api-impl
     * @name GetNationByIdOnlyUsingGet
     * @summary 查询国家信息通过code,没有下级feign
     * @request GET:/getNationByIdOnly
     */
    getNationByIdOnlyUsingGet: (
      query: {
        /** code */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseIntAreaDTO, any>({
        path: `/getNationByIdOnly`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getPurchaserRole = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetPurchaserRoleUsingGet
     * @summary getPurchaserRole
     * @request GET:/getPurchaserRole
     */
    getPurchaserRoleUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseManageRoleRespDTO, any>({
        path: `/getPurchaserRole`,
        method: "GET",
        ...params,
      }),
  };
  getRoleByCode = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetPurchaserRoleByCodeUsingGet
     * @summary getPurchaserRoleByCode
     * @request GET:/getRoleByCode
     */
    getPurchaserRoleByCodeUsingGet: (
      query: {
        /** code */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseManageRoleRespDTO, any>({
        path: `/getRoleByCode`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getRoleList = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetRoleListUsingPost
     * @summary getRoleList
     * @request POST:/getRoleList
     */
    getRoleListUsingPost: (roleIds: string[], params: RequestParams = {}) =>
      this.request<BizResponseListManageRoleRespDTO, any>({
        path: `/getRoleList`,
        method: "POST",
        body: roleIds,
        type: ContentType.Json,
        ...params,
      }),
  };
  getRolesById = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetRolesByIdUsingPost
     * @summary getRolesById
     * @request POST:/getRolesById
     */
    getRolesByIdUsingPost: (userId: string, params: RequestParams = {}) =>
      this.request<BizResponseListManageRoleRespDTO, any>({
        path: `/getRolesById`,
        method: "POST",
        body: userId,
        type: ContentType.Json,
        ...params,
      }),
  };
  getRolesByMenuId = {
    /**
     * No description
     *
     * @tags manage-feign-api-impl
     * @name GetRolesByMenuIdUsingPost
     * @summary getRolesByMenuId
     * @request POST:/getRolesByMenuId
     */
    getRolesByMenuIdUsingPost: (menuId: string, params: RequestParams = {}) =>
      this.request<BizResponseListManageRoleRespDTO, any>({
        path: `/getRolesByMenuId`,
        method: "POST",
        body: menuId,
        type: ContentType.Json,
        ...params,
      }),
  };
  getShopOverview = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetShopOverviewUsingPost
     * @summary 获取店铺情报
     * @request POST:/getShopOverview
     */
    getShopOverviewUsingPost: (
      reqDTO: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopOverviewRespDTO, any>({
        path: `/getShopOverview`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getSubCustomerDetailByManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetSubCustomerDetailByManagerUsingPost
     * @summary getSubCustomerDetailByManager
     * @request POST:/getSubCustomerDetailByManager
     */
    getSubCustomerDetailByManagerUsingPost: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDetailManagerRespDTO, any>({
        path: `/getSubCustomerDetailByManager`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  getSubCustomerList = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetSubCustomerListUsingGet
     * @summary 获取子账号列表
     * @request GET:/getSubCustomerList
     */
    getSubCustomerListUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListCustomerDetailRespDTO, any>({
        path: `/getSubCustomerList`,
        method: "GET",
        ...params,
      }),
  };
  getSumAmountGroupBySuperCustomerId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetSumAmountGroupBySuperCustomerIdUsingGet
     * @summary getSumAmountGroupBySuperCustomerId
     * @request GET:/getSumAmountGroupBySuperCustomerId
     */
    getSumAmountGroupBySuperCustomerIdUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListMembershipOrderDTO, any>({
        path: `/getSumAmountGroupBySuperCustomerId`,
        method: "GET",
        ...params,
      }),
  };
  getSuperCustomerBySuperId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name GetSuperCustomerBySuperIdUsingGet
     * @summary getSuperCustomerBySuperId
     * @request GET:/getSuperCustomerBySuperId
     */
    getSuperCustomerBySuperIdUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerRespDTO, any>({
        path: `/getSuperCustomerBySuperId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  getWhileList = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name GetWhileListUsingPost
     * @summary 获取白名单
     * @request POST:/getWhileList
     */
    getWhileListUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseListLong, any>({
        path: `/getWhileList`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  hasSubscriptionOrder = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name HasSubscriptionOrderUsingPost
     * @summary hasSubscriptionOrder
     * @request POST:/hasSubscriptionOrder
     */
    hasSubscriptionOrderUsingPost: (
      query: {
        /** nextPaymentDate */
        nextPaymentDate: string;
        /** subscriptionId */
        subscriptionId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/hasSubscriptionOrder`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  holiday = {
    /**
     * No description
     *
     * @tags holiday-date-feign-api-impl
     * @name QueryHolidayDateUsingPost
     * @summary queryHolidayDate
     * @request POST:/holiday/queryHolidayDate
     */
    queryHolidayDateUsingPost: (
      dateList: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListHolidayDateDTO, any>({
        path: `/holiday/queryHolidayDate`,
        method: "POST",
        body: dateList,
        type: ContentType.Json,
        ...params,
      }),
  };
  importantNotice = {
    /**
     * No description
     *
     * @tags important-notice-controller
     * @name DeleteByIdUsingPost
     * @summary 删除重要通知
     * @request POST:/importantNotice/deleteById
     */
    deleteByIdUsingPost: (
      query: {
        /**
         * id
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/importantNotice/deleteById`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags important-notice-controller
     * @name FindDetailByIdUsingGet
     * @summary 查询详情
     * @request GET:/importantNotice/findDetailById
     */
    findDetailByIdUsingGet: (
      query: {
        /**
         * id
         * @format int64
         */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseImportantNoticeDetailDTO, any>({
        path: `/importantNotice/findDetailById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags important-notice-controller
     * @name PageUsingPost
     * @summary 用户端分页查询
     * @request POST:/importantNotice/page
     */
    pageUsingPost: (
      reqDTO: ImportantNoticePageReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageResultImportantNoticeDTO, any>({
        path: `/importantNotice/page`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags important-notice-controller
     * @name PageBackUsingPost
     * @summary 后台分页查询
     * @request POST:/importantNotice/page/back
     */
    pageBackUsingPost: (
      reqDTO: ImportantNoticePageReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageResultImportantNoticeDTO, any>({
        path: `/importantNotice/page/back`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags important-notice-controller
     * @name ReadUsingPost
     * @summary 标记已读
     * @request POST:/importantNotice/read
     */
    readUsingPost: (
      query: {
        /**
         * importantNoticeId
         * @format int64
         */
        importantNoticeId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/importantNotice/read`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags important-notice-controller
     * @name SaveUsingPost1
     * @summary 保存重要通知
     * @request POST:/importantNotice/save
     */
    saveUsingPost1: (dto: ImportantNoticeDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/importantNotice/save`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags important-notice-controller
     * @name SelectUnReadCountUsingPost
     * @summary 查询未读数量
     * @request POST:/importantNotice/selectUnReadCount
     */
    selectUnReadCountUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseInt, any>({
        path: `/importantNotice/selectUnReadCount`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  insertMembershipOrder = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name InsertMembershipOrderUsingPost
     * @summary insertMembershipOrder
     * @request POST:/insertMembershipOrder
     */
    insertMembershipOrderUsingPost: (
      reqDTO: MembershipOrderDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/insertMembershipOrder`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  intended = {
    /**
     * No description
     *
     * @tags 美国站首页底部用户信息相关
     * @name AddUsingPost1
     * @summary 添加信息
     * @request POST:/intended/add
     */
    addUsingPost1: (
      reqDTO: AddIntendedCustomerInfoReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/intended/add`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  isAllowedAccess = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name IsAllowedAccessUsingGet
     * @summary 当前ip是否能够访问
     * @request GET:/isAllowedAccess
     */
    isAllowedAccessUsingGet: (
      query: {
        /** ip */
        ip: string;
        /** productId */
        productId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/isAllowedAccess`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  isSignup = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name IsSignupUsingGet
     * @summary 是否注册
     * @request GET:/isSignup
     */
    isSignupUsingGet: (
      query: {
        /** mobileOrEmail */
        mobileOrEmail: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/isSignup`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  listCustomerIdsByManagerId = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name ListCustomerIdsByManagerIdUsingGet
     * @summary listCustomerIdsByManagerId
     * @request GET:/listCustomerIdsByManagerId
     */
    listCustomerIdsByManagerIdUsingGet: (
      query: {
        /** managerId */
        managerId: string;
        /** roleEnum */
        roleEnum:
          | "ADMIN"
          | "CUSTOMER_DIRECTOR"
          | "CUSTOMER_MANAGER"
          | "MARKETING_MANAGER"
          | "PURCHASER"
          | "MERCHANDISER"
          | "PURCHASER_MANAGER"
          | "MERCHANDISER_MANAGER"
          | "OEM_PURCHASER_MANAGER"
          | "BLACK_SUPPLIER_AUDITOR"
          | "OEM_PURCHASER"
          | "FINANCE_DIRECTOR"
          | "FINANCE_CASHIER"
          | "FINANCE_ACCOUNTANT"
          | "FINANCE_JP_ACCOUNTANT"
          | "ONLINE_CS"
          | "BUYER"
          | "BUYER_MANAGER"
          | "AFTER_SALES_COMPENSATION";
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseHashSetLong, any>({
        path: `/listCustomerIdsByManagerId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  loginFeign = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name LoginFeignUsingGet
     * @summary loginFeign
     * @request GET:/loginFeign
     */
    loginFeignUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/loginFeign`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  logout = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name LogoutUsingGet
     * @summary 用户退出
     * @request GET:/logout
     */
    logoutUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/logout`,
        method: "GET",
        ...params,
      }),
  };
  memberChangeFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetMemberChangeFlagUsingGet
     * @summary 是否已读会员变更
     * @request GET:/memberChangeFlag
     */
    getMemberChangeFlagUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/memberChangeFlag`,
        method: "GET",
        ...params,
      }),
  };
  memberChangeZeroFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name GetMemberChangeZeroFlagUsingGet
     * @summary 是否已读0级会员变更
     * @request GET:/memberChangeZeroFlag
     */
    getMemberChangeZeroFlagUsingGet: (
      query?: {
        /**
         * customerId
         * @format int64
         */
        customerId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/memberChangeZeroFlag`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  menus = {
    /**
     * No description
     *
     * @tags 菜单接口
     * @name AddUsingPost2
     * @summary 新增菜单
     * @request POST:/menus
     */
    addUsingPost2: (menu: AddMenuReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/menus`,
        method: "POST",
        body: menu,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name TreeUsingGet
     * @summary 查询菜单树
     * @request GET:/menus/getMenustree
     */
    treeUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListMenuTreeRespDTO, any>({
        path: `/menus/getMenustree`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name GetPageMenuUsingPost
     * @summary 根据目录id,名称,状态分页查询功能菜单
     * @request POST:/menus/getPageMenu
     */
    getPageMenuUsingPost: (
      pageMenuVO: PageMenuReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageManageMenuRespDTO, any>({
        path: `/menus/getPageMenu`,
        method: "POST",
        body: pageMenuVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name ListUsingGet
     * @summary 查询路由列表
     * @request GET:/menus/routes
     */
    listUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseListRouteRespDTO, any>({
        path: `/menus/routes`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name UpdateUsingPut1
     * @summary 修改菜单
     * @request PUT:/menus/updateById
     */
    updateUsingPut1: (menu: UpdateMenuReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/menus/updateById`,
        method: "PUT",
        body: menu,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name UpdateVisibleUsingPost
     * @summary 修改菜单的状态
     * @request POST:/menus/updateVisible
     */
    updateVisibleUsingPost: (
      updateMenuVisibleReqDTOList: UpdateMenuVisibleReqDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/menus/updateVisible`,
        method: "POST",
        body: updateMenuVisibleReqDTOList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name DeleteUsingDelete1
     * @summary 批量删除菜单
     * @request DELETE:/menus/{ids}
     */
    deleteUsingDelete1: (ids: string, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/menus/${ids}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 菜单接口
     * @name DetailUsingGet1
     * @summary 查询菜单详情
     * @request GET:/menus/{id}
     */
    detailUsingGet1: (id: number, params: RequestParams = {}) =>
      this.request<BizResponseManageMenuRespDTO, any>({
        path: `/menus/${id}`,
        method: "GET",
        ...params,
      }),
  };
  mobile = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SendValidateCodeMobileUsingPost1
     * @summary 手机号码发送验证码
     * @request POST:/mobile/send/code
     */
    sendValidateCodeMobileUsingPost1: (
      checkMobileReqDTO: DTO3,
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/mobile/send/code`,
        method: "POST",
        body: checkMobileReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SendValidateCodeMobileUsingPost
     * @summary 手机号码发送验证码for app
     * @request POST:/mobile/send/code/app
     */
    sendValidateCodeMobileUsingPost: (
      query?: {
        /** request */
        request?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BaseResponse, any>({
        path: `/mobile/send/code/app`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  mobileLogin = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name MobileLoginUsingPost
     * @summary 手机验证登录
     * @request POST:/mobileLogin
     */
    mobileLoginUsingPost: (queryDTO: _DTO, params: RequestParams = {}) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/mobileLogin`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  needPopUpWindowByType = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name NeedPopUpWindowByTypeUsingGet
     * @summary 是否需要弹出弹窗
     * @request GET:/needPopUpWindowByType
     */
    needPopUpWindowByTypeUsingGet: (
      query: {
        /**
         * type
         * @format int32
         */
        type: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/needPopUpWindowByType`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  notify = {
    /**
     * No description
     *
     * @tags 通知
     * @name GetPrivateUnreadCountUsingGet
     * @summary 获取私有未读消息数量
     * @request GET:/notify/get/private/unread/count
     */
    getPrivateUnreadCountUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseInt, any>({
        path: `/notify/get/private/unread/count`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name PublishPrivateNotifyUsingPost
     * @summary 发布私有通知
     * @request POST:/notify/private/publish
     */
    publishPrivateNotifyUsingPost: (
      queryVO: NotifyPrivatePublishVO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/private/publish`,
        method: "POST",
        body: queryVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name QueryPrivateNotifyPageUsingGet
     * @summary 私有消息分页查询
     * @request GET:/notify/private/query
     */
    queryPrivateNotifyPageUsingGet: (
      query?: {
        /** @format int32 */
        pageNum?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        startIndex?: number;
        /** @format int64 */
        targetCustomerShopId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageNotifyPrivateVO, any>({
        path: `/notify/private/query`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name QueryPrivateNotifyByIdUsingGet
     * @summary 私有消息分页查询
     * @request GET:/notify/private/queryById
     */
    queryPrivateNotifyByIdUsingGet: (
      query?: {
        /** 私有消息id */
        notifyTemplatePrivateId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseNotifyPrivateVO, any>({
        path: `/notify/private/queryById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name ReadPrivateNotifyUsingPost
     * @summary 私有消息已读
     * @request POST:/notify/private/read
     */
    readPrivateNotifyUsingPost: (
      readVO: NotifyPrivateReadVO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/private/read`,
        method: "POST",
        body: readVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name ReadAllPrivateNotifyUsingPost
     * @summary 私有消息全部已读
     * @request POST:/notify/private/read/all
     */
    readAllPrivateNotifyUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/private/read/all`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name QueryPublicNotifyPageUsingGet
     * @summary 公有消息分页查询
     * @request GET:/notify/public/query
     */
    queryPublicNotifyPageUsingGet: (
      query?: {
        /** @format int32 */
        pageNum?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        startIndex?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageNotifyPublicVO, any>({
        path: `/notify/public/query`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name ReadPublicNotifyUsingPost
     * @summary 公有消息已读
     * @request POST:/notify/public/read
     */
    readPublicNotifyUsingPost: (
      readVO: NotifyPublicReadVO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/public/read`,
        method: "POST",
        body: readVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name ReadAllPublicNotifyUsingPost
     * @summary 公有消息已读
     * @request POST:/notify/public/read/all
     */
    readAllPublicNotifyUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/public/read/all`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name InsertNotifyTemplateUsingPost
     * @summary 插入通知模板
     * @request POST:/notify/template/insert
     */
    insertNotifyTemplateUsingPost: (
      entity: NotifyTemplateUpsertVO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/template/insert`,
        method: "POST",
        body: entity,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name SendTestUsingGet
     * @summary 公有消息已读
     * @request GET:/notify/test
     */
    sendTestUsingGet: (
      query: {
        /** customerEmail */
        customerEmail: string;
        /** subject */
        subject: string;
        /** templatePath */
        templatePath: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/test`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 通知
     * @name SendTest1UsingGet
     * @summary 公有消息已读
     * @request GET:/notify/test1
     */
    sendTest1UsingGet: (
      query: {
        /** customerEmail */
        customerEmail: string;
        /** subject */
        subject: string;
        /** templatePath */
        templatePath: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/notify/test1`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  openApi = {
    /**
     * No description
     *
     * @tags a-li-user-feign-api-impl
     * @name GetThirdPlatformUserCountUsingPost
     * @summary getThirdPlatformUserCount
     * @request POST:/openApi/thirdPlatformUserCount/get
     */
    getThirdPlatformUserCountUsingPost: (
      req: CustomerCount,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseInt, any>({
        path: `/openApi/thirdPlatformUserCount/get`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  oss = {
    /**
     * No description
     *
     * @tags 云存储
     * @name PutOssUsingPost
     * @summary 上传文件
     * @request POST:/oss/putOSS
     */
    putOssUsingPost: (
      data: {
        /** file */
        file: File;
      },
      query?: {
        /** path */
        path?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/oss/putOSS`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 云存储
     * @name GetOssSignUsingPost
     * @summary 获取上传签名信息
     * @request POST:/oss/sign
     */
    getOssSignUsingPost: (
      query?: {
        /** path */
        path?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/oss/sign`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 云存储
     * @name GetOssSignAnotherUsingPost
     * @summary 获取上传签名
     * @request POST:/oss/sign/another
     */
    getOssSignAnotherUsingPost: (
      query?: {
        /** bucketName */
        bucketName?: string;
        /** path */
        path?: string;
        /**
         * type
         * @format int64
         */
        type?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/oss/sign/another`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 云存储
     * @name GetOssSignAnotheWithoutLoginUsingPost
     * @summary 获取上传签名
     * @request POST:/oss/sign/another/withoutLogin
     */
    getOssSignAnotheWithoutLoginUsingPost: (
      query?: {
        /** bucketName */
        bucketName?: string;
        /** path */
        path?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/oss/sign/another/withoutLogin`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  page = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name QueryPageUsingPost
     * @summary queryPage
     * @request POST:/page
     */
    queryPageUsingPost: (
      reqDTO: GetCustomerListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerPageDTO, any>({
        path: `/page`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  passwordChangeFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name PasswordChangeFlagUsingGet
     * @summary 是否已读建议修改密码弹窗
     * @request GET:/passwordChangeFlag
     */
    passwordChangeFlagUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/passwordChangeFlag`,
        method: "GET",
        ...params,
      }),
  };
  passwordLogin = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name PasswordLoginUsingPost
     * @summary 密码登录
     * @request POST:/passwordLogin
     */
    passwordLoginUsingPost: (
      queryDTO: PasswordLoginReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/passwordLogin`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  pluginSearchStatistics = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name PluginSearchStatisticsUsingGet
     * @summary 插件搜索次数统计
     * @request GET:/pluginSearchStatistics
     */
    pluginSearchStatisticsUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseSearchResultDTO, any>({
        path: `/pluginSearchStatistics`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdatePluginSearchStatisticsUsingGet
     * @summary 插件搜索次数更新
     * @request GET:/pluginSearchStatistics/update
     */
    updatePluginSearchStatisticsUsingGet: (
      query: {
        /**
         * type
         * @format int64
         */
        type: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/pluginSearchStatistics/update`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  pluginSearchStatisticsAll = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name PluginSearchStatisticsAllUsingGet
     * @summary 插件搜索次数统计全部包含非会员和会员
     * @request GET:/pluginSearchStatisticsAll
     */
    pluginSearchStatisticsAllUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseSearchResultDTO, any>({
        path: `/pluginSearchStatisticsAll`,
        method: "GET",
        ...params,
      }),
  };
  priceTrackingFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name PriceTrackingFlagUsingGet
     * @summary 是否开启价格跟踪
     * @request GET:/priceTrackingFlag
     */
    priceTrackingFlagUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseInt, any>({
        path: `/priceTrackingFlag`,
        method: "GET",
        ...params,
      }),
  };
  query = {
    /**
     * No description
     *
     * @tags customer-query-feign-api-impl
     * @name CheckPalletWhiteUsingGet
     * @summary checkPalletWhite
     * @request GET:/query/ca/checkPalletWhite
     */
    checkPalletWhiteUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/query/ca/checkPalletWhite`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-query-feign-api-impl
     * @name GetCustomerMembershipTemplateIdBySuperIdUsingPost
     * @summary getCustomerMembershipTemplateIdBySuperId
     * @request POST:/query/ca/getCustomerMembershipTemplateIdBySuperId
     */
    getCustomerMembershipTemplateIdBySuperIdUsingPost: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/query/ca/getCustomerMembershipTemplateIdBySuperId`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-query-feign-api-impl
     * @name GetSimpleCustomerUsingGet
     * @summary getSimpleCustomer
     * @request GET:/query/ca/getSimpleCustomer
     */
    getSimpleCustomerUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerRespDTO, any>({
        path: `/query/ca/getSimpleCustomer`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-query-feign-api-impl
     * @name GetSimpleCustomerV1UsingGet
     * @summary getSimpleCustomerV1
     * @request GET:/query/ca/getSimpleCustomerV1
     */
    getSimpleCustomerV1UsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerRespDTO, any>({
        path: `/query/ca/getSimpleCustomerV1`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  queryChangeUrlUserByCustomerId = {
    /**
     * No description
     *
     * @tags customer-distribute-feign-api-impl
     * @name QueryChangeUrlUserByCustomerIdUsingGet
     * @summary queryChangeUrlUserByCustomerId
     * @request GET:/queryChangeUrlUserByCustomerId
     */
    queryChangeUrlUserByCustomerIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/queryChangeUrlUserByCustomerId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  queryRelationByCustomerId = {
    /**
     * No description
     *
     * @tags customer-distribute-feign-api-impl
     * @name QueryPurchaseUserByCustomerIdUsingGet
     * @summary queryPurchaseUserByCustomerId
     * @request GET:/queryRelationByCustomerId
     */
    queryPurchaseUserByCustomerIdUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerDistributeQueryRespDTO, any>({
        path: `/queryRelationByCustomerId`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  queryRelationByCustomerIds = {
    /**
     * No description
     *
     * @tags customer-distribute-feign-api-impl
     * @name QueryPurchaseUserByCustomerIdsUsingPost
     * @summary queryPurchaseUserByCustomerIds
     * @request POST:/queryRelationByCustomerIds
     */
    queryPurchaseUserByCustomerIdsUsingPost: (
      customerIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseMapLongCustomerDistributeQueryRespDTO, any>({
        path: `/queryRelationByCustomerIds`,
        method: "POST",
        body: customerIds,
        type: ContentType.Json,
        ...params,
      }),
  };
  removeWhileList = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name RemoveWhileListUsingPost
     * @summary 移出白名单
     * @request POST:/removeWhileList
     */
    removeWhileListUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/removeWhileList`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  reqDto = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name QueryCustomerDetailUsingPost
     * @summary queryCustomerDetail
     * @request POST:/reqDTO
     */
    queryCustomerDetailUsingPost: (
      reqDTO: QueryCustomerDetailReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerDetailRespDTO, any>({
        path: `/reqDTO`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  roles = {
    /**
     * No description
     *
     * @tags 角色接口
     * @name AddUsingPost3
     * @summary 新增角色
     * @request POST:/roles
     */
    addUsingPost3: (roleReqDTO: AddRoleReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/roles`,
        method: "POST",
        body: roleReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name AddUserRoleUsingPost
     * @summary 人员批量分配角色
     * @request POST:/roles/addUserRole
     */
    addUserRoleUsingPost: (
      userRole: AddUserRoleReqDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/roles/addUserRole`,
        method: "POST",
        body: userRole,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name DelUserRoleUsingPost
     * @summary 批量删除角色里面的人员
     * @request POST:/roles/delUserRole
     */
    delUserRoleUsingPost: (
      delUserRoleVO: DelUserRoleReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/roles/delUserRole`,
        method: "POST",
        body: delUserRoleVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name DeleteUsingDelete2
     * @summary 删除角色接口
     * @request DELETE:/roles/deleteById
     */
    deleteUsingDelete2: (
      query?: {
        /** id */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/roles/deleteById`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name FindManagerListUsingPost
     * @summary 查询复购单经理包含的人员
     * @request POST:/roles/findRoles/manager
     */
    findManagerListUsingPost: (
      rolesUsersVO: GetRolesUserListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListRoleUserRespDTO, any>({
        path: `/roles/findRoles/manager`,
        method: "POST",
        body: rolesUsersVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name FindMarketingManagerListUsingPost
     * @summary 查询营销经理包含的人员
     * @request POST:/roles/findRoles/marketingManager
     */
    findMarketingManagerListUsingPost: (
      rolesUsersVO: GetRolesUserListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListRoleUserRespDTO, any>({
        path: `/roles/findRoles/marketingManager`,
        method: "POST",
        body: rolesUsersVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name FindSupervisionManagerListUsingPost
     * @summary 查询客户总监包含的人员
     * @request POST:/roles/findRoles/supervisionManager
     */
    findSupervisionManagerListUsingPost: (
      rolesUsersVO: GetRolesUserListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListRoleUserRespDTO, any>({
        path: `/roles/findRoles/supervisionManager`,
        method: "POST",
        body: rolesUsersVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name FindRolesUserListUsingPost
     * @summary 查询多个角色包含的人员
     * @request POST:/roles/findRoles/user
     */
    findRolesUserListUsingPost: (
      rolesUsersVO: GetRolesUserListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListRoleUserRespDTO, any>({
        path: `/roles/findRoles/user`,
        method: "POST",
        body: rolesUsersVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name GetUsersByIdUsingGet
     * @summary 通过角色id获取用户集合
     * @request GET:/roles/getUsersById
     */
    getUsersByIdUsingGet: (
      query?: {
        /** roleId */
        roleId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/roles/getUsersById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name MenuTreeUsingPost
     * @summary 查询多个角色拥有的菜单树
     * @request POST:/roles/menu_tree
     */
    menuTreeUsingPost: (roleIds: string[], params: RequestParams = {}) =>
      this.request<BizResponseListMenuTreeListRespDTO, any>({
        path: `/roles/menu_tree`,
        method: "POST",
        body: roleIds,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name UpdateRoleMenuIdsUsingPut
     * @summary 修改多个角色菜单
     * @request PUT:/roles/update/roles_menus
     */
    updateRoleMenuIdsUsingPut: (
      roles: UpdateRoleMenusReqDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/roles/update/roles_menus`,
        method: "PUT",
        body: roles,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 角色接口
     * @name UpdateUsingPut2
     * @summary 修改角色
     * @request PUT:/roles/updateRole
     */
    updateUsingPut2: (role: UpdateRoleReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/roles/updateRole`,
        method: "PUT",
        body: role,
        type: ContentType.Json,
        ...params,
      }),
  };
  selectCustomerMembershipList = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name SelectCustomerMembershipListUsingPost
     * @summary selectCustomerMembershipList
     * @request POST:/selectCustomerMembershipList
     */
    selectCustomerMembershipListUsingPost: (
      dto: CustomerMembershipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerMembership, any>({
        path: `/selectCustomerMembershipList`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  selectCustomerPriceTrackingFlag = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name SelectCustomerPriceTrackingFlagUsingGet
     * @summary selectCustomerPriceTrackingFlag
     * @request GET:/selectCustomerPriceTrackingFlag
     */
    selectCustomerPriceTrackingFlagUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/selectCustomerPriceTrackingFlag`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  sendMsg = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name SendMsgUsingPost
     * @summary sendMsg
     * @request POST:/sendMsg
     */
    sendMsgUsingPost: (dto: CustomerJpushReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/sendMsg`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  setSupportChoiceShop = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SetSupportChoiceShopUsingGet
     * @summary 设置店铺为支持choice店铺
     * @request GET:/setSupportChoiceShop
     */
    setSupportChoiceShopUsingGet: (
      query: {
        /**
         * shopId
         * @format int64
         */
        shopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/setSupportChoiceShop`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  shop = {
    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name AddCustomerShopUsingPost1
     * @summary addCustomerShop
     * @request POST:/shop/addCustomerShop
     */
    addCustomerShopUsingPost1: (
      addShopDTO: AddCustomerShopReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseLong, any>({
        path: `/shop/addCustomerShop`,
        method: "POST",
        body: addShopDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name AddKoreaWarehouseUsingPost
     * @summary addKoreaWarehouse
     * @request POST:/shop/addKoreaWarehouse
     */
    addKoreaWarehouseUsingPost: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/shop/addKoreaWarehouse`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetCustomerShopUsingPost2
     * @summary getCustomerShop
     * @request POST:/shop/get
     */
    getCustomerShopUsingPost2: (
      dto: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopRespDTO, any>({
        path: `/shop/get`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetCustomerIdByShopIdsUsingPost
     * @summary getCustomerIdByShopIds
     * @request POST:/shop/getCustomerIdByShopIds
     */
    getCustomerIdByShopIdsUsingPost: (
      customerShopIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/shop/getCustomerIdByShopIds`,
        method: "POST",
        body: customerShopIds,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetCustomerShopListByShopIdListUsingPost
     * @summary getCustomerShopListByShopIdList
     * @request POST:/shop/getCustomerShopListByShopIdList
     */
    getCustomerShopListByShopIdListUsingPost: (
      dto: GetCustomerShopListByShopIdListDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/shop/getCustomerShopListByShopIdList`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetDefaultClearanceAddressUsingGet
     * @summary getDefaultClearanceAddress
     * @request GET:/shop/getDefaultClearanceAddress
     */
    getDefaultClearanceAddressUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopClearanceAddressRespDTO, any>({
        path: `/shop/getDefaultClearanceAddress`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetCustomerShopListUsingPost1
     * @summary getCustomerShopList
     * @request POST:/shop/getList
     */
    getCustomerShopListUsingPost1: (
      dto: GetCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/shop/getList`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetShopBySuperCustomerIdUsingGet
     * @summary getShopBySuperCustomerId
     * @request GET:/shop/getShopBySuperCustomerId
     */
    getShopBySuperCustomerIdUsingGet: (
      query: {
        /**
         * superCustomerId
         * @format int64
         */
        superCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopRespDTO, any>({
        path: `/shop/getShopBySuperCustomerId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetShopListByCustomerIdUsingPost
     * @summary getShopListByCustomerId
     * @request POST:/shop/getShopListByCustomerId
     */
    getShopListByCustomerIdUsingPost: (
      reqDTO: GetShopListByCustomerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopRespDTO, any>({
        path: `/shop/getShopListByCustomerId`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetShopPurchaseUsingGet1
     * @summary getShopPurchase
     * @request GET:/shop/getShopPurchase
     */
    getShopPurchaseUsingGet1: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseShopPurchaseRespDTO, any>({
        path: `/shop/getShopPurchase`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetShopPurchaseListUsingPost
     * @summary getShopPurchaseList
     * @request POST:/shop/getShopPurchaseList
     */
    getShopPurchaseListUsingPost: (
      customerShopIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListShopPurchaseRespDTO, any>({
        path: `/shop/getShopPurchaseList`,
        method: "POST",
        body: customerShopIds,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetVirtualShopByMainCustomerUsingGet
     * @summary getVirtualShopByMainCustomer
     * @request GET:/shop/getVirtualShopByMainCustomer
     */
    getVirtualShopByMainCustomerUsingGet: (
      query: {
        /**
         * mainCustomerId
         * @format int64
         */
        mainCustomerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopRespDTO, any>({
        path: `/shop/getVirtualShopByMainCustomer`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name GetCustomerShopPageUsingPost1
     * @summary getCustomerShopPage
     * @request POST:/shop/page
     */
    getCustomerShopPageUsingPost1: (
      dto: BaseQueryPage,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerShopRespDTO, any>({
        path: `/shop/page`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name QueryCustomerShopPageUsingPost
     * @summary queryCustomerShopPage
     * @request POST:/shop/query/page
     */
    queryCustomerShopPageUsingPost: (
      dto: CustomerShopQueryDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerShopPageDTO, any>({
        path: `/shop/query/page`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name SelectShopListByCustomerIdsUsingPost
     * @summary selectShopListByCustomerIds
     * @request POST:/shop/select/list/by/customerIds
     */
    selectShopListByCustomerIdsUsingPost: (
      customerIds: number[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopPageDTO, any>({
        path: `/shop/select/list/by/customerIds`,
        method: "POST",
        body: customerIds,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name AddCustomerShopShipUsingPost
     * @summary 新建店铺国际物流配置
     * @request POST:/shop/ship/add
     */
    addCustomerShopShipUsingPost: (
      dto: CustomerShopShipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/shop/ship/add`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name DeleteCustomerShopShipUsingPost
     * @summary 删除店铺国际物流配置
     * @request POST:/shop/ship/delete
     */
    deleteCustomerShopShipUsingPost: (
      customerShopShipDelReqDTO: CustomerShopShipDelReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/shop/ship/delete`,
        method: "POST",
        body: customerShopShipDelReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name GetCustomerShopShipUsingGet
     * @summary 获取店铺国际物流配置列表
     * @request GET:/shop/ship/get
     */
    getCustomerShopShipUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopShipRespDTO, any>({
        path: `/shop/ship/get`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name GetByShopIdUsingGet
     * @summary 后台 获取店铺国际物流配置列表
     * @request GET:/shop/ship/getByShopId
     */
    getByShopIdUsingGet: (
      query: {
        /**
         * X-AuthShopId
         * @format int64
         */
        "X-AuthShopId": number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopShipRespDTO, any>({
        path: `/shop/ship/getByShopId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name GetShopIdByLogisticsIdUsingGet
     * @summary getShopIdByLogisticsId
     * @request GET:/shop/ship/getShopIdByLogisticsId
     */
    getShopIdByLogisticsIdUsingGet: (
      query: {
        /**
         * logisticsId
         * @format int64
         */
        logisticsId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListLong, any>({
        path: `/shop/ship/getShopIdByLogisticsId`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name GetCustomerShopShipByManageUsingGet
     * @summary 获取店铺国际物流配置列表
     * @request GET:/shop/ship/manage/get
     */
    getCustomerShopShipByManageUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** warehouseCode */
        warehouseCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopShipRespDTO, any>({
        path: `/shop/ship/manage/get`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-用户店铺物流配置修改
     * @name UpdateCustomerShopShipUsingPost
     * @summary 编辑店铺国际物流配置
     * @request POST:/shop/ship/update
     */
    updateCustomerShopShipUsingPost: (
      dto: CustomerShopShipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/shop/ship/update`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name UpdateCustomerShopUsingPost1
     * @summary updateCustomerShop
     * @request POST:/shop/updateFeigh
     */
    updateCustomerShopUsingPost1: (
      dto: UpdateCustomerShopDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/shop/updateFeigh`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags customer-shop-feign-api-impl
     * @name UpdateShopPurchaseUsingPost1
     * @summary updateShopPurchase
     * @request POST:/shop/updateShopPurchase
     */
    updateShopPurchaseUsingPost1: (
      reqDTO: UpdateShopPurchaseReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/shop/updateShopPurchase`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  shopTaxDeductionAccount = {
    /**
     * No description
     *
     * @tags 扣税账号接口
     * @name AddShopTaxDeductionAccountUsingPost
     * @summary 新增扣税账号
     * @request POST:/shopTaxDeductionAccount/add
     */
    addShopTaxDeductionAccountUsingPost: (
      addShopTaxDeductionAccountDTO: AddShopTaxDeductionAccountDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/shopTaxDeductionAccount/add`,
        method: "POST",
        body: addShopTaxDeductionAccountDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 扣税账号接口
     * @name EditShopTaxDeductionAccountUsingPost
     * @summary 编辑扣税账号
     * @request POST:/shopTaxDeductionAccount/edit
     */
    editShopTaxDeductionAccountUsingPost: (
      editShopTaxDeductionAccountDTO: UpdateShopTaxDeductionAccountDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/shopTaxDeductionAccount/edit`,
        method: "POST",
        body: editShopTaxDeductionAccountDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 扣税账号接口
     * @name GetByIdUsingGet1
     * @summary 根据ID获取
     * @request GET:/shopTaxDeductionAccount/getById/{id}
     */
    getByIdUsingGet1: (id: number, params: RequestParams = {}) =>
      this.request<BizResponseShopTaxDeductionAccountRespDTO, any>({
        path: `/shopTaxDeductionAccount/getById/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 扣税账号接口
     * @name GetPageUsingPost1
     * @summary 分页查询
     * @request POST:/shopTaxDeductionAccount/getPage
     */
    getPageUsingPost1: (
      pageDTO: ShopTaxDeductionAccountPageDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageShopTaxDeductionAccountRespDTO, any>({
        path: `/shopTaxDeductionAccount/getPage`,
        method: "POST",
        body: pageDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 扣税账号接口
     * @name RemoveShopTaxDeductionAccountUsingPost
     * @summary 删除扣税账号
     * @request POST:/shopTaxDeductionAccount/removeById/{id}
     */
    removeShopTaxDeductionAccountUsingPost: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/shopTaxDeductionAccount/removeById/${id}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 扣税账号接口
     * @name SetDefaultUsingPost
     * @summary 设置默认
     * @request POST:/shopTaxDeductionAccount/setDefault/{id}
     */
    setDefaultUsingPost: (id: number, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/shopTaxDeductionAccount/setDefault/${id}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  showGoogle = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name ShowGoogleUsingPost
     * @summary 查看客户谷歌表
     * @request POST:/showGoogle
     */
    showGoogleUsingPost: (
      dto: GetCustomerGoogleListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageCustomerGoogle, any>({
        path: `/showGoogle`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  showGuide = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name ShowGuideUsingGet
     * @summary 查看新手指引
     * @request GET:/showGuide
     */
    showGuideUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerGuide, any>({
        path: `/showGuide`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  showMaterialPrice = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name ShowMaterialPriceUsingPost
     * @summary 查看国际料金表
     * @request POST:/showMaterialPrice
     */
    showMaterialPriceUsingPost: (
      query?: {
        /** stationCode */
        stationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListMaterialPrice, any>({
        path: `/showMaterialPrice`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  showWareIsExistOem = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name ShowWareIsExistOemUsingGet
     * @summary showWareIsExistOem
     * @request GET:/showWareIsExistOem
     */
    showWareIsExistOemUsingGet: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopRespDTO, any>({
        path: `/showWareIsExistOem`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  signup = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SignUpUsingPost
     * @summary 注册
     * @request POST:/signup
     */
    signUpUsingPost: (signUpReqDTO: SignUpReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseSignUpRespDTO, any>({
        path: `/signup`,
        method: "POST",
        body: signUpReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name CheckInvitationCodeUsingGet
     * @summary 验证推广码是否为推广联盟
     * @request GET:/signup/check/invitationCode
     */
    checkInvitationCodeUsingGet: (
      query?: {
        /** invitationCode */
        invitationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/signup/check/invitationCode`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name CheckLoginNameUsingGet
     * @summary 验证登录名是否唯一
     * @request GET:/signup/check/loginname
     */
    checkLoginNameUsingGet: (
      query?: {
        /** loginName */
        loginName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/signup/check/loginname`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name DefaultLoginUsingPost
     * @summary 用户默认登录b2b或d2c
     * @request POST:/signup/defaultLogin
     */
    defaultLoginUsingPost: (
      reqDTO: DefaultLoginReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/signup/defaultLogin`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name GetInvitationInfoUsingGet
     * @summary 根据邀请码获取邀请信息
     * @request GET:/signup/getInvitationInfo
     */
    getInvitationInfoUsingGet: (
      query?: {
        /** invitationCode */
        invitationCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseInvitationInfoRespDTO, any>({
        path: `/signup/getInvitationInfo`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SignUpNeedEmailCodeUsingGet
     * @summary 直采注册是否需要邮箱验证码
     * @request GET:/signup/needEmailCode
     */
    signUpNeedEmailCodeUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/signup/needEmailCode`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SignUpNoEmailCodeUsingPost
     * @summary 直采注册，不需要邮箱验证码
     * @request POST:/signup/noEmailCode
     */
    signUpNoEmailCodeUsingPost: (
      signUpReqDTO: SignUpReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseSignUpRespDTO, any>({
        path: `/signup/noEmailCode`,
        method: "POST",
        body: signUpReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name SendValidCodeUsingPost
     * @summary 注册发送验证码
     * @request POST:/signup/send/code
     */
    sendValidCodeUsingPost: (
      checkEmailReqDTO: CheckEmailReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/signup/send/code`,
        method: "POST",
        body: checkEmailReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  splitRemindFlag = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name SplitRemindFlagUsingPost
     * @summary 拆单不再提醒标记
     * @request POST:/splitRemindFlag
     */
    splitRemindFlagUsingPost: (
      dto: CustomerSplitRemindFlagDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/splitRemindFlag`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  systemSourceLogin = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name LoginUsingPost
     * @summary 通过uuid和系统来源登录
     * @request POST:/systemSourceLogin
     */
    loginUsingPost: (
      queryDTO: DefaultLoginReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerLoginRespDTO, any>({
        path: `/systemSourceLogin`,
        method: "POST",
        body: queryDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  tag = {
    /**
     * No description
     *
     * @tags 用户表标签
     * @name SyncCustomerTagUsingPost
     * @summary 定时任务
     * @request POST:/tag/syncCustomerTag
     */
    syncCustomerTagUsingPost: (
      query: {
        /** batchCode */
        batchCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/tag/syncCustomerTag`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户表标签
     * @name UpdateCustomerTagUsingPost
     * @summary 更新用户标签
     * @request POST:/tag/updateCustomerTag
     */
    updateCustomerTagUsingPost: (
      req: CustomerTagUpdateReq,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/tag/updateCustomerTag`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  take = {
    /**
     * No description
     *
     * @tags 档口用户接口
     * @name AddUserUsingPost1
     * @summary 添加拿货员
     * @request POST:/take/users/addUser
     */
    addUserUsingPost1: (
      addReqDTO: TakeUserAddReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/take/users/addUser`,
        method: "POST",
        body: addReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 档口用户接口
     * @name EditUserUsingPost
     * @summary 修改拿货员
     * @request POST:/take/users/editUser
     */
    editUserUsingPost: (
      reqDTO: TakeUserEditReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/take/users/editUser`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 档口用户接口
     * @name GetOneUsingGet
     * @summary 根据ID获取拿货员详情
     * @request GET:/take/users/getOne
     */
    getOneUsingGet: (
      query?: {
        /**
         * 拿货员ID
         * @format int64
         */
        takeUserId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseTakeUserRespDTO, any>({
        path: `/take/users/getOne`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 档口用户接口
     * @name GetOneByTokenUsingGet
     * @summary 根据token获取拿货员详情
     * @request GET:/take/users/getOneByToken
     */
    getOneByTokenUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseTakeUserRespDTO, any>({
        path: `/take/users/getOneByToken`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 档口用户接口
     * @name GetTakeUserUsingGet
     * @summary getTakeUser
     * @request GET:/take/users/getTakeUser
     */
    getTakeUserUsingGet: (
      query: {
        /** token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseTakeUserRespDTO, any>({
        path: `/take/users/getTakeUser`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 档口用户接口
     * @name LoginUsingPost1
     * @summary 拿货员登录
     * @request POST:/take/users/login
     */
    loginUsingPost1: (
      reqDTO: TakeUserLoginReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/take/users/login`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 档口用户接口
     * @name PageUserUsingPost
     * @summary 拿货员列表
     * @request POST:/take/users/pageUser
     */
    pageUserUsingPost: (
      takeUserReqDTO: TakeUserReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageTakeUserRespDTO, any>({
        path: `/take/users/pageUser`,
        method: "POST",
        body: takeUserReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdAuthLink = {
    /**
     * No description
     *
     * @tags 三方平台Oauth2授权相关
     * @name ThirdAuthLinkUsingPost
     * @summary 获取三方授权链接
     * @request POST:/thirdAuthLink
     */
    thirdAuthLinkUsingPost: (
      thirdAuthLinkReqDTO: GetThirdAuthLinkReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/thirdAuthLink`,
        method: "POST",
        body: thirdAuthLinkReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdCallback = {
    /**
     * No description
     *
     * @tags 三方平台Oauth2授权相关
     * @name ThirdCallbackAppleUsingPost
     * @summary 苹果授权回调接口
     * @request POST:/thirdCallback/apple
     */
    thirdCallbackAppleUsingPost: (
      query: {
        /** code */
        code: string;
        /** id_token */
        id_token: string;
        /** state */
        state: string;
        /** user */
        user?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/thirdCallback/apple`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 三方平台Oauth2授权相关
     * @name ThirdCallbackEasyAppleUsingPost
     * @summary 苹果授权回调接口
     * @request POST:/thirdCallback/easy/apple
     */
    thirdCallbackEasyAppleUsingPost: (
      query: {
        /** code */
        code: string;
        /** id_token */
        id_token: string;
        /** state */
        state: string;
        /** user */
        user?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/thirdCallback/easy/apple`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdData = {
    /**
     * No description
     *
     * @tags 三方平台Oauth2授权相关
     * @name ThirdDataUsingPost
     * @summary 获取三方数据
     * @request POST:/thirdData
     */
    thirdDataUsingPost: (
      thirdDataReqDTO: GetThirdDataReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseGetThirdDataRespDTO, any>({
        path: `/thirdData`,
        method: "POST",
        body: thirdDataReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  update = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateDefectiveProductRiskFlagUsingGet
     * @summary 已读不良品风险弹窗
     * @request GET:/update/defectiveProductRiskFlag
     */
    updateDefectiveProductRiskFlagUsingGet: (
      query: {
        /**
         * confirmationStyle
         * @format int64
         */
        confirmationStyle: number;
        /** version */
        version: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/update/defectiveProductRiskFlag`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateMemberChangeFlagUsingGet
     * @summary 更新会员变更为已读
     * @request GET:/update/memberChangeFlag
     */
    updateMemberChangeFlagUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/update/memberChangeFlag`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateMemberChangeZeroFlagUsingGet
     * @summary 更新0级会员变更为已读
     * @request GET:/update/memberChangeZeroFlag
     */
    updateMemberChangeZeroFlagUsingGet: (
      query?: {
        /**
         * customerId
         * @format int64
         */
        customerId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/update/memberChangeZeroFlag`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdatePasswordChangeFlagUsingGet
     * @summary 已读建议修改密码弹窗
     * @request GET:/update/passwordChangeFlag
     */
    updatePasswordChangeFlagUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/update/passwordChangeFlag`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdatePopUpWindowByTypeUsingGet
     * @summary 已读弹窗
     * @request GET:/update/popUpWindowByType
     */
    updatePopUpWindowByTypeUsingGet: (
      query: {
        /**
         * type
         * @format int32
         */
        type: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/update/popUpWindowByType`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  updateCustomer = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name UpdateCustomerUsingPost
     * @summary 更新个人信息
     * @request POST:/updateCustomer
     */
    updateCustomerUsingPost: (
      reqDTO: UpdateCustomerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/updateCustomer`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateCustomer2AgencyGoodsSign = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateCustomer2AgencyGoodsSignUsingPost
     * @summary 更新直采用户跳转代采商品是否弹框标识
     * @request POST:/updateCustomer2AgencyGoodsSign
     */
    updateCustomer2AgencyGoodsSignUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateCustomer2AgencyGoodsSign`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  updateCustomer2AgencySign = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateCustomer2AgencySignUsingPost
     * @summary 更新直采用户跳转代采是否弹框标识
     * @request POST:/updateCustomer2AgencySign
     */
    updateCustomer2AgencySignUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateCustomer2AgencySign`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  updateCustomerDetail = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateCustomerDetailUsingGet
     * @summary updateCustomerDetail
     * @request GET:/updateCustomerDetail
     */
    updateCustomerDetailUsingGet: (
      query: {
        /**
         * customerId
         * @format int64
         */
        customerId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateCustomerDetail`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  updateCustomerGoogle = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name UpdateCustomerGoogleUsingPost
     * @summary 更新个人谷歌表
     * @request POST:/updateCustomerGoogle
     */
    updateCustomerGoogleUsingPost: (
      reqDTO: UpdateCustomerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/updateCustomerGoogle`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateCustomerRegistration = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateCustomerRegistrationUsingGet
     * @summary 更新客户设备注册表
     * @request GET:/updateCustomerRegistration
     */
    updateCustomerRegistrationUsingGet: (
      query: {
        /** registrationId */
        registrationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/updateCustomerRegistration`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  updateCustomerRegistrationEmpty = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateCustomerRegistrationEmptyUsingGet
     * @summary 删除设备注册表
     * @request GET:/updateCustomerRegistrationEmpty
     */
    updateCustomerRegistrationEmptyUsingGet: (
      query: {
        /** registrationId */
        registrationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/updateCustomerRegistrationEmpty`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  updateExpireAndMembership = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateExpireAndMembershipUsingPost
     * @summary updateExpireAndMembership
     * @request POST:/updateExpireAndMembership
     */
    updateExpireAndMembershipUsingPost: (
      dto: CustomerMembershipReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateExpireAndMembership`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateGoogle = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateGoogleUsingPost
     * @summary 更新客户谷歌表
     * @request POST:/updateGoogle
     */
    updateGoogleUsingPost: (dto: CustomerGoogle, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/updateGoogle`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateGuide = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateGuideUsingPost
     * @summary 更新新手指引
     * @request POST:/updateGuide
     */
    updateGuideUsingPost: (dto: CustomerGuide, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/updateGuide`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateManagerUsingPost
     * @summary updateManager
     * @request POST:/updateManager
     */
    updateManagerUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateManager`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateMarketingManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateMarketingManagerUsingPost
     * @summary updateMarketingManager
     * @request POST:/updateMarketingManager
     */
    updateMarketingManagerUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateMarketingManager`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateMaterialPrice = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateMaterialPriceUsingPost
     * @summary 更新国际料金表
     * @request POST:/updateMaterialPrice
     */
    updateMaterialPriceUsingPost: (
      dto: MaterialPrice,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseObject, any>({
        path: `/updateMaterialPrice`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  };
  updatePassword = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户密码和邮箱修改
     * @name UpdatePasswordUsingPost
     * @summary 原密码更新密码
     * @request POST:/updatePassword
     */
    updatePasswordUsingPost: (
      updatePasswordReqDTO: UpdatePasswordReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/updatePassword`,
        method: "POST",
        body: updatePasswordReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateShopChangeTime = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户登录注册
     * @name UpdateShopChangeTimeUsingGet
     * @summary 切换店铺切换时间
     * @request GET:/updateShopChangeTime
     */
    updateShopChangeTimeUsingGet: (
      query: {
        /**
         * shopId
         * @format int64
         */
        shopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/updateShopChangeTime`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  updateShopPopup = {
    /**
     * No description
     *
     * @tags D2C&&B2B-前台用户
     * @name UpdateShopPopupUsingPost
     * @summary 更新修改店铺已弹窗状态
     * @request POST:/updateShopPopup
     */
    updateShopPopupUsingPost: (params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/updateShopPopup`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
  updateSupervisionManager = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateSupervisionManagerUsingPost
     * @summary updateSupervisionManager
     * @request POST:/updateSupervisionManager
     */
    updateSupervisionManagerUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateSupervisionManager`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateUnificationCustomerFullName = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateUnificationCustomerFullNameUsingPost
     * @summary updateUnificationCustomerFullName
     * @request POST:/updateUnificationCustomerFullName
     */
    updateUnificationCustomerFullNameUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateUnificationCustomerFullName`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateWare = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateWareUsingPost
     * @summary updateWare
     * @request POST:/updateWare
     */
    updateWareUsingPost: (
      reqDTOs: QueryCustomerByManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateWare`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  updateWareIsExistOem = {
    /**
     * No description
     *
     * @tags customer-feign-api-impl
     * @name UpdateWareIsExistOemUsingPost
     * @summary updateWareIsExistOem
     * @request POST:/updateWareIsExistOem
     */
    updateWareIsExistOemUsingPost: (
      reqDTOs: UpdateWareOemReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/updateWareIsExistOem`,
        method: "POST",
        body: reqDTOs,
        type: ContentType.Json,
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags 用户接口
     * @name BatchMoveDepartmentsUsingPost
     * @summary 批量移动用户部门
     * @request POST:/users/batchMoveDepartments
     */
    batchMoveDepartmentsUsingPost: (
      reqDTO: MoveUserDepartmentReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/batchMoveDepartments`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name DeleteUsingDelete3
     * @summary 批量删除部门员工接口
     * @request DELETE:/users/deleteByIds
     */
    deleteUsingDelete3: (ids: string[], params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/users/deleteByIds`,
        method: "DELETE",
        body: ids,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name DirectorSetUsingPost
     * @summary 把用户设置为主管
     * @request POST:/users/directorSet
     */
    directorSetUsingPost: (
      reqDTO: DirectorSetReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/directorSet`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name ListUsingPost1
     * @summary 根据部门id等条件查询用户列表分页
     * @request POST:/users/findUserList
     */
    listUsingPost1: (
      findUserListVO: GetUserListReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageManageUserRespDTO, any>({
        path: `/users/findUserList`,
        method: "POST",
        body: findUserListVO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetOemPurserUsingGet
     * @summary 获取oem采购员
     * @request GET:/users/getOemPurser
     */
    getOemPurserUsingGet: (
      query?: {
        /** userId */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/users/getOemPurser`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name RoleIdsByUserUsingGet
     * @summary 查询用户登录名获取角色id
     * @request GET:/users/getRoleIds
     */
    roleIdsByUserUsingGet: (
      query?: {
        /** userName */
        userName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListString, any>({
        path: `/users/getRoleIds`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetUserByMobileUsingGet
     * @summary 通过手机号查询用户
     * @request GET:/users/getUserByMobile
     */
    getUserByMobileUsingGet: (
      query: {
        /** mobile */
        mobile: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseManageUserRespDTO, any>({
        path: `/users/getUserByMobile`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetUserByRoleUsingGet
     * @summary 获取角色code获取用户
     * @request GET:/users/getUserByRole
     */
    getUserByRoleUsingGet: (
      query?: {
        /** roleCode */
        roleCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/users/getUserByRole`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetUserByRoleListUsingPost
     * @summary 通过批量角色code获取用户
     * @request POST:/users/getUserByRoleList
     */
    getUserByRoleListUsingPost: (
      roleCodes: string[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/users/getUserByRoleList`,
        method: "POST",
        body: roleCodes,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetUserInfoByUsernameUsingGet
     * @summary 查询用户名获取用户的角色，资源信息
     * @request GET:/users/getUserInfoByUsername/{username}
     */
    getUserInfoByUsernameUsingGet: (
      username: string,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseManageUserInfoRespDTO, any>({
        path: `/users/getUserInfoByUsername/${username}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetUsersByDirectorUsingGet
     * @summary 主管获取当前部门所有人员的信息
     * @request GET:/users/getUsersByDirector
     */
    getUsersByDirectorUsingGet: (
      query?: {
        /** userId */
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListManageUserRespDTO, any>({
        path: `/users/getUsersByDirector`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name LogoutUsingDelete
     * @summary 用户退出
     * @request DELETE:/users/logout
     */
    logoutUsingDelete: (
      query: {
        /** id */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/logout`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetCurrentUserUsingGet
     * @summary 查询当前登陆的用户信息
     * @request GET:/users/me
     */
    getCurrentUserUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseManageUserLoginRespDTO, any>({
        path: `/users/me`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name AddUsingPost4
     * @summary 新增部门用户接口
     * @request POST:/users/save
     */
    addUsingPost4: (user: AddManageUserReqDTO, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/users/save`,
        method: "POST",
        body: user,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name SavesUsingPost
     * @summary 批量新增部门用户接口
     * @request POST:/users/saves
     */
    savesUsingPost: (
      users: AddManageUserReqDTO[],
      params: RequestParams = {},
    ) =>
      this.request<BizResponseMapStringListString, any>({
        path: `/users/saves`,
        method: "POST",
        body: users,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name PostAccessTokenUsingPost
     * @summary 用户登录
     * @request POST:/users/token
     */
    postAccessTokenUsingPost: (
      query: {
        /** password */
        password: string;
        /** username */
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseManageLoginRespDTO, any>({
        path: `/users/token`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name UpdateUsingPut3
     * @summary 部门员工详情修改接口
     * @request PUT:/users/update
     */
    updateUsingPut3: (
      user: UpdateManageUserReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/update`,
        method: "PUT",
        body: user,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name UpdateManagerPasswordUsingPatch
     * @summary 后台用户修改密码
     * @request PATCH:/users/updateManagerPassword
     */
    updateManagerPasswordUsingPatch: (
      user: UpdateManagerPasswordReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/updateManagerPassword`,
        method: "PATCH",
        body: user,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name PatchUsingPatch
     * @summary 部门员工禁用或者修改密码局部更新接口
     * @request PATCH:/users/updatePasswordEnable
     */
    patchUsingPatch: (
      user: UpdatePasswordReqManagerDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/updatePasswordEnable`,
        method: "PATCH",
        body: user,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name UploadUserUsingPost
     * @summary 上传用户信息
     * @request POST:/users/uploadUser
     */
    uploadUserUsingPost: (
      data: {
        /**
         * file
         * @format binary
         */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseMapStringListString, any>({
        path: `/users/uploadUser`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name GetUserByUsernameUsingGet
     * @summary 查询用户名获取用户信息
     * @request GET:/users/username/{username}
     */
    getUserByUsernameUsingGet: (username: string, params: RequestParams = {}) =>
      this.request<BizResponseManageUserDetailRespDTO, any>({
        path: `/users/username/${username}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name VerificationMobileRepeatUsingGet
     * @summary 验证手机号是否重复
     * @request GET:/users/verificationMobileRepeat
     */
    verificationMobileRepeatUsingGet: (
      query: {
        /** mobile */
        mobile: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponse, any>({
        path: `/users/verificationMobileRepeat`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 用户接口
     * @name DetailUsingGet2
     * @summary 查询用户详情
     * @request GET:/users/{id}
     */
    detailUsingGet2: (id: string, params: RequestParams = {}) =>
      this.request<BizResponseManageUserDetailRespDTO, any>({
        path: `/users/${id}`,
        method: "GET",
        ...params,
      }),
  };
  video = {
    /**
     * No description
     *
     * @tags 火山直播控制层
     * @name GetActivitiesUsingGet
     * @summary 获取直播间列表
     * @request GET:/video/getActivities
     */
    getActivitiesUsingGet: (params: RequestParams = {}) =>
      this.request<BizResponseGetActivitiesRespDTO, any>({
        path: `/video/getActivities`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 火山直播控制层
     * @name GetActivityByIdUsingGet
     * @summary 获取直播间详情
     * @request GET:/video/getActivityById
     */
    getActivityByIdUsingGet: (
      query: {
        /**
         * activityId
         * @format int64
         */
        activityId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVideoActivityDTO, any>({
        path: `/video/getActivityById`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 火山直播控制层
     * @name GetTokenUsingGet
     * @summary 获取token
     * @request GET:/video/getToken
     */
    getTokenUsingGet: (
      query: {
        /**
         * activityId
         * @format int64
         */
        activityId: number;
        /**
         * mode
         * @format int32
         */
        mode: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseString, any>({
        path: `/video/getToken`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 火山直播控制层
     * @name ReserveUsingGet
     * @summary 直播预约
     * @request GET:/video/reserve
     */
    reserveUsingGet: (
      query: {
        /**
         * activityId
         * @format int64
         */
        activityId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/video/reserve`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 火山直播控制层
     * @name ReserveCallBackUsingPost
     * @summary 直播预约回调
     * @request POST:/video/reserveCallBack
     */
    reserveCallBackUsingPost: (
      reqDTO: ReserveCallBackReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/video/reserveCallBack`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  workbenchBanner = {
    /**
     * No description
     *
     * @tags 工作台banner
     * @name BackendGetUsingPost
     * @summary 后台获取工作台banner
     * @request POST:/workbenchBanner/backendGet
     */
    backendGetUsingPost: (
      queryWorkbenchBannerReqDTO: QueryWorkbenchBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListWorkbenchBannerRespDTO, any>({
        path: `/workbenchBanner/backendGet`,
        method: "POST",
        body: queryWorkbenchBannerReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 工作台banner
     * @name GetUsingGet1
     * @summary 客户端获取工作台banner
     * @request GET:/workbenchBanner/get
     */
    getUsingGet1: (params: RequestParams = {}) =>
      this.request<BizResponseListWorkbenchBannerRespDTO, any>({
        path: `/workbenchBanner/get`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 工作台banner
     * @name SaveUsingPost2
     * @summary 保存工作台banner
     * @request POST:/workbenchBanner/save
     */
    saveUsingPost2: (
      saveWorkbenchBannerReqDTO: SaveWorkbenchBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/workbenchBanner/save`,
        method: "POST",
        body: saveWorkbenchBannerReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 工作台banner
     * @name UpdateUsingPost1
     * @summary 更新工作台banner
     * @request POST:/workbenchBanner/update
     */
    updateUsingPost1: (
      saveWorkbenchBannerReqDTO: SaveWorkbenchBannerReqDTO,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/workbenchBanner/update`,
        method: "POST",
        body: saveWorkbenchBannerReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
}

// generate-template
    import { handleRequest as _handleRequest, baseURL, getHandleResponse, handleResponseError } from '@/plugins/axios'
    type _ResponseData = {
  code?: string;
  data?: any;
  msg?: string;
};
const _handleResponse = getHandleResponse(false)

export const isServer = () => false
export function handleRequest (requestParams:any) {
  _handleRequest(requestParams)
  requestParams.baseUrl = baseURL
  if (!requestParams.format) {
    requestParams.format = 'json'
  }
}
export const handleResponse:<T extends _ResponseData | Blob | void>(
  res: { data: T }
)=> Promise<T extends _ResponseData ? T : Blob | void> = (res) => _handleResponse(res as any).catch(handleResponseError)
    // generate-template-end
                            
// 重写后的api

const http = new HttpClient();
const _request = http.request;
const getRequest = () => (isServer() ? new HttpClient().request : _request);

export const customer = {
  /**
   *
   * @tags livens-probe-controller
   * @summary 执行一次健康检查探针
   * @request GET:/customer/Probe/test
   */
  "/Probe/test": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/Probe/test`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags monitor-contorller
   * @summary jvmInfo
   * @request GET:/customer/actuator1/jvmInfo
   */
  "/actuator1/jvmInfo": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/actuator1/jvmInfo`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 添加联系方式
   * @request POST:/customer/addConcat
   */
  "/addConcat": (body: ConcatReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/addConcat`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 更改新邮箱
   * @request POST:/customer/addEmail
   */
  "/addEmail": (body: DTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/addEmail`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 添加商品附加项
   * @request POST:/customer/additional/add
   */
  "/additional/add": (body: AddAdditionReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/additional/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 新增水洗标配置接口
   * @request POST:/customer/additional/addWashedlabel
   */
  "/additional/addWashedlabel": (
    body: ShopWashedLabelAdditionReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/additional/addWashedlabel`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 删除附加项详情
   * @request GET:/customer/additional/delete
   */
  "/additional/delete": (
    query: {
      shopAdditionId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/additional/delete`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取附加项配置详情
   * @request GET:/customer/additional/get
   */
  "/additional/get": (
    query: {
      shopAdditionId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionDetailRespDTO, any>({
      path: `/customer/additional/get`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-additional-feign-api-impl
   * @summary getAdditionFeign
   * @request GET:/customer/additional/getAdditionFeign
   */
  "/additional/getAdditionFeign": (
    query: {
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListShopAdditionRespDTO, any>({
      path: `/customer/additional/getAdditionFeign`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取国际物流附加项
   * @request GET:/customer/additional/getAddress
   */
  "/additional/getAddress": (
    query: {
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionAddressRespDTO, any>({
      path: `/customer/additional/getAddress`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-additional-feign-api-impl
   * @summary getAddressByShopIdFeign
   * @request GET:/customer/additional/getAddressByShopIdFeign
   */
  "/additional/getAddressByShopIdFeign": (
    query: {
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionAddressRespDTO, any>({
      path: `/customer/additional/getAddressByShopIdFeign`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取国际物流附加项(Feign)
   * @request GET:/customer/additional/getAddressFeign
   */
  "/additional/getAddressFeign": (
    query: {
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionAddressRespDTO, any>({
      path: `/customer/additional/getAddressFeign`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 查询店铺已配置附加项的类目
   * @request GET:/customer/additional/getCategoryConfigured
   */
  "/additional/getCategoryConfigured": (
    query: {
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCategoryCodeRespDTO, any>({
      path: `/customer/additional/getCategoryConfigured`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-additional-feign-api-impl
   * @summary getGoodsAdditionFeign
   * @request GET:/customer/additional/getGoodsAdditionFeign
   */
  "/additional/getGoodsAdditionFeign": (
    query: {
      categoryCateId: number;
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionDetailRespDTO, any>({
      path: `/customer/additional/getGoodsAdditionFeign`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取附加项模板
   * @request GET:/customer/additional/getList
   */
  "/additional/getList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListAdditionTemplateRespDTO, any>({
      path: `/customer/additional/getList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-additional-feign-api-impl
   * @summary getShopLogisticsInfo
   * @request GET:/customer/additional/getShopLogisticsInfo
   */
  "/additional/getShopLogisticsInfo": (
    query: {
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopAddressRespDTO, any>({
      path: `/customer/additional/getShopLogisticsInfo`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取水洗标配置
   * @request GET:/customer/additional/getWashedlabel
   */
  "/additional/getWashedlabel": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionWashedLabelRespDTO, any>({
      path: `/customer/additional/getWashedlabel`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取水洗标配置列表
   * @request GET:/customer/additional/getWashedlabelList
   */
  "/additional/getWashedlabelList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListWashedLabelRespDTOV2, any>({
      path: `/customer/additional/getWashedlabelList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取店铺水洗标模板信息，没传 id 返回默认的
   * @request GET:/customer/additional/getWashedlabelV2
   */
  "/additional/getWashedlabelV2": (
    query: {
      washedlabelAdditionId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseWashedLabelRespDTOV2, any>({
      path: `/customer/additional/getWashedlabelV2`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取水洗标配置-仓库
   * @request GET:/customer/additional/getWashedlabelWarehouse
   */
  "/additional/getWashedlabelWarehouse": (
    query: {
      customerShopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopAdditionWashedLabelRespDTO, any>({
      path: `/customer/additional/getWashedlabelWarehouse`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 获取附加项配置表
   * @request GET:/customer/additional/list
   */
  "/additional/list": (
    query: {
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListShopAdditionRespDTO, any>({
      path: `/customer/additional/list`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 更新商品附加项
   * @request POST:/customer/additional/update
   */
  "/additional/update": (
    body: UpdateAdditionReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/additional/update`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 更新国际物流附加项
   * @request POST:/customer/additional/updateAddress
   */
  "/additional/updateAddress": (
    body: UpdateAdditionAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/additional/updateAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 更新水洗标配置
   * @request POST:/customer/additional/updateWashedlabel
   */
  "/additional/updateWashedlabel": (
    body: UpdateAdditionWashedLabelReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/additional/updateWashedlabel`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags additional-controller
   * @summary 更新水洗标配置接口V2
   * @request POST:/customer/additional/updateWashedlabelV2
   */
  "/additional/updateWashedlabelV2": (
    body: ShopWashedLabelAdditionReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/additional/updateWashedlabelV2`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary 查询地区信息通过id
   * @request POST:/customer/area/getAreaById
   */
  "/area/getAreaById": (
    query: {
      intAreaId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/area/getAreaById`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary 批量查询地区信息通过ids
   * @request POST:/customer/area/getAreaListByIds
   */
  "/area/getAreaListByIds": (
    query: {
      intAreaIds: number[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListIntAreaDTO, any>({
      path: `/customer/area/getAreaListByIds`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary getById
   * @request GET:/customer/area/getById
   */
  "/area/getById": (
    query: {
      id: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/area/getById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary getByKrNameLike
   * @request GET:/customer/area/getByKrNameLike
   */
  "/area/getByKrNameLike": (
    query: {
      krName: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/area/getByKrNameLike`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary 查询下级地区信息
   * @request GET:/customer/area/getByPid
   */
  "/area/getByPid": (
    query: {
      pid: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListIntAreaDTO, any>({
      path: `/customer/area/getByPid`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary getCountryByCountryCode
   * @request GET:/customer/area/getCountryByCountryCode
   */
  "/area/getCountryByCountryCode": (
    query: {
      countryCode: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/area/getCountryByCountryCode`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary getJapanProvinceByEnLike
   * @request GET:/customer/area/getJapanProvinceByEnLike
   */
  "/area/getJapanProvinceByEnLike": (
    query: {
      nameEn: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/area/getJapanProvinceByEnLike`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary getJapanProvinceByNameLike
   * @request GET:/customer/area/getJapanProvinceByNameLike
   */
  "/area/getJapanProvinceByNameLike": (
    query: {
      name: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/area/getJapanProvinceByNameLike`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 地区设置
   * @summary 查询地区信息全部
   * @request POST:/customer/area/getTree
   */
  "/area/getTree": (
    query: {
      level?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListIntAreaDTO, any>({
      path: `/customer/area/getTree`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary assignManager
   * @request POST:/customer/assignManager
   */
  "/assignManager": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/assignManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary assignMarketingManager
   * @request POST:/customer/assignMarketingManager
   */
  "/assignMarketingManager": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/assignMarketingManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary assignSupervisionManager
   * @request POST:/customer/assignSupervisionManager
   */
  "/assignSupervisionManager": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/assignSupervisionManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 省市区后门接口
   * @summary initJapanEnName
   * @request GET:/customer/backdoor/area/initJapanEnName
   */
  "/backdoor/area/initJapanEnName": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/backdoor/area/initJapanEnName`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 省市区后门接口
   * @summary setCountryCode
   * @request GET:/customer/backdoor/area/setCountryCode
   */
  "/backdoor/area/setCountryCode": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/backdoor/area/setCountryCode`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户后门接口
   * @summary 新建一个用户
   * @request POST:/customer/backdoor/customer/createNew
   */
  "/backdoor/customer/createNew": (
    query: {
      buType?: number;
      channel?: string;
      chatWorkId?: string;
      corpName?: string;
      countryCode?: string;
      countryPlaceCode?: string;
      customerEmail?: string;
      customerMobile?: string;
      customerName?: string;
      customerStatus?: number;
      "ext.innerMap"?: undefined;
      gender?: number;
      initShopFlag?: number;
      invitationCode?: string;
      invitationPlatform?: number;
      langcode?: string;
      loginName?: string;
      password?: string;
      platformType?: number;
      recommendationEmail?: string;
      skype?: string;
      spm?: string;
      stationCode?: string;
      termId?: number;
      thirdCustomerId?: string;
      thirdCustomerName?: string;
      thirdEmail?: string;
      thirdPlatform?: string;
      utcTimeZone?: string;
      verificationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/backdoor/customer/createNew`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户后门接口
   * @summary 后台删除用户接口,松松使用
   * @request DELETE:/customer/backdoor/customer/deleteCustomerBack
   */
  "/backdoor/customer/deleteCustomerBack": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/backdoor/customer/deleteCustomerBack`,
      method: "DELETE",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户后门接口
   * @summary 导入模板-重新分配主账号营销经理和复购单经理
   * @request POST:/customer/backdoor/customer/import/allocationManagerByMainCustomerId
   */
  "/backdoor/customer/import/allocationManagerByMainCustomerId": (
    body: {
      file: File;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/backdoor/customer/import/allocationManagerByMainCustomerId`,
      method: "POST",

      body,
      type: ContentType.FormData,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户后门接口
   * @summary 标记用户为内部用户,松松使用
   * @request POST:/customer/backdoor/customer/internalCustomerBack
   */
  "/backdoor/customer/internalCustomerBack": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/backdoor/customer/internalCustomerBack`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户后门接口
   * @summary 获取经济舱或退会的客户总监客户经理存入数据库
   * @request POST:/customer/backdoor/customer/managerLogSaveAndDelayDel
   */
  "/backdoor/customer/managerLogSaveAndDelayDel": (
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/backdoor/customer/managerLogSaveAndDelayDel`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户后门接口
   * @summary 初始化英文和韩文文案
   * @request GET:/customer/backdoor/notify/initKrAndEnContent
   */
  "/backdoor/notify/initKrAndEnContent": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/backdoor/notify/initKrAndEnContent`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags recall-backdoor-controller
   * @summary recallEmailSend
   * @request GET:/customer/backdoor/recall/emailSend
   */
  "/backdoor/recall/emailSend": (
    query: {
      email?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<array, any>({
      path: `/customer/backdoor/recall/emailSend`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心后面接口
   * @summary initContent
   * @request GET:/customer/backdoor/supportContent/initContent
   */
  "/backdoor/supportContent/initContent": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/backdoor/supportContent/initContent`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 创建Banner
   * @request POST:/customer/banner/create
   */
  "/banner/create": (body: AddBannerReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/banner/create`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 删除banner
   * @request DELETE:/customer/banner/delete
   */
  "/banner/delete": (
    query: {
      bannerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/banner/delete`,
      method: "DELETE",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary getMarketBannerByCategory
   * @request POST:/customer/banner/getByCategory
   */
  "/banner/getByCategory": (
    body: ManageBannerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageBannerRespDTO, any>({
      path: `/customer/banner/getByCategory`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 累加点击数
   * @request POST:/customer/banner/increment
   */
  "/banner/increment": (
    body: UpdateManageBannerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/banner/increment`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 查询banner分页
   * @request POST:/customer/banner/page
   */
  "/banner/page": (
    body: GetManageBannerPageReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageManageBannerRespDTO, any>({
      path: `/customer/banner/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 获取用户显示的banner(前台)
   * @request GET:/customer/banner/show
   */
  "/banner/show": (
    query: {
      bannerType?: number;
      stationCode?: string;
      systemSource?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageBannerRespDTO, any>({
      path: `/customer/banner/show`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 根据banner类型获取banner列表
   * @request GET:/customer/banner/show/market
   */
  "/banner/show/market": (
    query: {
      bannerType: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageBannerRespDTO, any>({
      path: `/customer/banner/show/market`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 开启/关闭banner状态
   * @request POST:/customer/banner/toggle/status
   */
  "/banner/toggle/status": (
    body: UpdateManageBannerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/banner/toggle/status`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags banner管理接口
   * @summary 修改Banner
   * @request PUT:/customer/banner/update
   */
  "/banner/update": (body: UpdateBannerReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/banner/update`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 官网接口
   * @summary 保存客户信息
   * @request POST:/customer/base/feedback/addFeedbackInfo
   */
  "/base/feedback/addFeedbackInfo": (
    body: FeedbackInfoReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/base/feedback/addFeedbackInfo`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 官网接口
   * @summary 查询列表
   * @request GET:/customer/base/feedback/list
   */
  "/base/feedback/list": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListFeedbackInfoRspDTO, any>({
      path: `/customer/base/feedback/list`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 注册页配图
   * @summary 编辑(后台)
   * @request POST:/customer/base/registerPageImage/backend/edit
   */
  "/base/registerPageImage/backend/edit": (
    body: RegisterPageImageBackendUpdateDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/registerPageImage/backend/edit`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 注册页配图
   * @summary 查询列表(后台)
   * @request GET:/customer/base/registerPageImage/backend/query
   */
  "/base/registerPageImage/backend/query": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListRegisterPageImageBackendDTO, any>({
      path: `/customer/base/registerPageImage/backend/query`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 注册页配图
   * @summary 查询注册页配图
   * @request GET:/customer/base/registerPageImage/getRegisterImage
   */
  "/base/registerPageImage/getRegisterImage": (
    query: {
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseRegisterPageImageDTO, any>({
      path: `/customer/base/registerPageImage/getRegisterImage`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 类型选择字典
   * @summary 查询类型字典
   * @request GET:/customer/base/selectTypeDic/getSelectType
   */
  "/base/selectTypeDic/getSelectType": (
    query: {
      businessType?: string;
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListSelectTypeDicDTO, any>({
      path: `/customer/base/selectTypeDic/getSelectType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 全球化基础站点信息
   * @summary 查询支持的站点信息
   * @request GET:/customer/base/station/getSupportStation
   */
  "/base/station/getSupportStation": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerStationDTO, any>({
      path: `/customer/base/station/getSupportStation`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 添加文档
   * @request POST:/customer/base/supportCenter/content/add
   */
  "/base/supportCenter/content/add": (
    body: SupportCenterContentUpdateBackendDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/supportCenter/content/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 删除文档
   * @request POST:/customer/base/supportCenter/content/delete/{contentId}
   */
  "/base/supportCenter/content/delete/{contentId}": (
    pathParams: number,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/supportCenter/content/delete/${pathParams}`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 查询文档
   * @request GET:/customer/base/supportCenter/content/query
   */
  "/base/supportCenter/content/query": (
    query: {
      bizType?: string;
      contentType?: string;
      keyword?: string;
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListSupportCenterContentDTO, any>({
      path: `/customer/base/supportCenter/content/query`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 更新文档
   * @request POST:/customer/base/supportCenter/content/update
   */
  "/base/supportCenter/content/update": (
    body: SupportCenterContentUpdateBackendDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/supportCenter/content/update`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 查询帮助中心子目录，用于构建帮助中心目录（前台）
   * @request GET:/customer/base/supportCenter/getSupportSubjectByParentId
   */
  "/base/supportCenter/getSupportSubjectByParentId": (
    query: {
      bizType?: string;
      parentId?: number;
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListSupportCenterSubjectDTO, any>({
      path: `/customer/base/supportCenter/getSupportSubjectByParentId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 帮助中心根据路径查全路径
   * @request GET:/customer/base/supportCenter/query/byPath
   */
  "/base/supportCenter/query/byPath": (
    query: {
      path?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseSupportCenterSubjectDTO, any>({
      path: `/customer/base/supportCenter/query/byPath`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 帮助中心根据id查内容
   * @request GET:/customer/base/supportCenter/query/getSupportCenterContentById
   */
  "/base/supportCenter/query/getSupportCenterContentById": (
    query: {
      contentId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseSupportCenterContentDTO, any>({
      path: `/customer/base/supportCenter/query/getSupportCenterContentById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 批量更新排序
   * @request POST:/customer/base/supportCenter/subject/batchUpdateContentSort
   */
  "/base/supportCenter/subject/batchUpdateContentSort": (
    body: SupportCenterContentUpdateBackendDTO[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/supportCenter/subject/batchUpdateContentSort`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 批量更新目录排序
   * @request POST:/customer/base/supportCenter/subject/batchUpdateSort
   */
  "/base/supportCenter/subject/batchUpdateSort": (
    body: SupportCenterSubjectUpdateBackendDTO[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/supportCenter/subject/batchUpdateSort`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 批量更新分类
   * @request POST:/customer/base/supportCenter/subject/batchUpdateSubject
   */
  "/base/supportCenter/subject/batchUpdateSubject": (
    body: SupportCenterSubjectUpdateBackendDTO[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/supportCenter/subject/batchUpdateSubject`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 获取帮助中心内容
   * @request GET:/customer/base/supportCenter/subject/contentList
   */
  "/base/supportCenter/subject/contentList": (
    query: {
      subjectId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListSupportCenterContentDTO, any>({
      path: `/customer/base/supportCenter/subject/contentList`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 帮助中心
   * @summary 帮助中心目录-树结构
   * @request GET:/customer/base/supportCenter/tree
   */
  "/base/supportCenter/tree": (
    query: {
      bizType?: string;
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListSupportCenterSubjectDTO, any>({
      path: `/customer/base/supportCenter/tree`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 条款配置
   * @summary 用户同意条款
   * @request GET:/customer/base/term/agreeTerm
   */
  "/base/term/agreeTerm": (
    query: {
      termId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/term/agreeTerm`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 条款配置
   * @summary 获取用户同意过的条款
   * @request GET:/customer/base/term/getCustomerAgreeEffectTermByType
   */
  "/base/term/getCustomerAgreeEffectTermByType": (
    query: {
      stationCode?: string;
      type?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseTermConfigDTO, any>({
      path: `/customer/base/term/getCustomerAgreeEffectTermByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 条款配置
   * @summary 获取最新的条款配置
   * @request GET:/customer/base/term/getEffectTermByType
   */
  "/base/term/getEffectTermByType": (
    query: {
      stationCode?: string;
      type?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListTermConfigDTO, any>({
      path: `/customer/base/term/getEffectTermByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 条款配置
   * @summary 查询条款的修改记录
   * @request GET:/customer/base/term/getTermUpdateLog
   */
  "/base/term/getTermUpdateLog": (
    query: {
      stationCode?: string;
      type?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListTermConfigDTO, any>({
      path: `/customer/base/term/getTermUpdateLog`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 条款配置
   * @summary 更新条款内容(管理后台)
   * @request POST:/customer/base/term/updateTermContent
   */
  "/base/term/updateTermContent": (
    body: TermUpdateDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/base/term/updateTermContent`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 批量
   * @request POST:/customer/batchChangeWarehouseTask
   */
  "/batchChangeWarehouseTask": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/batchChangeWarehouseTask`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 绑定第三方账号
   * @request POST:/customer/bind/third
   */
  "/bind/third": (body: BindThirdReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/bind/third`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 解绑第三方账号
   * @request POST:/customer/bind/third/cancel
   */
  "/bind/third/cancel": (body: BindThirdReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/bind/third/cancel`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 第三方账号已绑定列表
   * @request GET:/customer/bind/third/getBindList
   */
  "/bind/third/getBindList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerThirdBindRespDTO, any>({
      path: `/customer/bind/third/getBindList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 第三方账号是否已绑定系统账号
   * @request POST:/customer/bind/third/isBind
   */
  "/bind/third/isBind": (body: BindThirdReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseThirdIsBindRespDTO, any>({
      path: `/customer/bind/third/isBind`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 注销全部账号校验
   * @request GET:/customer/cancelAllCustomerCheck
   */
  "/cancelAllCustomerCheck": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/cancelAllCustomerCheck`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 注销全部账号
   * @request GET:/customer/cancelCustomer
   */
  "/cancelCustomer": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/cancelCustomer`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 注销子账号
   * @request GET:/customer/cancelSubCustomer
   */
  "/cancelSubCustomer": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/cancelSubCustomer`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 注销子账号校验
   * @request GET:/customer/cancelSubCustomerCheck
   */
  "/cancelSubCustomerCheck": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/cancelSubCustomerCheck`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 更改邮箱发送邮件
   * @request GET:/customer/changeEmailsendEmail
   */
  "/changeEmailsendEmail": (
    query: {
      buType?: number;
      newCustomerEmail: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/changeEmailsendEmail`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 切换登陆登录(2B-2C)
   * @request POST:/customer/changeLogin
   */
  "/changeLogin": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/changeLogin`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 根据类型切换登录
   * @request GET:/customer/changeLoginByType
   */
  "/changeLoginByType": (
    query: {
      type: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/changeLoginByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 修改手机号码
   * @request POST:/customer/changeMobile
   */
  "/changeMobile": (body: ChangeMobileReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/changeMobile`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 更改新邮箱
   * @request POST:/customer/changeNewEmail
   */
  "/changeNewEmail": (body: ChangeEmailReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/changeNewEmail`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 开启关闭价格跟踪
   * @request GET:/customer/changePriceTrackingFlag
   */
  "/changePriceTrackingFlag": (
    query: {
      priceTrackingFlag: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/changePriceTrackingFlag`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 切换店铺
   * @request GET:/customer/changeShop
   */
  "/changeShop": (
    query: {
      shopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/changeShop`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 创建换仓任务
   * @request POST:/customer/changeWarehouseTask
   */
  "/changeWarehouseTask": (
    body: ChangeWarehouseTaskReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/changeWarehouseTask`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary checkAdmin
   * @request GET:/customer/checkAdmin
   */
  "/checkAdmin": (
    query: {
      userId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/checkAdmin`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 检测货盘白名单
   * @request GET:/customer/checkPalletWhite
   */
  "/checkPalletWhite": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/checkPalletWhite`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 检测推广联盟黑名单
   * @request GET:/customer/checkSMCBlack
   */
  "/checkSMCBlack": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/checkSMCBlack`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 清空缓存
   * @request GET:/customer/clearCache
   */
  "/clearCache": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/clearCache`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 关闭自动续费问卷调查
   * @request POST:/customer/closeAutorenewQuestionnaire
   */
  "/closeAutorenewQuestionnaire": (
    body: object,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/closeAutorenewQuestionnaire`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-config-controller
   * @summary 获取用户配置
   * @request GET:/customer/config/get
   */
  "/config/get": (
    query: {
      configCode: string;
      level?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerConfigRespDTO, any>({
      path: `/customer/config/get`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-config-controller
   * @summary 获取用户库存提醒配置信息
   * @request GET:/customer/config/getStockNotifyConfig
   */
  "/config/getStockNotifyConfig": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBigdecimal, any>({
      path: `/customer/config/getStockNotifyConfig`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-config-controller
   * @summary 获取用户库存提醒配置信息
   * @request GET:/customer/config/getStockNotifyConfigByCustomerId
   */
  "/config/getStockNotifyConfigByCustomerId": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBigdecimal, any>({
      path: `/customer/config/getStockNotifyConfigByCustomerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-config-controller
   * @summary 保存用户配置
   * @request POST:/customer/config/save
   */
  "/config/save": (
    body: SaveCustomerConfigReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/config/save`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-config-controller
   * @summary 保存或更新用户配置
   * @request POST:/customer/config/saveOrUpdate
   */
  "/config/saveOrUpdate": (
    body: SaveOrUpdateCustomerConfigReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/config/saveOrUpdate`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-config-controller
   * @summary 保存用户库存提醒配置信息
   * @request POST:/customer/config/saveStockNotifyConfig
   */
  "/config/saveStockNotifyConfig": (
    body: SaveOrUpdateCustomerConfigReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/config/saveStockNotifyConfig`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 创建2D账号
   * @request POST:/customer/create2D
   */
  "/create2D": (body: integer[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseInt, any>({
      path: `/customer/create2D`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags shop
   * @summary get shop list
   * @request POST:/customer/crossBorder/shop/list
   */
  "/crossBorder/shop/list": (
    body: OpenBaseReqDto,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListOpenShopListRespDTO, any>({
      path: `/customer/crossBorder/shop/list`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 查询会员信息List
   * @request POST:/customer/customer/membership/getBeforeTodayExpireList
   */
  "/customer/membership/getBeforeTodayExpireList": (
    body: CustomerMembershipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerMembershipResDTO, any>({
      path: `/customer/customer/membership/getBeforeTodayExpireList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 计算过期日期
   * @request GET:/customer/customer/membership/getExpiresDate
   */
  "/customer/membership/getExpiresDate": (
    query: {
      start: string;
      validPeriod: number;
      validPeriodUnit: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/membership/getExpiresDate`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 基于会员等级数据计算过期日期
   * @request GET:/customer/customer/membership/getExpiresDateBySuperCustomerId
   */
  "/customer/membership/getExpiresDateBySuperCustomerId": (
    query: {
      idDelay: number;
      membershipTemplateId?: number;
      superCustomerId: number;
      validPeriod: number;
      validPeriodUnit: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/membership/getExpiresDateBySuperCustomerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 添加会员信息
   * @request POST:/customer/customer/membership/insert
   */
  "/customer/membership/insert": (
    body: CustomerMembershipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/membership/insert`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 查询会员信息
   * @request POST:/customer/customer/membership/selectCustomerMembership
   */
  "/customer/membership/selectCustomerMembership": (
    body: CustomerMembershipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerMembershipResDTO, any>({
      path: `/customer/customer/membership/selectCustomerMembership`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 根据会员身份模板获取未过期用户列表
   * @request POST:/customer/customer/membership/selectNoExpiredListByTemplateId
   */
  "/customer/membership/selectNoExpiredListByTemplateId": (
    query: {
      membershipTemplateId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerMembershipResDTO, any>({
      path: `/customer/customer/membership/selectNoExpiredListByTemplateId`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 更新会员信息
   * @request POST:/customer/customer/membership/updateById
   */
  "/customer/membership/updateById": (
    body: CustomerMembershipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/membership/updateById`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 会员信息列表操作
   * @summary 查询会员信息/是否过期
   * @request GET:/customer/customer/membership/validMembership
   */
  "/customer/membership/validMembership": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/customer/membership/validMembership`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-service-controller
   * @summary bizProcess
   * @request POST:/customer/customer/service/echatBizProcess
   */
  "/customer/service/echatBizProcess": (
    body: EchatBizReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/service/echatBizProcess`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-service-controller
   * @summary echatMsgPush
   * @request POST:/customer/customer/service/echatMsgPush
   */
  "/customer/service/echatMsgPush": (
    body: object,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<string, any>({
      path: `/customer/customer/service/echatMsgPush`,
      method: "POST",

      body,
      type: undefined,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 激活子账号
   * @request POST:/customer/customer/shop/activateSubCustomer
   */
  "/customer/shop/activateSubCustomer": (
    body: AddSubCustomerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/activateSubCustomer`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 添加店铺
   * @request POST:/customer/customer/shop/add
   */
  "/customer/shop/add": (
    body: AddCustomerShopReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/customer/shop/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 添加清关地址
   * @request POST:/customer/customer/shop/addClearanceAddress
   */
  "/customer/shop/addClearanceAddress": (
    body: AddClearanceAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/customer/shop/addClearanceAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 添加收货地址
   * @request POST:/customer/customer/shop/addShippingAddress
   */
  "/customer/shop/addShippingAddress": (
    body: AddShippingAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/customer/shop/addShippingAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 开启/关闭自动下单
   * @request POST:/customer/customer/shop/auto/order/switch
   */
  "/customer/shop/auto/order/switch": (
    body: CustomerShopOptDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/customer/shop/auto/order/switch`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 删除清关地址
   * @request POST:/customer/customer/shop/deleteClearanceAddress/v2
   */
  "/customer/shop/deleteClearanceAddress/v2": (
    body: DeleteClearanceAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/deleteClearanceAddress/v2`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 删除清关地址
   * @request POST:/customer/customer/shop/deleteDefaultClearanceAddress
   */
  "/customer/shop/deleteDefaultClearanceAddress": (
    query: {
      shopClearanceAddressId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/deleteDefaultClearanceAddress`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 删除收货地址
   * @request POST:/customer/customer/shop/deleteShippingAddress
   */
  "/customer/shop/deleteShippingAddress": (
    query: {
      shopShippingAddressId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/deleteShippingAddress`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 删除收货地址
   * @request POST:/customer/customer/shop/deleteShippingAddress/v2
   */
  "/customer/shop/deleteShippingAddress/v2": (
    body: DeleteShippingAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/deleteShippingAddress/v2`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 取得用户店铺
   * @request POST:/customer/customer/shop/get
   */
  "/customer/shop/get": (
    body: GetCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/get`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 店铺分页_可根据账户id
   * @request POST:/customer/customer/shop/get/shop
   */
  "/customer/shop/get/shop": (
    body: GetCustomerShopListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/get/shop`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取BASE店铺绑定且token失效
   * @request POST:/customer/customer/shop/getBaseCustomerAuthStatus
   */
  "/customer/shop/getBaseCustomerAuthStatus": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/getBaseCustomerAuthStatus`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 根据店铺ID获取BASE店铺绑定且token失效
   * @request POST:/customer/customer/shop/getBaseCustomerAuthStatusByShopId
   */
  "/customer/shop/getBaseCustomerAuthStatusByShopId": (
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/getBaseCustomerAuthStatusByShopId`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取单个店铺清关地址
   * @request GET:/customer/customer/shop/getClearanceAddress
   */
  "/customer/shop/getClearanceAddress": (
    query: {
      shopClearanceAddressId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopClearanceAddressRespDTO, any>({
      path: `/customer/customer/shop/getClearanceAddress`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取店铺收货清关列表
   * @request GET:/customer/customer/shop/getClearanceAddressList
   */
  "/customer/shop/getClearanceAddressList": (
    query: {
      exportCountry?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListShopClearanceAddressRespDTO, any>({
      path: `/customer/customer/shop/getClearanceAddressList`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取单个店铺收货地址
   * @request GET:/customer/customer/shop/getShippingAddress
   */
  "/customer/shop/getShippingAddress": (
    query: {
      shopShippingAddressId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopShippingAddressRespDTO, any>({
      path: `/customer/customer/shop/getShippingAddress`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取店铺收货地址列表
   * @request GET:/customer/customer/shop/getShippingAddressList
   */
  "/customer/shop/getShippingAddressList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListShopShippingAddressRespDTO, any>({
      path: `/customer/customer/shop/getShippingAddressList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取店铺数量限制
   * @request GET:/customer/customer/shop/getShopNumLimit
   */
  "/customer/shop/getShopNumLimit": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopLimitRespDTO, any>({
      path: `/customer/customer/shop/getShopNumLimit`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 获取店铺采购配置信息
   * @request GET:/customer/customer/shop/getShopPurchase
   */
  "/customer/shop/getShopPurchase": (
    query: {
      customerShopId?: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopPurchaseRespDTO, any>({
      path: `/customer/customer/shop/getShopPurchase`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 检查用户是否包含子账户
   * @request GET:/customer/customer/shop/hasCustomerShop
   */
  "/customer/shop/hasCustomerShop": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/customer/shop/hasCustomerShop`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 店铺列表
   * @request POST:/customer/customer/shop/list
   */
  "/customer/shop/list": (
    body: GetCustomerShopListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/list`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 所有子店铺店铺列表
   * @request POST:/customer/customer/shop/listSubAll
   */
  "/customer/shop/listSubAll": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/listSubAll`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 店铺分页
   * @request POST:/customer/customer/shop/page
   */
  "/customer/shop/page": (
    body: GetCustomerShopListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerShopRespDTO, any>({
      path: `/customer/customer/shop/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary wms查询店铺分页数据
   * @request GET:/customer/customer/shop/query
   */
  "/customer/shop/query": (
    query: {
      customerShopName?: string;
      pageNum?: number;
      pageSize?: number;
      startIndex?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerShopWmsRespDTO, any>({
      path: `/customer/customer/shop/query`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 清关地址设为-默认
   * @request POST:/customer/customer/shop/setDefaultClearanceAddress
   */
  "/customer/shop/setDefaultClearanceAddress": (
    body: UpdateClearanceDefaultAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/setDefaultClearanceAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 收货地址设为默认
   * @request POST:/customer/customer/shop/setDefaultShippingAddress
   */
  "/customer/shop/setDefaultShippingAddress": (
    body: UpdateShippingDefaultAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/setDefaultShippingAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 编辑店铺
   * @request POST:/customer/customer/shop/update
   */
  "/customer/shop/update": (
    body: UpdateCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/customer/shop/update`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 更新清关地址
   * @request POST:/customer/customer/shop/updateClearanceAddress
   */
  "/customer/shop/updateClearanceAddress": (
    body: UpdateClearanceAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/customer/shop/updateClearanceAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 更新收货地址
   * @request POST:/customer/customer/shop/updateShippingAddress
   */
  "/customer/shop/updateShippingAddress": (
    body: UpdateShippingAddressReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/customer/shop/updateShippingAddress`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 更新店发货配置信息
   * @request POST:/customer/customer/shop/updateShopDelivery
   */
  "/customer/shop/updateShopDelivery": (
    body: UpdateShopDeliveryReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/updateShopDelivery`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户店铺
   * @summary 更新店铺采购配置信息
   * @request POST:/customer/customer/shop/updateShopPurchase
   */
  "/customer/shop/updateShopPurchase": (
    body: UpdateShopPurchaseReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/customer/shop/updateShopPurchase`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 工具类
   * @summary 导入excel，建立关系
   * @request POST:/customer/customer/tool/import_relation
   */
  "/customer/tool/import_relation": (
    body: {
      excelFile: File;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/customer/tool/import_relation`,
      method: "POST",

      body,
      type: ContentType.FormData,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-tag-feign-api-impl
   * @summary 根据客户ids和标签查询标签信息
   * @request POST:/customer/customerTag/search
   */
  "/customerTag/search": (
    body: CustomerTagSearchReq,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerTagDTO, any>({
      path: `/customer/customerTag/search`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 数据字典
   * @summary 根据父级字典key获取下级字典信息集合
   * @request GET:/customer/data/dict/list
   */
  "/data/dict/list": (
    query: {
      parentKey: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDataDictRespDTO, any>({
      path: `/customer/data/dict/list`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 数据字典
   * @summary 根据字典key获取字典信息
   * @request GET:/customer/data/dict/one
   */
  "/data/dict/one": (
    query: {
      key: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseDataDictRespDTO, any>({
      path: `/customer/data/dict/one`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 数据字典
   * @summary 根据类型获取下级字典信息集合
   * @request GET:/customer/data/dict/selectListByType
   */
  "/data/dict/selectListByType": (
    query: {
      type: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDataDictRespDTO, any>({
      path: `/customer/data/dict/selectListByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 申报白名单接口
   * @summary 增加白名單
   * @request POST:/customer/declaration/whitelist/add
   */
  "/declaration/whitelist/add": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/declaration/whitelist/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 申报白名单接口
   * @summary 校验是否在白名单中
   * @request POST:/customer/declaration/whitelist/check/{mainCustomerId}
   */
  "/declaration/whitelist/check/{mainCustomerId}": (
    pathParams: number,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/declaration/whitelist/check/${pathParams}`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 申报白名单接口
   * @summary 分页查询
   * @request POST:/customer/declaration/whitelist/getPage
   */
  "/declaration/whitelist/getPage": (
    body: DeclarationWhitelistPageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageDeclarationWhitelistRespDTO, any>({
      path: `/customer/declaration/whitelist/getPage`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 申报白名单接口
   * @summary 删除白名單
   * @request POST:/customer/declaration/whitelist/removeById/{id}
   */
  "/declaration/whitelist/removeById/{id}": (
    pathParams: number,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/declaration/whitelist/removeById/${pathParams}`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 是否已读不良品风险弹窗
   * @request GET:/customer/defectiveProductRiskFlag
   */
  "/defectiveProductRiskFlag": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/defectiveProductRiskFlag`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 删除账号，危险操作
   * @request DELETE:/customer/deleteAccount
   */
  "/deleteAccount": (
    query: {
      superCustomerId: number;
      token: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/deleteAccount`,
      method: "DELETE",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 新增组织接口
   * @request POST:/customer/depts/add
   */
  "/depts/add": (body: AddDepartmentReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/depts/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 批量删除组织机构公司部门（子公司，子部门）接口
   * @request DELETE:/customer/depts/deleteByIds
   */
  "/depts/deleteByIds": (body: string[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseMapStringListDepartmentDetailRespDTO, any>({
      path: `/customer/depts/deleteByIds`,
      method: "DELETE",

      body,
      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 根据组织目录id和条件查询目录下面的部门列表分页展示
   * @request POST:/customer/depts/getDepartmentUser
   */
  "/depts/getDepartmentUser": (
    body: GetDepartmentUserReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageDepartmentDetailRespDTO, any>({
      path: `/customer/depts/getDepartmentUser`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 查询展示组织机构左侧目录
   * @request POST:/customer/depts/getTree
   */
  "/depts/getTree": (
    body: GetDepartmentTreeReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDepartmentTreeRespDTO, any>({
      path: `/customer/depts/getTree`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 查询根据组织机构目录id展示其下面的目录
   * @request POST:/customer/depts/getTreeByDeptId
   */
  "/depts/getTreeByDeptId": (
    body: GetDepartmentTreeByIdReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDepartmentTreeRespDTO, any>({
      path: `/customer/depts/getTreeByDeptId`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 用户角色添加用户条件查询
   * @request POST:/customer/depts/getTreeByName
   */
  "/depts/getTreeByName": (
    body: GetDepartmentTreeByNameReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDepartmentTreeRespDTO, any>({
      path: `/customer/depts/getTreeByName`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 修改公司部门（子部门，子公司）详细
   * @request PUT:/customer/depts/update
   */
  "/depts/update": (
    body: UpdateDepartmentReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/depts/update`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 组织架构目录接口
   * @summary 查询组织机构详情
   * @request GET:/customer/depts/{depId}
   */
  "/depts/{depId}": (pathParams: string, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseDepartmentDetailRespDTO, any>({
      path: `/customer/depts/${pathParams}`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 根据选择字段导出钉钉通讯录(该接口官方不支持)
   * @request GET:/customer/dingding/exportExcel
   */
  "/dingding/exportExcel": (
    query: {
      columns?: string;
      companyId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/dingding/exportExcel`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 根据部门ID获取指定部门详情
   * @request GET:/customer/dingding/getDepartmentById
   */
  "/dingding/getDepartmentById": (
    query: {
      deptId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseJSONObject, any>({
      path: `/customer/dingding/getDepartmentById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 获取某个部门下的所有子部门
   * @request GET:/customer/dingding/getDepartments
   */
  "/dingding/getDepartments": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseJSONArray, any>({
      path: `/customer/dingding/getDepartments`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 获取全部的子部门和用户数据
   * @request GET:/customer/dingding/getDepartmentsAndUsers
   */
  "/dingding/getDepartmentsAndUsers": (
    query: {
      companyId: string;
      userId?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseJSONArray, any>({
      path: `/customer/dingding/getDepartmentsAndUsers`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 获取指定部门中的用户详细信息
   * @request GET:/customer/dingding/getUserListByDepartmentId
   */
  "/dingding/getUserListByDepartmentId": (
    query: {
      companyId: string;
      deptId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseJSONObject, any>({
      path: `/customer/dingding/getUserListByDepartmentId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 获取某个部门下的全部用户信息
   * @request GET:/customer/dingding/getUsersByDepartmentId
   */
  "/dingding/getUsersByDepartmentId": (
    query: {
      companyId: string;
      deptId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseJSONObject, any>({
      path: `/customer/dingding/getUsersByDepartmentId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 钉钉接口
   * @summary 获取全部公司钉钉信息表
   * @request GET:/customer/dingding/queryList
   */
  "/dingding/queryList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDingCompany, any>({
      path: `/customer/dingding/queryList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 客户分配
   * @summary 新增白名单
   * @request POST:/customer/distribute/addUser
   */
  "/distribute/addUser": (body: AddUserReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/distribute/addUser`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 客户分配
   * @summary 批量修改
   * @request POST:/customer/distribute/batchModify
   */
  "/distribute/batchModify": (
    body: BatchModifyPurchaseReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/distribute/batchModify`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 客户分配
   * @summary 单个/批量移除白名单
   * @request POST:/customer/distribute/batchRemoveUser
   */
  "/distribute/batchRemoveUser": (
    body: BatchRemoveUserReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/distribute/batchRemoveUser`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 客户分配
   * @summary 获取用户列表
   * @request POST:/customer/distribute/list
   */
  "/distribute/list": (
    body: QueryCustomerDistributeReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageQueryCustomerDistributeRespDTO, any>({
      path: `/customer/distribute/list`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 客户分配
   * @summary 获取白名单用户列表
   * @request POST:/customer/distribute/queryChangeUrlUsers
   */
  "/distribute/queryChangeUrlUsers": (
    body: ChangeUrlWhiteUserReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageChangeUrlWhiteUserRespDTO, any>({
      path: `/customer/distribute/queryChangeUrlUsers`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 客户分配
   * @summary 查询用户操作日志
   * @request GET:/customer/distribute/queryOperateLog
   */
  "/distribute/queryOperateLog": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListQueryOperateLogRespDTO, any>({
      path: `/customer/distribute/queryOperateLog`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 修改登录名
   * @request POST:/customer/editLoginName
   */
  "/editLoginName": (
    query: {
      loginName: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/editLoginName`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags email-send-feign-api-impl
   * @summary sendEmail
   * @request POST:/customer/email/send/single
   */
  "/email/send/single": (body: EmailSendReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseEmailSendRespDTO, any>({
      path: `/customer/email/send/single`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 邮箱验证登录
   * @request POST:/customer/emailLogin
   */
  "/emailLogin": (body: EmailLoginReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/emailLogin`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 邮箱登录发送验证码
   * @request POST:/customer/emailLogin/send/code
   */
  "/emailLogin/send/code": (
    body: CheckEmailReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/emailLogin/send/code`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 忘记密码重置密码
   * @request POST:/customer/forgetPasswordResetPassword
   */
  "/forgetPasswordResetPassword": (
    body: ResetPasswordReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/forgetPasswordResetPassword`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 忘记密码发送邮件
   * @request GET:/customer/forgetPasswordSendEmail
   */
  "/forgetPasswordSendEmail": (
    query: {
      buType?: number;
      customerEmail: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/forgetPasswordSendEmail`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags free-count-controller
   * @summary deduction
   * @request POST:/customer/free/count/deduction
   */
  "/free/count/deduction": (
    body: FreeCountOperationReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/free/count/deduction`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags free-count-controller
   * @summary getOemCharge
   * @request GET:/customer/free/count/getOemCharge
   */
  "/free/count/getOemCharge": (
    query: {
      level: number;
      stationCode: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBigdecimal, any>({
      path: `/customer/free/count/getOemCharge`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags free-count-controller
   * @summary rollback
   * @request POST:/customer/free/count/rollback
   */
  "/free/count/rollback": (
    body: FreeCountOperationReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/free/count/rollback`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags free-count-controller
   * @summary 根据类型查询免费次数
   * @request GET:/customer/free/count/selectFreeCountByType
   */
  "/free/count/selectFreeCountByType": (
    query: {
      superCustomerId?: number;
      type: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseFreeCountRespDTO, any>({
      path: `/customer/free/count/selectFreeCountByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 获取归档列表
   * @request POST:/customer/frog/article/archive
   */
  "/frog/article/archive": (
    body: GetFrogArticleArchivePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListFrogArticleArchiveSortRespDTO, any>({
      path: `/customer/frog/article/archive`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询归档文章分页
   * @request POST:/customer/frog/article/archive/page
   */
  "/frog/article/archive/page": (
    body: GetFrogArticleArchivePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageFrogArticleRespDTO, any>({
      path: `/customer/frog/article/archive/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 累加阅读量
   * @request GET:/customer/frog/article/count
   */
  "/frog/article/count": (
    query: {
      frogArticleId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/frog/article/count`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 创建青蛙文章
   * @request POST:/customer/frog/article/create
   */
  "/frog/article/create": (
    body: AddFrogArticleReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/create`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 删除文章
   * @request DELETE:/customer/frog/article/delete
   */
  "/frog/article/delete": (
    query: {
      frogArticleId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/delete`,
      method: "DELETE",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 文章详情
   * @request GET:/customer/frog/article/detail
   */
  "/frog/article/detail": (
    query: {
      frogArticleId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseFrogArticleDetailRespDTO, any>({
      path: `/customer/frog/article/detail`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询青蛙文章浏览记录分页（前台）
   * @request POST:/customer/frog/article/foot/page
   */
  "/frog/article/foot/page": (
    body: GetFrogArticlePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageFrogArticleRespDTO, any>({
      path: `/customer/frog/article/foot/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询当前文章上一篇/下一篇文章
   * @request POST:/customer/frog/article/get/prepAndNext
   */
  "/frog/article/get/prepAndNext": (
    body: GetFrogArticlePrepAndNextReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseFrogArticlePrepAndNextRespDTO, any>({
      path: `/customer/frog/article/get/prepAndNext`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询热门文章分页
   * @request POST:/customer/frog/article/hot/page
   */
  "/frog/article/hot/page": (
    body: GetFrogArticleArchivePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageHotFrogArticleRespDTO, any>({
      path: `/customer/frog/article/hot/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询青蛙文章分页（后台）
   * @request POST:/customer/frog/article/manage/page
   */
  "/frog/article/manage/page": (
    body: GetManageFrogArticlePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageManageFrogArticleRespDTO, any>({
      path: `/customer/frog/article/manage/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询青蛙文章分页（前台）
   * @request POST:/customer/frog/article/page
   */
  "/frog/article/page": (
    body: GetFrogArticlePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageFrogArticleRespDTO, any>({
      path: `/customer/frog/article/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 查询除平台频道外所有青蛙文章分页（前台）
   * @request POST:/customer/frog/article/page/all
   */
  "/frog/article/page/all": (
    body: GetAllFrogArticlePageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageFrogArticleRespDTO, any>({
      path: `/customer/frog/article/page/all`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 置顶文章
   * @request GET:/customer/frog/article/pinTop
   */
  "/frog/article/pinTop": (
    query: {
      frogArticleId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/pinTop`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 标记热门文章
   * @request POST:/customer/frog/article/sign/hot
   */
  "/frog/article/sign/hot": (
    query: {
      frogArticleMonth?: string;
      frogArticleYear?: string;
      pageNum?: number;
      pageSize?: number;
      startIndex?: number;
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListHotFrogArticleSortDTO, any>({
      path: `/customer/frog/article/sign/hot`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 开启/关闭文章可见状态
   * @request PUT:/customer/frog/article/toggle/status
   */
  "/frog/article/toggle/status": (
    body: UpdateFrogArticleStatusReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/toggle/status`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 删除青蛙文章分类
   * @request GET:/customer/frog/article/type/delete
   */
  "/frog/article/type/delete": (
    query: {
      id: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/type/delete`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 青蛙文章分类列表
   * @request GET:/customer/frog/article/type/list
   */
  "/frog/article/type/list": (
    query: {
      stationCode: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListFrogArticleType, any>({
      path: `/customer/frog/article/type/list`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 客户端青蛙文章分类列表(有文章的分类)
   * @request GET:/customer/frog/article/type/list/customer
   */
  "/frog/article/type/list/customer": (
    query: {
      stationCode: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListFrogArticleType, any>({
      path: `/customer/frog/article/type/list/customer`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 保存青蛙文章分类
   * @request POST:/customer/frog/article/type/save
   */
  "/frog/article/type/save": (
    body: FrogArticleType[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/type/save`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 取消置顶文章
   * @request GET:/customer/frog/article/unPinTop
   */
  "/frog/article/unPinTop": (
    query: {
      frogArticleId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/unPinTop`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 青蛙文章接口
   * @summary 修改青蛙文章
   * @request POST:/customer/frog/article/update
   */
  "/frog/article/update": (
    body: UpdateFrogArticleReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/frog/article/update`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-invitation-feign-api-impl
   * @summary 生成推广码
   * @request GET:/customer/generateCode
   */
  "/generateCode": (
    query: {
      superCustomerId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseString, any>({
      path: `/customer/generateCode`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getAdminRoles
   * @request POST:/customer/getAdminRoles
   */
  "/getAdminRoles": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageRoleRespDTO, any>({
      path: `/customer/getAdminRoles`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getAgentCustomerIdByDirectId
   * @request GET:/customer/getAgentCustomerIdByDirectId
   */
  "/getAgentCustomerIdByDirectId": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/getAgentCustomerIdByDirectId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 获取所有地址列表，会存储到redis
   * @request GET:/customer/getAllArea
   */
  "/getAllArea": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListIntAreaDTO, any>({
      path: `/customer/getAllArea`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getAllDepartment
   * @request GET:/customer/getAllDepartment
   */
  "/getAllDepartment": (
    query: {
      token: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListDepartmentDetailRespDTO, any>({
      path: `/customer/getAllDepartment`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getAllMainCustomer
   * @request POST:/customer/getAllMainCustomer
   */
  "/getAllMainCustomer": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerDetailManagerRespDTO, any>({
      path: `/customer/getAllMainCustomer`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 查询地区信息feign
   * @request GET:/customer/getAreaById
   */
  "/getAreaById": (
    query: {
      intAreaId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/getAreaById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 查询地区信息通过id,没有下级feign
   * @request GET:/customer/getAreaByIdOnly
   */
  "/getAreaByIdOnly": (
    query: {
      intAreaId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/getAreaByIdOnly`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 查询地区信息feign
   * @request POST:/customer/getAreaByIds
   */
  "/getAreaByIds": (body: IntAreaQueryDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListIntAreaDTO, any>({
      path: `/customer/getAreaByIds`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 查询地区信息通过地区等级,没有下级feign
   * @request GET:/customer/getAreaByLevelOnly
   */
  "/getAreaByLevelOnly": (
    query: {
      level?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListIntAreaDTO, any>({
      path: `/customer/getAreaByLevelOnly`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-station-feign-api-impl
   * @summary 根据国家code查询
   * @request GET:/customer/getByNationCodes
   */
  "/getByNationCodes": (
    query: {
      nationCodes: string[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerStationDTO, any>({
      path: `/customer/getByNationCodes`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-station-feign-api-impl
   * @summary 根据站点查询
   * @request GET:/customer/getByStationCode
   */
  "/getByStationCode": (
    query: {
      stationCode: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerStationDTO, any>({
      path: `/customer/getByStationCode`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取可转账的账号列表
   * @request GET:/customer/getCanTransformList
   */
  "/getCanTransformList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerCanTransformRespDTO, any>({
      path: `/customer/getCanTransformList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-invitation-feign-api-impl
   * @summary 获取可以提现的列表
   * @request GET:/customer/getCanTransformListBySuperId
   */
  "/getCanTransformListBySuperId": (
    query: {
      superCustomerId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerCanTransformRespDTO, any>({
      path: `/customer/getCanTransformListBySuperId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 获取前端版本号
   * @request POST:/customer/getClientVersion
   */
  "/getClientVersion": (
    query: {
      project: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseString, any>({
      path: `/customer/getClientVersion`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 根据key获取数量
   * @request GET:/customer/getCountByKey
   */
  "/getCountByKey": (
    query: {
      key: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/getCountByKey`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取直采用户跳转代采是否弹框标识
   * @request GET:/customer/getCustomer2AgencyGoodsSign
   */
  "/getCustomer2AgencyGoodsSign": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/getCustomer2AgencyGoodsSign`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取直采用户跳转代采是否弹框标识
   * @request GET:/customer/getCustomer2AgencySign
   */
  "/getCustomer2AgencySign": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/getCustomer2AgencySign`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerByDto
   * @request POST:/customer/getCustomerByDto
   */
  "/getCustomerByDto": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerByDto`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 通过谷歌表获取用户信息
   * @request GET:/customer/getCustomerByGoogleUrl
   */
  "/getCustomerByGoogleUrl": (
    query: {
      url: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomer, any>({
      path: `/customer/getCustomerByGoogleUrl`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerByMainCustomerId
   * @request POST:/customer/getCustomerByMainCustomerId
   */
  "/getCustomerByMainCustomerId": (
    body: GetCustomerByMainCustomerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerByMainCustomerId`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerBySuperAndManageId
   * @request POST:/customer/getCustomerByManageId
   */
  "/getCustomerByManageId": (
    body: QueryCustomerDetailManagerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerByManageId`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerByShopId
   * @request GET:/customer/getCustomerByShopId
   */
  "/getCustomerByShopId": (
    query: {
      shopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerByShopId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerByShopIds
   * @request POST:/customer/getCustomerByShopIds
   */
  "/getCustomerByShopIds": (
    query: {
      shopIds: number[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerByShopIds`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerBySuperId
   * @request GET:/customer/getCustomerBySuperId
   */
  "/getCustomerBySuperId": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerBySuperId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-invitation-feign-api-impl
   * @summary 获取用户信息
   * @request GET:/customer/getCustomerBySuperIds
   */
  "/getCustomerBySuperIds": (
    query: {
      superCustomerIds: number[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerBySuperIds`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerDetail
   * @request GET:/customer/getCustomerDetail
   */
  "/getCustomerDetail": (
    query: {
      token: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerDetail`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerDetailByFullName
   * @request GET:/customer/getCustomerDetailByFullName
   */
  "/getCustomerDetailByFullName": (
    query: {
      unificationCustomerFullName?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerDetailByFullName`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerDetailById
   * @request GET:/customer/getCustomerDetailById
   */
  "/getCustomerDetailById": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerDetailById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerDetailByIdList
   * @request POST:/customer/getCustomerDetailByIdList
   */
  "/getCustomerDetailByIdList": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerDetailByIdList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerDetailByManager
   * @request POST:/customer/getCustomerDetailByManager
   */
  "/getCustomerDetailByManager": (
    query: {
      customerId: number;
      userId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailManagerRespDTO, any>({
      path: `/customer/getCustomerDetailByManager`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 根据用户信息查用户-营销策略
   * @request GET:/customer/getCustomerDetailByMarketing
   */
  "/getCustomerDetailByMarketing": (
    query: {
      message?: string;
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerDetailByMarketing`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取用户列表详情
   * @request GET:/customer/getCustomerDetails
   */
  "/getCustomerDetails": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getCustomerDetails`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerIdByFullName
   * @request GET:/customer/getCustomerIdByFullName
   */
  "/getCustomerIdByFullName": (
    query: {
      unificationCustomerFullName: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListLong, any>({
      path: `/customer/getCustomerIdByFullName`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerIdsByManagerId
   * @request GET:/customer/getCustomerIdsByManagerId
   */
  "/getCustomerIdsByManagerId": (
    query: {
      managerId: string;
      roleEnum?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseHashSetLong, any>({
      path: `/customer/getCustomerIdsByManagerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取用户是否主动开启过新会员
   * @request GET:/customer/getCustomerIsNewMembership
   */
  "/getCustomerIsNewMembership": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/getCustomerIsNewMembership`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取用户列表
   * @request POST:/customer/getCustomerList
   */
  "/getCustomerList": (
    body: GetCustomerListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerItemRespDTO, any>({
      path: `/customer/getCustomerList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取用户列表
   * @request POST:/customer/getCustomerList/new
   */
  "/getCustomerList/new": (
    body: GetCustomerListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerItemRespDTO, any>({
      path: `/customer/getCustomerList/new`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取用户列表带权限限制
   * @request POST:/customer/getCustomerListAuth
   */
  "/getCustomerListAuth": (
    body: GetCustomerListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerItemRespDTO, any>({
      path: `/customer/getCustomerListAuth`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerList
   * @request POST:/customer/getCustomerListByCustomerIds
   */
  "/getCustomerListByCustomerIds": (
    body: GetCustomerListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerItemRespDTO, any>({
      path: `/customer/getCustomerListByCustomerIds`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取登陆用户会员信息
   * @request GET:/customer/getCustomerMembership
   */
  "/getCustomerMembership": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerMembership, any>({
      path: `/customer/getCustomerMembership`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerMembershipById
   * @request GET:/customer/getCustomerMembershipById
   */
  "/getCustomerMembershipById": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerMembership, any>({
      path: `/customer/getCustomerMembershipById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取账户概览-废弃
   * @request POST:/customer/getCustomerOverview
   */
  "/getCustomerOverview": (
    body: GetCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerOverviewRespDTO, any>({
      path: `/customer/getCustomerOverview`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取账户概览-全部店铺信息
   * @request POST:/customer/getCustomerOverviewOtherShop
   */
  "/getCustomerOverviewOtherShop": (
    body: GetCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerOverviewRespDTO, any>({
      path: `/customer/getCustomerOverviewOtherShop`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取账户概览-当前店铺
   * @request POST:/customer/getCustomerOverviewOwnerShop
   */
  "/getCustomerOverviewOwnerShop": (
    body: GetCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerOverviewRespDTO, any>({
      path: `/customer/getCustomerOverviewOwnerShop`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取账户概览-当前店铺-工作台新
   * @request POST:/customer/getCustomerOverviewWorkbenchInfo
   */
  "/getCustomerOverviewWorkbenchInfo": (
    body: GetCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerOverviewRespDTO, any>({
      path: `/customer/getCustomerOverviewWorkbenchInfo`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerShopBySuperId
   * @request GET:/customer/getCustomerShopBySuperId
   */
  "/getCustomerShopBySuperId": (
    query: {
      superCustomerIds: number[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopBySuperRespDTO, any>({
      path: `/customer/getCustomerShopBySuperId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getCustomerSimple
   * @request GET:/customer/getCustomerSimple
   */
  "/getCustomerSimple": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerRespDTO, any>({
      path: `/customer/getCustomerSimple`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getDefaultCustomerBySuperId
   * @request GET:/customer/getDefaultCustomerBySuperId
   */
  "/getDefaultCustomerBySuperId": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getDefaultCustomerBySuperId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 后台获取用户详情,新建寻源单用
   * @request GET:/customer/getDetailBySystem
   */
  "/getDetailBySystem": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getDetailBySystem`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getMainCustomerDetail
   * @request GET:/customer/getMainCustomerDetail
   */
  "/getMainCustomerDetail": (
    query: {
      token: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailRespDTO, any>({
      path: `/customer/getMainCustomerDetail`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getManageIdBySupervisionManagerIdAndRoles
   * @request GET:/customer/getManageIdBySupervisionManagerIdAndRoles
   */
  "/getManageIdBySupervisionManagerIdAndRoles": (
    query: {
      managerId: string;
      roleEnums: string[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseHashSetLong, any>({
      path: `/customer/getManageIdBySupervisionManagerIdAndRoles`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManageUserById
   * @request POST:/customer/getManageUserById
   */
  "/getManageUserById": (body: string, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserRespDTO, any>({
      path: `/customer/getManageUserById`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManageUserByToken
   * @request GET:/customer/getManageUserByToken
   */
  "/getManageUserByToken": (
    query: {
      token: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserRespDTO, any>({
      path: `/customer/getManageUserByToken`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManageUserList
   * @request POST:/customer/getManageUserList
   */
  "/getManageUserList": (body: string[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/getManageUserList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManageUserListByNickNameList
   * @request POST:/customer/getManageUserListByNickNameList
   */
  "/getManageUserListByNickNameList": (
    body: string[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/getManageUserListByNickNameList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManageUserListByNickNames
   * @request GET:/customer/getManageUserListByNickNames
   */
  "/getManageUserListByNickNames": (
    query: {
      roleId: string[];
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/getManageUserListByNickNames`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManageUserListByRoleId
   * @request GET:/customer/getManageUserListByRoleId
   */
  "/getManageUserListByRoleId": (
    query: {
      roleId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/getManageUserListByRoleId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getManagerDetailByCustomerId
   * @request GET:/customer/getManagerDetailByCustomerId
   */
  "/getManagerDetailByCustomerId": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseUserManagerDetailRespDTO, any>({
      path: `/customer/getManagerDetailByCustomerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags area-feign-api-impl
   * @summary 查询国家信息通过code,没有下级feign
   * @request GET:/customer/getNationByIdOnly
   */
  "/getNationByIdOnly": (
    query: {
      code: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseIntAreaDTO, any>({
      path: `/customer/getNationByIdOnly`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getPurchaserRole
   * @request GET:/customer/getPurchaserRole
   */
  "/getPurchaserRole": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageRoleRespDTO, any>({
      path: `/customer/getPurchaserRole`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getPurchaserRoleByCode
   * @request GET:/customer/getRoleByCode
   */
  "/getRoleByCode": (
    query: {
      code: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageRoleRespDTO, any>({
      path: `/customer/getRoleByCode`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getRoleList
   * @request POST:/customer/getRoleList
   */
  "/getRoleList": (body: string[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageRoleRespDTO, any>({
      path: `/customer/getRoleList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getRolesById
   * @request POST:/customer/getRolesById
   */
  "/getRolesById": (body: string, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageRoleRespDTO, any>({
      path: `/customer/getRolesById`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags manage-feign-api-impl
   * @summary getRolesByMenuId
   * @request POST:/customer/getRolesByMenuId
   */
  "/getRolesByMenuId": (body: string, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageRoleRespDTO, any>({
      path: `/customer/getRolesByMenuId`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取店铺情报
   * @request POST:/customer/getShopOverview
   */
  "/getShopOverview": (
    body: GetCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopOverviewRespDTO, any>({
      path: `/customer/getShopOverview`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getSubCustomerDetailByManager
   * @request POST:/customer/getSubCustomerDetailByManager
   */
  "/getSubCustomerDetailByManager": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDetailManagerRespDTO, any>({
      path: `/customer/getSubCustomerDetailByManager`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 获取子账号列表
   * @request GET:/customer/getSubCustomerList
   */
  "/getSubCustomerList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerDetailRespDTO, any>({
      path: `/customer/getSubCustomerList`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getSumAmountGroupBySuperCustomerId
   * @request GET:/customer/getSumAmountGroupBySuperCustomerId
   */
  "/getSumAmountGroupBySuperCustomerId": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListMembershipOrderDTO, any>({
      path: `/customer/getSumAmountGroupBySuperCustomerId`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary getSuperCustomerBySuperId
   * @request GET:/customer/getSuperCustomerBySuperId
   */
  "/getSuperCustomerBySuperId": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerRespDTO, any>({
      path: `/customer/getSuperCustomerBySuperId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 获取白名单
   * @request POST:/customer/getWhileList
   */
  "/getWhileList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListLong, any>({
      path: `/customer/getWhileList`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary hasSubscriptionOrder
   * @request POST:/customer/hasSubscriptionOrder
   */
  "/hasSubscriptionOrder": (
    query: {
      nextPaymentDate: string;
      subscriptionId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/hasSubscriptionOrder`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags holiday-date-feign-api-impl
   * @summary queryHolidayDate
   * @request POST:/customer/holiday/queryHolidayDate
   */
  "/holiday/queryHolidayDate": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListHolidayDateDTO, any>({
      path: `/customer/holiday/queryHolidayDate`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 删除重要通知
   * @request POST:/customer/importantNotice/deleteById
   */
  "/importantNotice/deleteById": (
    query: {
      id: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/importantNotice/deleteById`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 查询详情
   * @request GET:/customer/importantNotice/findDetailById
   */
  "/importantNotice/findDetailById": (
    query: {
      id: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseImportantNoticeDetailDTO, any>({
      path: `/customer/importantNotice/findDetailById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 用户端分页查询
   * @request POST:/customer/importantNotice/page
   */
  "/importantNotice/page": (
    body: ImportantNoticePageReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageResultImportantNoticeDTO, any>({
      path: `/customer/importantNotice/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 后台分页查询
   * @request POST:/customer/importantNotice/page/back
   */
  "/importantNotice/page/back": (
    body: ImportantNoticePageReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageResultImportantNoticeDTO, any>({
      path: `/customer/importantNotice/page/back`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 标记已读
   * @request POST:/customer/importantNotice/read
   */
  "/importantNotice/read": (
    query: {
      importantNoticeId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/importantNotice/read`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 保存重要通知
   * @request POST:/customer/importantNotice/save
   */
  "/importantNotice/save": (
    body: ImportantNoticeDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/importantNotice/save`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags important-notice-controller
   * @summary 查询未读数量
   * @request POST:/customer/importantNotice/selectUnReadCount
   */
  "/importantNotice/selectUnReadCount": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseInt, any>({
      path: `/customer/importantNotice/selectUnReadCount`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary insertMembershipOrder
   * @request POST:/customer/insertMembershipOrder
   */
  "/insertMembershipOrder": (
    body: MembershipOrderDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseString, any>({
      path: `/customer/insertMembershipOrder`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 美国站首页底部用户信息相关
   * @summary 添加信息
   * @request POST:/customer/intended/add
   */
  "/intended/add": (
    body: AddIntendedCustomerInfoReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/intended/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 当前ip是否能够访问
   * @request GET:/customer/isAllowedAccess
   */
  "/isAllowedAccess": (
    query: {
      ip: string;
      productId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/isAllowedAccess`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 是否注册
   * @request GET:/customer/isSignup
   */
  "/isSignup": (
    query: {
      mobileOrEmail: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/isSignup`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary listCustomerIdsByManagerId
   * @request GET:/customer/listCustomerIdsByManagerId
   */
  "/listCustomerIdsByManagerId": (
    query: {
      managerId: string;
      roleEnum: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseHashSetLong, any>({
      path: `/customer/listCustomerIdsByManagerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary loginFeign
   * @request GET:/customer/loginFeign
   */
  "/loginFeign": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/loginFeign`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 用户退出
   * @request GET:/customer/logout
   */
  "/logout": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/logout`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 是否已读会员变更
   * @request GET:/customer/memberChangeFlag
   */
  "/memberChangeFlag": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/memberChangeFlag`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 是否已读0级会员变更
   * @request GET:/customer/memberChangeZeroFlag
   */
  "/memberChangeZeroFlag": (
    query: {
      customerId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/memberChangeZeroFlag`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 新增菜单
   * @request POST:/customer/menus
   */
  "/menus": (body: AddMenuReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/menus`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 查询菜单树
   * @request GET:/customer/menus/getMenustree
   */
  "/menus/getMenustree": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListMenuTreeRespDTO, any>({
      path: `/customer/menus/getMenustree`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 根据目录id,名称,状态分页查询功能菜单
   * @request POST:/customer/menus/getPageMenu
   */
  "/menus/getPageMenu": (body: PageMenuReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageManageMenuRespDTO, any>({
      path: `/customer/menus/getPageMenu`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 查询路由列表
   * @request GET:/customer/menus/routes
   */
  "/menus/routes": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListRouteRespDTO, any>({
      path: `/customer/menus/routes`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 修改菜单
   * @request PUT:/customer/menus/updateById
   */
  "/menus/updateById": (body: UpdateMenuReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/menus/updateById`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 修改菜单的状态
   * @request POST:/customer/menus/updateVisible
   */
  "/menus/updateVisible": (
    body: UpdateMenuVisibleReqDTO[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/menus/updateVisible`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 批量删除菜单
   * @request DELETE:/customer/menus/{ids}
   */
  "/menus/{ids}": (pathParams: string, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/menus/${pathParams}`,
      method: "DELETE",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 菜单接口
   * @summary 查询菜单详情
   * @request GET:/customer/menus/{id}
   */
  "/menus/{id}": (pathParams: number, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageMenuRespDTO, any>({
      path: `/customer/menus/${pathParams}`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 手机号码发送验证码
   * @request POST:/customer/mobile/send/code
   */
  "/mobile/send/code": (body: DTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BaseResponse, any>({
      path: `/customer/mobile/send/code`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 手机号码发送验证码for app
   * @request POST:/customer/mobile/send/code/app
   */
  "/mobile/send/code/app": (
    query: {
      request?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BaseResponse, any>({
      path: `/customer/mobile/send/code/app`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 手机验证登录
   * @request POST:/customer/mobileLogin
   */
  "/mobileLogin": (body: DTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/mobileLogin`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 是否需要弹出弹窗
   * @request GET:/customer/needPopUpWindowByType
   */
  "/needPopUpWindowByType": (
    query: {
      type: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/needPopUpWindowByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 获取私有未读消息数量
   * @request GET:/customer/notify/get/private/unread/count
   */
  "/notify/get/private/unread/count": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseInt, any>({
      path: `/customer/notify/get/private/unread/count`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 发布私有通知
   * @request POST:/customer/notify/private/publish
   */
  "/notify/private/publish": (
    body: NotifyPrivatePublishVO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/private/publish`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 私有消息分页查询
   * @request GET:/customer/notify/private/query
   */
  "/notify/private/query": (
    query: {
      pageNum?: number;
      pageSize?: number;
      startIndex?: number;
      targetCustomerShopId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageNotifyPrivateVO, any>({
      path: `/customer/notify/private/query`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 私有消息分页查询
   * @request GET:/customer/notify/private/queryById
   */
  "/notify/private/queryById": (
    query: {
      notifyTemplatePrivateId?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseNotifyPrivateVO, any>({
      path: `/customer/notify/private/queryById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 私有消息已读
   * @request POST:/customer/notify/private/read
   */
  "/notify/private/read": (
    body: NotifyPrivateReadVO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/private/read`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 私有消息全部已读
   * @request POST:/customer/notify/private/read/all
   */
  "/notify/private/read/all": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/private/read/all`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 公有消息分页查询
   * @request GET:/customer/notify/public/query
   */
  "/notify/public/query": (
    query: {
      pageNum?: number;
      pageSize?: number;
      startIndex?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageNotifyPublicVO, any>({
      path: `/customer/notify/public/query`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 公有消息已读
   * @request POST:/customer/notify/public/read
   */
  "/notify/public/read": (
    body: NotifyPublicReadVO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/public/read`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 公有消息已读
   * @request POST:/customer/notify/public/read/all
   */
  "/notify/public/read/all": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/public/read/all`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 插入通知模板
   * @request POST:/customer/notify/template/insert
   */
  "/notify/template/insert": (
    body: NotifyTemplateUpsertVO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/template/insert`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 公有消息已读
   * @request GET:/customer/notify/test
   */
  "/notify/test": (
    query: {
      customerEmail: string;
      subject: string;
      templatePath: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/test`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 通知
   * @summary 公有消息已读
   * @request GET:/customer/notify/test1
   */
  "/notify/test1": (
    query: {
      customerEmail: string;
      subject: string;
      templatePath: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/notify/test1`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags a-li-user-feign-api-impl
   * @summary getThirdPlatformUserCount
   * @request POST:/customer/openApi/thirdPlatformUserCount/get
   */
  "/openApi/thirdPlatformUserCount/get": (
    body: CustomerCount,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseInt, any>({
      path: `/customer/openApi/thirdPlatformUserCount/get`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 云存储
   * @summary 上传文件
   * @request POST:/customer/oss/putOSS
   */
  "/oss/putOSS": (
    body: {
      file: File;
    },
    query: {
      path?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/oss/putOSS`,
      method: "POST",
      query,
      body,
      type: ContentType.FormData,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 云存储
   * @summary 获取上传签名信息
   * @request POST:/customer/oss/sign
   */
  "/oss/sign": (
    query: {
      path?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/oss/sign`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 云存储
   * @summary 获取上传签名
   * @request POST:/customer/oss/sign/another
   */
  "/oss/sign/another": (
    query: {
      bucketName?: string;
      path?: string;
      type?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/oss/sign/another`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 云存储
   * @summary 获取上传签名
   * @request POST:/customer/oss/sign/another/withoutLogin
   */
  "/oss/sign/another/withoutLogin": (
    query: {
      bucketName?: string;
      path?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/oss/sign/another/withoutLogin`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary queryPage
   * @request POST:/customer/page
   */
  "/page": (body: GetCustomerListReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerPageDTO, any>({
      path: `/customer/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 是否已读建议修改密码弹窗
   * @request GET:/customer/passwordChangeFlag
   */
  "/passwordChangeFlag": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/passwordChangeFlag`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 密码登录
   * @request POST:/customer/passwordLogin
   */
  "/passwordLogin": (body: PasswordLoginReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/passwordLogin`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 插件搜索次数统计
   * @request GET:/customer/pluginSearchStatistics
   */
  "/pluginSearchStatistics": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseSearchResultDTO, any>({
      path: `/customer/pluginSearchStatistics`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 插件搜索次数更新
   * @request GET:/customer/pluginSearchStatistics/update
   */
  "/pluginSearchStatistics/update": (
    query: {
      type: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/pluginSearchStatistics/update`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 插件搜索次数统计全部包含非会员和会员
   * @request GET:/customer/pluginSearchStatisticsAll
   */
  "/pluginSearchStatisticsAll": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseSearchResultDTO, any>({
      path: `/customer/pluginSearchStatisticsAll`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 是否开启价格跟踪
   * @request GET:/customer/priceTrackingFlag
   */
  "/priceTrackingFlag": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseInt, any>({
      path: `/customer/priceTrackingFlag`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-query-feign-api-impl
   * @summary checkPalletWhite
   * @request GET:/customer/query/ca/checkPalletWhite
   */
  "/query/ca/checkPalletWhite": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/query/ca/checkPalletWhite`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-query-feign-api-impl
   * @summary getCustomerMembershipTemplateIdBySuperId
   * @request POST:/customer/query/ca/getCustomerMembershipTemplateIdBySuperId
   */
  "/query/ca/getCustomerMembershipTemplateIdBySuperId": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/query/ca/getCustomerMembershipTemplateIdBySuperId`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-query-feign-api-impl
   * @summary getSimpleCustomer
   * @request GET:/customer/query/ca/getSimpleCustomer
   */
  "/query/ca/getSimpleCustomer": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerRespDTO, any>({
      path: `/customer/query/ca/getSimpleCustomer`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-query-feign-api-impl
   * @summary getSimpleCustomerV1
   * @request GET:/customer/query/ca/getSimpleCustomerV1
   */
  "/query/ca/getSimpleCustomerV1": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerRespDTO, any>({
      path: `/customer/query/ca/getSimpleCustomerV1`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-distribute-feign-api-impl
   * @summary queryChangeUrlUserByCustomerId
   * @request GET:/customer/queryChangeUrlUserByCustomerId
   */
  "/queryChangeUrlUserByCustomerId": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/queryChangeUrlUserByCustomerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-distribute-feign-api-impl
   * @summary queryPurchaseUserByCustomerId
   * @request GET:/customer/queryRelationByCustomerId
   */
  "/queryRelationByCustomerId": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerDistributeQueryRespDTO, any>({
      path: `/customer/queryRelationByCustomerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-distribute-feign-api-impl
   * @summary queryPurchaseUserByCustomerIds
   * @request POST:/customer/queryRelationByCustomerIds
   */
  "/queryRelationByCustomerIds": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseMapLongCustomerDistributeQueryRespDTO, any>({
      path: `/customer/queryRelationByCustomerIds`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 移出白名单
   * @request POST:/customer/removeWhileList
   */
  "/removeWhileList": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/removeWhileList`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary queryCustomerDetail
   * @request POST:/customer/reqDTO
   */
  "/reqDTO": (body: QueryCustomerDetailReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerDetailRespDTO, any>({
      path: `/customer/reqDTO`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 新增角色
   * @request POST:/customer/roles
   */
  "/roles": (body: AddRoleReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/roles`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 人员批量分配角色
   * @request POST:/customer/roles/addUserRole
   */
  "/roles/addUserRole": (
    body: AddUserRoleReqDTO[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/roles/addUserRole`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 批量删除角色里面的人员
   * @request POST:/customer/roles/delUserRole
   */
  "/roles/delUserRole": (
    body: DelUserRoleReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/roles/delUserRole`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 删除角色接口
   * @request DELETE:/customer/roles/deleteById
   */
  "/roles/deleteById": (
    query: {
      id?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/roles/deleteById`,
      method: "DELETE",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 查询复购单经理包含的人员
   * @request POST:/customer/roles/findRoles/manager
   */
  "/roles/findRoles/manager": (
    body: GetRolesUserListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListRoleUserRespDTO, any>({
      path: `/customer/roles/findRoles/manager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 查询营销经理包含的人员
   * @request POST:/customer/roles/findRoles/marketingManager
   */
  "/roles/findRoles/marketingManager": (
    body: GetRolesUserListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListRoleUserRespDTO, any>({
      path: `/customer/roles/findRoles/marketingManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 查询客户总监包含的人员
   * @request POST:/customer/roles/findRoles/supervisionManager
   */
  "/roles/findRoles/supervisionManager": (
    body: GetRolesUserListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListRoleUserRespDTO, any>({
      path: `/customer/roles/findRoles/supervisionManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 查询多个角色包含的人员
   * @request POST:/customer/roles/findRoles/user
   */
  "/roles/findRoles/user": (
    body: GetRolesUserListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListRoleUserRespDTO, any>({
      path: `/customer/roles/findRoles/user`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 通过角色id获取用户集合
   * @request GET:/customer/roles/getUsersById
   */
  "/roles/getUsersById": (
    query: {
      roleId?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/roles/getUsersById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 查询多个角色拥有的菜单树
   * @request POST:/customer/roles/menu_tree
   */
  "/roles/menu_tree": (body: string[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListMenuTreeListRespDTO, any>({
      path: `/customer/roles/menu_tree`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 修改多个角色菜单
   * @request PUT:/customer/roles/update/roles_menus
   */
  "/roles/update/roles_menus": (
    body: UpdateRoleMenusReqDTO[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/roles/update/roles_menus`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 角色接口
   * @summary 修改角色
   * @request PUT:/customer/roles/updateRole
   */
  "/roles/updateRole": (body: UpdateRoleReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/roles/updateRole`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary selectCustomerMembershipList
   * @request POST:/customer/selectCustomerMembershipList
   */
  "/selectCustomerMembershipList": (
    body: CustomerMembershipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerMembership, any>({
      path: `/customer/selectCustomerMembershipList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary selectCustomerPriceTrackingFlag
   * @request GET:/customer/selectCustomerPriceTrackingFlag
   */
  "/selectCustomerPriceTrackingFlag": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/selectCustomerPriceTrackingFlag`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary sendMsg
   * @request POST:/customer/sendMsg
   */
  "/sendMsg": (body: CustomerJpushReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/sendMsg`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 设置店铺为支持choice店铺
   * @request GET:/customer/setSupportChoiceShop
   */
  "/setSupportChoiceShop": (
    query: {
      shopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/setSupportChoiceShop`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary addCustomerShop
   * @request POST:/customer/shop/addCustomerShop
   */
  "/shop/addCustomerShop": (
    body: AddCustomerShopReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseLong, any>({
      path: `/customer/shop/addCustomerShop`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary addKoreaWarehouse
   * @request POST:/customer/shop/addKoreaWarehouse
   */
  "/shop/addKoreaWarehouse": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/shop/addKoreaWarehouse`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getCustomerShop
   * @request POST:/customer/shop/get
   */
  "/shop/get": (body: GetCustomerShopDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopRespDTO, any>({
      path: `/customer/shop/get`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getCustomerIdByShopIds
   * @request POST:/customer/shop/getCustomerIdByShopIds
   */
  "/shop/getCustomerIdByShopIds": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/shop/getCustomerIdByShopIds`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getCustomerShopListByShopIdList
   * @request POST:/customer/shop/getCustomerShopListByShopIdList
   */
  "/shop/getCustomerShopListByShopIdList": (
    body: GetCustomerShopListByShopIdListDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/shop/getCustomerShopListByShopIdList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getDefaultClearanceAddress
   * @request GET:/customer/shop/getDefaultClearanceAddress
   */
  "/shop/getDefaultClearanceAddress": (
    query: {
      customerShopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopClearanceAddressRespDTO, any>({
      path: `/customer/shop/getDefaultClearanceAddress`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getCustomerShopList
   * @request POST:/customer/shop/getList
   */
  "/shop/getList": (body: GetCustomerShopDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/shop/getList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getShopBySuperCustomerId
   * @request GET:/customer/shop/getShopBySuperCustomerId
   */
  "/shop/getShopBySuperCustomerId": (
    query: {
      superCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopRespDTO, any>({
      path: `/customer/shop/getShopBySuperCustomerId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getShopListByCustomerId
   * @request POST:/customer/shop/getShopListByCustomerId
   */
  "/shop/getShopListByCustomerId": (
    body: GetShopListByCustomerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopRespDTO, any>({
      path: `/customer/shop/getShopListByCustomerId`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getShopPurchase
   * @request GET:/customer/shop/getShopPurchase
   */
  "/shop/getShopPurchase": (
    query: {
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopPurchaseRespDTO, any>({
      path: `/customer/shop/getShopPurchase`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getShopPurchaseList
   * @request POST:/customer/shop/getShopPurchaseList
   */
  "/shop/getShopPurchaseList": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListShopPurchaseRespDTO, any>({
      path: `/customer/shop/getShopPurchaseList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getVirtualShopByMainCustomer
   * @request GET:/customer/shop/getVirtualShopByMainCustomer
   */
  "/shop/getVirtualShopByMainCustomer": (
    query: {
      mainCustomerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopRespDTO, any>({
      path: `/customer/shop/getVirtualShopByMainCustomer`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary getCustomerShopPage
   * @request POST:/customer/shop/page
   */
  "/shop/page": (body: BaseQueryPage, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerShopRespDTO, any>({
      path: `/customer/shop/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary queryCustomerShopPage
   * @request POST:/customer/shop/query/page
   */
  "/shop/query/page": (
    body: CustomerShopQueryDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerShopPageDTO, any>({
      path: `/customer/shop/query/page`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary selectShopListByCustomerIds
   * @request POST:/customer/shop/select/list/by/customerIds
   */
  "/shop/select/list/by/customerIds": (
    body: integer[],
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopPageDTO, any>({
      path: `/customer/shop/select/list/by/customerIds`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary 新建店铺国际物流配置
   * @request POST:/customer/shop/ship/add
   */
  "/shop/ship/add": (
    body: CustomerShopShipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/shop/ship/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary 删除店铺国际物流配置
   * @request POST:/customer/shop/ship/delete
   */
  "/shop/ship/delete": (
    body: CustomerShopShipDelReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/shop/ship/delete`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary 获取店铺国际物流配置列表
   * @request GET:/customer/shop/ship/get
   */
  "/shop/ship/get": (
    query: {
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopShipRespDTO, any>({
      path: `/customer/shop/ship/get`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary 后台 获取店铺国际物流配置列表
   * @request GET:/customer/shop/ship/getByShopId
   */
  "/shop/ship/getByShopId": (
    query: {
      "X-AuthShopId": number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopShipRespDTO, any>({
      path: `/customer/shop/ship/getByShopId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary getShopIdByLogisticsId
   * @request GET:/customer/shop/ship/getShopIdByLogisticsId
   */
  "/shop/ship/getShopIdByLogisticsId": (
    query: {
      logisticsId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListLong, any>({
      path: `/customer/shop/ship/getShopIdByLogisticsId`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary 获取店铺国际物流配置列表
   * @request GET:/customer/shop/ship/manage/get
   */
  "/shop/ship/manage/get": (
    query: {
      customerShopId: number;
      warehouseCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListCustomerShopShipRespDTO, any>({
      path: `/customer/shop/ship/manage/get`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-用户店铺物流配置修改
   * @summary 编辑店铺国际物流配置
   * @request POST:/customer/shop/ship/update
   */
  "/shop/ship/update": (
    body: CustomerShopShipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/shop/ship/update`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary updateCustomerShop
   * @request POST:/customer/shop/updateFeigh
   */
  "/shop/updateFeigh": (
    body: UpdateCustomerShopDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/shop/updateFeigh`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-shop-feign-api-impl
   * @summary updateShopPurchase
   * @request POST:/customer/shop/updateShopPurchase
   */
  "/shop/updateShopPurchase": (
    body: UpdateShopPurchaseReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/shop/updateShopPurchase`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 扣税账号接口
   * @summary 新增扣税账号
   * @request POST:/customer/shopTaxDeductionAccount/add
   */
  "/shopTaxDeductionAccount/add": (
    body: AddShopTaxDeductionAccountDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/shopTaxDeductionAccount/add`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 扣税账号接口
   * @summary 编辑扣税账号
   * @request POST:/customer/shopTaxDeductionAccount/edit
   */
  "/shopTaxDeductionAccount/edit": (
    body: UpdateShopTaxDeductionAccountDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/shopTaxDeductionAccount/edit`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 扣税账号接口
   * @summary 根据ID获取
   * @request GET:/customer/shopTaxDeductionAccount/getById/{id}
   */
  "/shopTaxDeductionAccount/getById/{id}": (
    pathParams: number,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseShopTaxDeductionAccountRespDTO, any>({
      path: `/customer/shopTaxDeductionAccount/getById/${pathParams}`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 扣税账号接口
   * @summary 分页查询
   * @request POST:/customer/shopTaxDeductionAccount/getPage
   */
  "/shopTaxDeductionAccount/getPage": (
    body: ShopTaxDeductionAccountPageDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageShopTaxDeductionAccountRespDTO, any>({
      path: `/customer/shopTaxDeductionAccount/getPage`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 扣税账号接口
   * @summary 删除扣税账号
   * @request POST:/customer/shopTaxDeductionAccount/removeById/{id}
   */
  "/shopTaxDeductionAccount/removeById/{id}": (
    pathParams: number,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/shopTaxDeductionAccount/removeById/${pathParams}`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 扣税账号接口
   * @summary 设置默认
   * @request POST:/customer/shopTaxDeductionAccount/setDefault/{id}
   */
  "/shopTaxDeductionAccount/setDefault/{id}": (
    pathParams: number,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/shopTaxDeductionAccount/setDefault/${pathParams}`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 查看客户谷歌表
   * @request POST:/customer/showGoogle
   */
  "/showGoogle": (
    body: GetCustomerGoogleListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageCustomerGoogle, any>({
      path: `/customer/showGoogle`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 查看新手指引
   * @request GET:/customer/showGuide
   */
  "/showGuide": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerGuide, any>({
      path: `/customer/showGuide`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 查看国际料金表
   * @request POST:/customer/showMaterialPrice
   */
  "/showMaterialPrice": (
    query: {
      stationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListMaterialPrice, any>({
      path: `/customer/showMaterialPrice`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary showWareIsExistOem
   * @request GET:/customer/showWareIsExistOem
   */
  "/showWareIsExistOem": (
    query: {
      customerShopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerShopRespDTO, any>({
      path: `/customer/showWareIsExistOem`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 注册
   * @request POST:/customer/signup
   */
  "/signup": (body: SignUpReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseSignUpRespDTO, any>({
      path: `/customer/signup`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 验证推广码是否为推广联盟
   * @request GET:/customer/signup/check/invitationCode
   */
  "/signup/check/invitationCode": (
    query: {
      invitationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/signup/check/invitationCode`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 验证登录名是否唯一
   * @request GET:/customer/signup/check/loginname
   */
  "/signup/check/loginname": (
    query: {
      loginName?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/signup/check/loginname`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 用户默认登录b2b或d2c
   * @request POST:/customer/signup/defaultLogin
   */
  "/signup/defaultLogin": (
    body: DefaultLoginReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/signup/defaultLogin`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 根据邀请码获取邀请信息
   * @request GET:/customer/signup/getInvitationInfo
   */
  "/signup/getInvitationInfo": (
    query: {
      invitationCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseInvitationInfoRespDTO, any>({
      path: `/customer/signup/getInvitationInfo`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 直采注册是否需要邮箱验证码
   * @request GET:/customer/signup/needEmailCode
   */
  "/signup/needEmailCode": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/signup/needEmailCode`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 直采注册，不需要邮箱验证码
   * @request POST:/customer/signup/noEmailCode
   */
  "/signup/noEmailCode": (body: SignUpReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseSignUpRespDTO, any>({
      path: `/customer/signup/noEmailCode`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 注册发送验证码
   * @request POST:/customer/signup/send/code
   */
  "/signup/send/code": (body: CheckEmailReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/signup/send/code`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 拆单不再提醒标记
   * @request POST:/customer/splitRemindFlag
   */
  "/splitRemindFlag": (
    body: CustomerSplitRemindFlagDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/splitRemindFlag`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 通过uuid和系统来源登录
   * @request POST:/customer/systemSourceLogin
   */
  "/systemSourceLogin": (
    body: DefaultLoginReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseCustomerLoginRespDTO, any>({
      path: `/customer/systemSourceLogin`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户表标签
   * @summary 定时任务
   * @request POST:/customer/tag/syncCustomerTag
   */
  "/tag/syncCustomerTag": (
    query: {
      batchCode: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/tag/syncCustomerTag`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户表标签
   * @summary 更新用户标签
   * @request POST:/customer/tag/updateCustomerTag
   */
  "/tag/updateCustomerTag": (
    body: CustomerTagUpdateReq,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/tag/updateCustomerTag`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary 添加拿货员
   * @request POST:/customer/take/users/addUser
   */
  "/take/users/addUser": (
    body: TakeUserAddReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/take/users/addUser`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary 修改拿货员
   * @request POST:/customer/take/users/editUser
   */
  "/take/users/editUser": (
    body: TakeUserEditReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/take/users/editUser`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary 根据ID获取拿货员详情
   * @request GET:/customer/take/users/getOne
   */
  "/take/users/getOne": (
    query: {
      takeUserId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseTakeUserRespDTO, any>({
      path: `/customer/take/users/getOne`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary 根据token获取拿货员详情
   * @request GET:/customer/take/users/getOneByToken
   */
  "/take/users/getOneByToken": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseTakeUserRespDTO, any>({
      path: `/customer/take/users/getOneByToken`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary getTakeUser
   * @request GET:/customer/take/users/getTakeUser
   */
  "/take/users/getTakeUser": (
    query: {
      token: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseTakeUserRespDTO, any>({
      path: `/customer/take/users/getTakeUser`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary 拿货员登录
   * @request POST:/customer/take/users/login
   */
  "/take/users/login": (
    body: TakeUserLoginReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseString, any>({
      path: `/customer/take/users/login`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 档口用户接口
   * @summary 拿货员列表
   * @request POST:/customer/take/users/pageUser
   */
  "/take/users/pageUser": (
    body: TakeUserReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageTakeUserRespDTO, any>({
      path: `/customer/take/users/pageUser`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 三方平台Oauth2授权相关
   * @summary 获取三方授权链接
   * @request POST:/customer/thirdAuthLink
   */
  "/thirdAuthLink": (
    body: GetThirdAuthLinkReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseString, any>({
      path: `/customer/thirdAuthLink`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 三方平台Oauth2授权相关
   * @summary 苹果授权回调接口
   * @request POST:/customer/thirdCallback/apple
   */
  "/thirdCallback/apple": (
    query: {
      code: string;
      id_token: string;
      state: string;
      user?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/thirdCallback/apple`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 三方平台Oauth2授权相关
   * @summary 苹果授权回调接口
   * @request POST:/customer/thirdCallback/easy/apple
   */
  "/thirdCallback/easy/apple": (
    query: {
      code: string;
      id_token: string;
      state: string;
      user?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<void, any>({
      path: `/customer/thirdCallback/easy/apple`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 三方平台Oauth2授权相关
   * @summary 获取三方数据
   * @request POST:/customer/thirdData
   */
  "/thirdData": (body: GetThirdDataReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseGetThirdDataRespDTO, any>({
      path: `/customer/thirdData`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 已读不良品风险弹窗
   * @request GET:/customer/update/defectiveProductRiskFlag
   */
  "/update/defectiveProductRiskFlag": (
    query: {
      confirmationStyle: number;
      version: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/update/defectiveProductRiskFlag`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新会员变更为已读
   * @request GET:/customer/update/memberChangeFlag
   */
  "/update/memberChangeFlag": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/update/memberChangeFlag`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新0级会员变更为已读
   * @request GET:/customer/update/memberChangeZeroFlag
   */
  "/update/memberChangeZeroFlag": (
    query: {
      customerId?: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/update/memberChangeZeroFlag`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 已读建议修改密码弹窗
   * @request GET:/customer/update/passwordChangeFlag
   */
  "/update/passwordChangeFlag": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/update/passwordChangeFlag`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 已读弹窗
   * @request GET:/customer/update/popUpWindowByType
   */
  "/update/popUpWindowByType": (
    query: {
      type: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/update/popUpWindowByType`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 更新个人信息
   * @request POST:/customer/updateCustomer
   */
  "/updateCustomer": (
    body: UpdateCustomerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/updateCustomer`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新直采用户跳转代采商品是否弹框标识
   * @request POST:/customer/updateCustomer2AgencyGoodsSign
   */
  "/updateCustomer2AgencyGoodsSign": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateCustomer2AgencyGoodsSign`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新直采用户跳转代采是否弹框标识
   * @request POST:/customer/updateCustomer2AgencySign
   */
  "/updateCustomer2AgencySign": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateCustomer2AgencySign`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateCustomerDetail
   * @request GET:/customer/updateCustomerDetail
   */
  "/updateCustomerDetail": (
    query: {
      customerId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateCustomerDetail`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 更新个人谷歌表
   * @request POST:/customer/updateCustomerGoogle
   */
  "/updateCustomerGoogle": (
    body: UpdateCustomerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/updateCustomerGoogle`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新客户设备注册表
   * @request GET:/customer/updateCustomerRegistration
   */
  "/updateCustomerRegistration": (
    query: {
      registrationId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/updateCustomerRegistration`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 删除设备注册表
   * @request GET:/customer/updateCustomerRegistrationEmpty
   */
  "/updateCustomerRegistrationEmpty": (
    query: {
      registrationId: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/updateCustomerRegistrationEmpty`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateExpireAndMembership
   * @request POST:/customer/updateExpireAndMembership
   */
  "/updateExpireAndMembership": (
    body: CustomerMembershipReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateExpireAndMembership`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新客户谷歌表
   * @request POST:/customer/updateGoogle
   */
  "/updateGoogle": (body: CustomerGoogle, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/updateGoogle`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新新手指引
   * @request POST:/customer/updateGuide
   */
  "/updateGuide": (body: CustomerGuide, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/updateGuide`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateManager
   * @request POST:/customer/updateManager
   */
  "/updateManager": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateMarketingManager
   * @request POST:/customer/updateMarketingManager
   */
  "/updateMarketingManager": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateMarketingManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新国际料金表
   * @request POST:/customer/updateMaterialPrice
   */
  "/updateMaterialPrice": (body: MaterialPrice, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseObject, any>({
      path: `/customer/updateMaterialPrice`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户密码和邮箱修改
   * @summary 原密码更新密码
   * @request POST:/customer/updatePassword
   */
  "/updatePassword": (
    body: UpdatePasswordReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/updatePassword`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户登录注册
   * @summary 切换店铺切换时间
   * @request GET:/customer/updateShopChangeTime
   */
  "/updateShopChangeTime": (
    query: {
      shopId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/updateShopChangeTime`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags D2C&&B2B-前台用户
   * @summary 更新修改店铺已弹窗状态
   * @request POST:/customer/updateShopPopup
   */
  "/updateShopPopup": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/updateShopPopup`,
      method: "POST",

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateSupervisionManager
   * @request POST:/customer/updateSupervisionManager
   */
  "/updateSupervisionManager": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateSupervisionManager`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateUnificationCustomerFullName
   * @request POST:/customer/updateUnificationCustomerFullName
   */
  "/updateUnificationCustomerFullName": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateUnificationCustomerFullName`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateWare
   * @request POST:/customer/updateWare
   */
  "/updateWare": (
    body: QueryCustomerByManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateWare`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags customer-feign-api-impl
   * @summary updateWareIsExistOem
   * @request POST:/customer/updateWareIsExistOem
   */
  "/updateWareIsExistOem": (
    body: UpdateWareOemReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/updateWareIsExistOem`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 批量移动用户部门
   * @request POST:/customer/users/batchMoveDepartments
   */
  "/users/batchMoveDepartments": (
    body: MoveUserDepartmentReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/batchMoveDepartments`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 批量删除部门员工接口
   * @request DELETE:/customer/users/deleteByIds
   */
  "/users/deleteByIds": (body: string[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/deleteByIds`,
      method: "DELETE",

      body,
      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 把用户设置为主管
   * @request POST:/customer/users/directorSet
   */
  "/users/directorSet": (
    body: DirectorSetReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/directorSet`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 根据部门id等条件查询用户列表分页
   * @request POST:/customer/users/findUserList
   */
  "/users/findUserList": (
    body: GetUserListReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponsePageManageUserRespDTO, any>({
      path: `/customer/users/findUserList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 获取oem采购员
   * @request GET:/customer/users/getOemPurser
   */
  "/users/getOemPurser": (
    query: {
      userId?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/users/getOemPurser`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 查询用户登录名获取角色id
   * @request GET:/customer/users/getRoleIds
   */
  "/users/getRoleIds": (
    query: {
      userName?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListString, any>({
      path: `/customer/users/getRoleIds`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 通过手机号查询用户
   * @request GET:/customer/users/getUserByMobile
   */
  "/users/getUserByMobile": (
    query: {
      mobile: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserRespDTO, any>({
      path: `/customer/users/getUserByMobile`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 获取角色code获取用户
   * @request GET:/customer/users/getUserByRole
   */
  "/users/getUserByRole": (
    query: {
      roleCode?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/users/getUserByRole`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 通过批量角色code获取用户
   * @request POST:/customer/users/getUserByRoleList
   */
  "/users/getUserByRoleList": (body: string[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/users/getUserByRoleList`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 查询用户名获取用户的角色，资源信息
   * @request GET:/customer/users/getUserInfoByUsername/{username}
   */
  "/users/getUserInfoByUsername/{username}": (
    pathParams: string,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserInfoRespDTO, any>({
      path: `/customer/users/getUserInfoByUsername/${pathParams}`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 主管获取当前部门所有人员的信息
   * @request GET:/customer/users/getUsersByDirector
   */
  "/users/getUsersByDirector": (
    query: {
      userId?: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListManageUserRespDTO, any>({
      path: `/customer/users/getUsersByDirector`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 用户退出
   * @request DELETE:/customer/users/logout
   */
  "/users/logout": (
    query: {
      id: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/logout`,
      method: "DELETE",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 查询当前登陆的用户信息
   * @request GET:/customer/users/me
   */
  "/users/me": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserLoginRespDTO, any>({
      path: `/customer/users/me`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 新增部门用户接口
   * @request POST:/customer/users/save
   */
  "/users/save": (body: AddManageUserReqDTO, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/save`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 批量新增部门用户接口
   * @request POST:/customer/users/saves
   */
  "/users/saves": (body: AddManageUserReqDTO[], params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseMapStringListString, any>({
      path: `/customer/users/saves`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 用户登录
   * @request POST:/customer/users/token
   */
  "/users/token": (
    query: {
      password: string;
      username: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageLoginRespDTO, any>({
      path: `/customer/users/token`,
      method: "POST",
      query,

      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 部门员工详情修改接口
   * @request PUT:/customer/users/update
   */
  "/users/update": (
    body: UpdateManageUserReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/update`,
      method: "PUT",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 后台用户修改密码
   * @request PATCH:/customer/users/updateManagerPassword
   */
  "/users/updateManagerPassword": (
    body: UpdateManagerPasswordReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/updateManagerPassword`,
      method: "PATCH",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 部门员工禁用或者修改密码局部更新接口
   * @request PATCH:/customer/users/updatePasswordEnable
   */
  "/users/updatePasswordEnable": (
    body: UpdatePasswordReqManagerDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/updatePasswordEnable`,
      method: "PATCH",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 上传用户信息
   * @request POST:/customer/users/uploadUser
   */
  "/users/uploadUser": (
    body: {
      file: File;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseMapStringListString, any>({
      path: `/customer/users/uploadUser`,
      method: "POST",

      body,
      type: ContentType.FormData,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 查询用户名获取用户信息
   * @request GET:/customer/users/username/{username}
   */
  "/users/username/{username}": (
    pathParams: string,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserDetailRespDTO, any>({
      path: `/customer/users/username/${pathParams}`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 验证手机号是否重复
   * @request GET:/customer/users/verificationMobileRepeat
   */
  "/users/verificationMobileRepeat": (
    query: {
      mobile: string;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponse, any>({
      path: `/customer/users/verificationMobileRepeat`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 用户接口
   * @summary 查询用户详情
   * @request GET:/customer/users/{id}
   */
  "/users/{id}": (pathParams: string, params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseManageUserDetailRespDTO, any>({
      path: `/customer/users/${pathParams}`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 火山直播控制层
   * @summary 获取直播间列表
   * @request GET:/customer/video/getActivities
   */
  "/video/getActivities": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseGetActivitiesRespDTO, any>({
      path: `/customer/video/getActivities`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 火山直播控制层
   * @summary 获取直播间详情
   * @request GET:/customer/video/getActivityById
   */
  "/video/getActivityById": (
    query: {
      activityId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVideoActivityDTO, any>({
      path: `/customer/video/getActivityById`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 火山直播控制层
   * @summary 获取token
   * @request GET:/customer/video/getToken
   */
  "/video/getToken": (
    query: {
      activityId: number;
      mode: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseString, any>({
      path: `/customer/video/getToken`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 火山直播控制层
   * @summary 直播预约
   * @request GET:/customer/video/reserve
   */
  "/video/reserve": (
    query: {
      activityId: number;
    },
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/video/reserve`,
      method: "GET",
      query,

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 火山直播控制层
   * @summary 直播预约回调
   * @request POST:/customer/video/reserveCallBack
   */
  "/video/reserveCallBack": (
    body: ReserveCallBackReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseBoolean, any>({
      path: `/customer/video/reserveCallBack`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 工作台banner
   * @summary 后台获取工作台banner
   * @request POST:/customer/workbenchBanner/backendGet
   */
  "/workbenchBanner/backendGet": (
    body: QueryWorkbenchBannerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListWorkbenchBannerRespDTO, any>({
      path: `/customer/workbenchBanner/backendGet`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 工作台banner
   * @summary 客户端获取工作台banner
   * @request GET:/customer/workbenchBanner/get
   */
  "/workbenchBanner/get": (params: RequestParams = {}) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseListWorkbenchBannerRespDTO, any>({
      path: `/customer/workbenchBanner/get`,
      method: "GET",

      type: ContentType.Text,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 工作台banner
   * @summary 保存工作台banner
   * @request POST:/customer/workbenchBanner/save
   */
  "/workbenchBanner/save": (
    body: SaveWorkbenchBannerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/workbenchBanner/save`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
  /**
   *
   * @tags 工作台banner
   * @summary 更新工作台banner
   * @request POST:/customer/workbenchBanner/update
   */
  "/workbenchBanner/update": (
    body: SaveWorkbenchBannerReqDTO,
    params: RequestParams = {},
  ) => {
    const request = getRequest();
    handleRequest(params);
    return request<BizResponseVoid, any>({
      path: `/customer/workbenchBanner/update`,
      method: "POST",

      body,
      type: ContentType.Json,
      ...params,
    }).then(handleResponse);
  },
};

export type CUSTOMER = typeof customer;

/** 解析错误的接口 */
const msg = [];
